export const News = [
  {
    Key: 2214,
    feature:
      "https://asset.salaamlifetakaful.com/SavingAssets/news/takafuleasy2.jpeg",
    heading:
      "Salaam Takaful Limited formalized its partnership with TakafulEasy through an MoU signing ceremony",
    content:
      "A proud achievement for Salaam Takaful Limited as we formalized our partnership with TakafulEasy through an MoU signing ceremony. This collaboration marks an important step toward expanding access to Shariah-compliant Takaful solutions across Pakistan, with a shared commitment to ethical, transparent, and customer-first protection for individuals and businesses. Together, we look forward to strengthening our partnership, driving innovation, and delivering solutions that reflect our shared vision of excellence.",
    Date: "",
    archead:
      "Salaam Takaful Limited formalized its partnership with TakafulEasy through an MoU signing ceremony",
  },
  {
    Key: 2215,
    feature:
      "https://asset.salaamlifetakaful.com/SavingAssets/news/AbhiPvtLtd.png",
    heading:
      " Salaam Takaful Limited and Abhi (Pvt.) Ltd. Commenced a Strategic Partnership",
    content:
      "Salaam Takaful Limited and Abhi (Pvt.) Ltd. have signed an MoU to advance financial inclusion through Shariah-compliant takaful and fintech solutions. This collaboration aims to enhance accessibility to ethical financial services, ensuring seamless and secure transactions while empowering individuals and businesses through innovative fintech solutions.",
    Date: "",
    archead: "",
  },
  {
    Key: 2214,
    heading:
      "Salaam Takaful Limited and Karakoram Area Development Organization (KADO) commenced a strategic collaboration",
    content:
      "Salaam Takaful Limited has partnered with the Karakoram Area Development Organization (KADO) to support sustainable development in Chitral and its adjoining areas. This collaboration introduces Pakistan's first weather index-based climate risk coverage for mountain agriculture through Salaam Takaful’s Parametric-based Crop Takaful product, a pioneering solution to address the impact of climate change on farmers.",
    content1:
      "By leveraging weather data triggers for automated payouts, this will ensure timely financial support for farmers affected by adverse weather conditions. The initiative reflects a shared commitment to empowering marginalized communities through innovation and resilience-building efforts.",
    content2:
      "#ClimateResilience #SustainableFarming #Innovation #SalaamTakaful",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/KarakoramAreaDevelopmentOrganization.jpg",
    date: "",
    archead:
      "Salaam Takaful Limited and Karakoram Area Development Organization (KADO) commenced a strategic collaboration",
  },
  {
    Key: 2213,
    heading:
      "Salaam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
    content:
      "Salaam Takaful Limited, under its partnership with the Institute of Business Administration (IBA), Karachi, and in line with its ESG-driven philosophy, continues the distribution of Qarz-e-Hasna (a financing facility for students of various programs). The cheque was received by Mr. Saifullah Soomro.",
    content1:
      "These measures emphasize the need for human capital development and enable students to be resilient against financial constraints in the pursuance of their higher education.",
    content2:
      "Salaam Takaful Limited, under its partnership with the Institute of Business Administration (IBA), Karachi, and in line with its ESG-driven philosophy, continues the distribution of Qarz-e-Hasna (a financing facility for students of various programs). Mr. Saifullah Soomro received the cheque.",
    content3:
      "#SalaamTakafulLimited #Qarzehasna #islamicinsurance #takaful #ESG #IBA",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/ContinuesQarzHasnaIBA.jpg",
    date: "",
    archead:
      "Salaam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
  },
  {
    Key: 2212,
    heading:
      "Salaam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
    content:
      "Salaam Takaful Limited, under its partnership with Sir Syed University of Engineering and Technology (SSUET), Karachi, and in line with its ESG-driven philosophy, continues the distribution of Qarz-e-Hasna (a financing facility for students of various programs). The cheque was received by Ms. Haiqa Shaukat Mir.",
    content1:
      "These measures emphasize the need for human capital development and enable students to be resilient against financial constraints in the pursuance of their higher education.",
    content2:
      "With this initiative, and many more of its kind, Salaam Takaful hopes to empower individuals by ensuring inclusive and equitable quality education and promoting lifelong learning opportunities for all.",
    content3:
      "#SalaamTakafulLimited #Qarzehasna #islamicinsurance #takaful #ESG #SSUET",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/ContinuesQarzHasnaSSUET.jpg",
    date: "",
    archead:
      "Salaam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
  },
  {
    Key: 2211,
    heading:
      "Salaam Takaful’s products will now be available on Takaful Bazaar’s Digital Platform",
    content:
      "Salaam Takaful Limited has signed a Memorandum of Understanding (MoU) with Takaful Bazaar to make its products accessible through Takaful Bazaar’s digital platforms on December 4 , 2024. This partnership enables customers to explore and acquire Salaam Takaful’s Shariah-compliant solutions online. By integrating its offerings with Takaful Bazaar’s digital presence, Salaam Takaful aims to enhance convenience and accessibility for customers while promoting the adoption of digital channels in the Takaful industry.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2211.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful’s products will now be available on Takaful Bazaar’s Digital Platform",
    excerpt:
      "Salaam Takaful Limited has signed a Memorandum of Understanding (MoU) with Takaful Bazaar to make its products…",
  },
  {
    Key: 2210,
    heading:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as a panelist at the 8th International Conference on Islamic Banking and Finance",
    content:
      'Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, was invited as a panelist at the 8th International Conference on Islamic Banking and Finance, organized by the Institute of Business Management on November 12, 2024. He contributed valuable insights to the discussion on "The potential of Islamic finance to drive social impact through responsible investment practices."',
    content1:
      "During the session, Mr. Nayyar emphasized the value proposition of Islamic finance, citing customer-centric products like Salaam Family Takaful’s savings solutions as examples of how the industry can address societal needs more meaningfully. He advocated for traditional Islamic finance to evolve and focus on tangible social impact by offering products that not only align with Islamic principles but also provide accessible, practical solutions to modern financial challenges. This shift, he noted, would strengthen public trust and position Islamic finance as a transformative force in the global financial landscape.",
    content2:
      "Mr. Nayyar’s nuanced approach sparked an engaging conversation about the role of Islamic finance in promoting responsible investment, highlighting its potential to drive meaningful social impact while adhering to ethical standards.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2199.jpg",
    date: "02-08-2024",
    archead:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as a panelist at the 8th International Conference on Islamic Banking and Finance",
    excerpt:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, was invited as a panelist at the…",
  },
  {
    Key: 2209,
    heading:
      "Salaam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
    content:
      "Salaam Takaful Limited, under its partnership with the Bahria University, Karachi, and in line with its ESG-driven philosophy, continues the distribution of Qarz-e-Hasna (a financing facility for students of various programs). The cheque was received by Mr. Shahroz Bhamani (Assistant Director, Bahria University, Karachi) on behalf of the beneficiaries of this program.",
    content1:
      "These measures emphasize the need for human capital development and enable students to be resilient against financial constraints in the pursuance of their higher education.",
    content2:
      "With this initiative, and many more of its kind, Salaam Takaful hopes to empower individuals by ensuring inclusive and equitable quality education and promoting lifelong learning opportunities for all.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/220011.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
    excerpt:
      "Salaam Takaful Limited, under its partnership with the Bahria University, Karachi, and in line with its ESG-driven philosophy…",
  },
  {
    Key: 2208,
    heading:
      "Salaam Takaful Limited at the Singapore International Reinsurance Conference 2024",
    content:
      "Salaam Takaful Limited, Pakistan’s largest General Takaful operator, recently participated in the Singapore International Reinsurance Conference 2024, joining global industry leaders to explore new opportunities and advancements in insurance and reinsurance.",
    content1:
      "The conference allowed Salaam Takaful to connect with international peers, engage in discussions on emerging trends and challenges, and gain fresh insights into the future of Takaful and Islamic insurance. With a commitment to innovation and ethical practices, Salaam Takaful is excited to bring these learnings back to enhance its mission of delivering policyholder-centric, Shariah-compliant solutions to communities across Pakistan.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2201.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited at the Singapore International Reinsurance Conference 2024",
    excerpt:
      "Salaam Takaful Limited, Pakistan’s largest General Takaful operator, recently participated in the Singapore International Reinsurance Conference 2024…",
  },
  {
    Key: 2207,
    heading:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as a panelist at the Pakistan Insurtech Summit II organized by the Pakistan Fintech Network",
    content:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, participated as a panelist at the Pakistan Insurtech Summit II, organized by the Pakistan Fintech Network on 11th November 2024. He shared his vision of an “enabling environment” for Pakistan’s insurance sector in response to a key question on fostering growth and innovation. Mr. Nayyar Hussain emphasized the role of a supportive regulatory framework, increased public awareness, and a cultural shift to recognize insurance as a cornerstone of financial resilience. He highlighted the importance of regulatory sandboxes and their cohorts as essential tools for testing innovative solutions in a controlled environment. Through closer collaboration between regulators and industry leaders, policies can be streamlined, digital transformation accelerated, and access to insurance broadened, paving the way for a robust and inclusive insurance ecosystem tailored to Pakistan’s needs.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2202.jpeg",
    date: "02-08-2024",
    archead:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as a panelist at the Pakistan Insurtech Summit II organized by the Pakistan Fintech Network",
    excerpt:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, participated as a panelist at the Pakistan…",
  },
  {
    Key: 2206,
    heading:
      "Salaam Takaful Limited wins 3rd position in the Best Corporate and Sustainability Report awards 2023 in the insurance category by CA and ICMA Pakistan",
    content:
      "Alhamdulillah, another achievement! We are thrilled to announce that Salaam Takaful Limited has been awarded 3rd position in the Best Corporate and Sustainability Report Awards 2023 in the Insurance category organized by ICAP & ICMA Pakistan. This recognition reflects our dedication to excellence in corporate reporting, transparency, and sustainability practices.",
    content1:
      "For six consecutive years, we have remained in the top award recipients due to our commitment to enhancing the standard of our reporting, ensuring impeccable compliance, and demonstrating financial strength. Our journey continues with the same drive to earn and maintain the trust of our stakeholders locally and globally, all while upholding Shariah principles and ethical governance.",
    content2:
      "A big congratulations to the entire team who made this possible—here’s to many more achievements to come, Insha’Allah!",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2203.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited wins 3rd position in the Best Corporate and Sustainability Report awards 2023 in the insurance category by CA and ICMA Pakistan",
    excerpt:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, participated as a panelist at the Pakistan…",
  },
  {
    Key: 2205,
    heading:
      "Salaam Takaful and Al Baraka Bank (Pakistan) commenced a strategic collaboration",
    content:
      "Salaam Takaful and Al Baraka Bank (Pakistan) commenced a strategic collaboration to provide Takaful protection for digital transactions and enhance customers' digital banking experience. This collaboration reaffirms the company's dedication to innovate and deliver unmatched service & security to its partners.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2204.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful and Al Baraka Bank (Pakistan) commenced a strategic collaboration",
    excerpt:
      "Salaam Takaful and Al Baraka Bank (Pakistan) commenced a strategic collaboration to provide Takaful protection for digital transactions and enhance customers' digital banking experience…",
  },
  {
    Key: 2204,
    heading:
      "Syed Nayyar Hussain elected as a member of the IAP Executive Committee",
    content:
      "Salaam Takaful Limited congratulates Syed Nayyar Hussain, Executive Director of Strategy and New Initiatives, on being elected as a prestigious member of the Executive Committee of The Insurance Association of Pakistan (IAP) for the tenure 2024-26.",
    content1:
      "In this role, he will play a vital part in supporting the common interests of the insurance and Takaful industry of Pakistan. Salaam Takaful wishes him continued success as he helps drive innovation and progress within the sector.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2205.jpg",
    date: "02-08-2024",
    archead:
      "Syed Nayyar Hussain elected as a member of the IAP Executive Committee",
    excerpt:
      "Salaam Takaful Limited congratulates Syed Nayyar Hussain, Executive Director of Strategy and New Initiatives…",
  },
  {
    Key: 2203,
    heading:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as a panelist at the Stakeholder Consultation Workshop",
    content:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, participated in the Stakeholder Consultation Workshop, as a Panelist. The Workshop embarked on an enlightening journey to explore a diverse range of topics in the digitalization of the Pakistan Insurance Sector, and to emphasize on how digital transformation can enhance the Takaful/insurance sector in Pakistan by fostering inclusivity, accessibility, and resilience.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2206.jpg",
    date: "02-08-2024",
    archead:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as a panelist at the Stakeholder Consultation Workshop",
    excerpt:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, participated in the Stakeholder Consultation Workshop…",
  },
  {
    Key: 2202,
    heading:
      "Salaam Takaful Limited and BADRI Management Consultancy commenced a strategic partnership",
    content:
      "Salaam Takaful Limited is pleased to announce its partnership with BADRI Management Consultancy for the implementation of IFRS 17. As an industry leader in innovation, Salaam Takaful continues to prioritize operational efficiency and compliance with global standards. With BADRI Management Consultancy’s expertise and the ACE 17 accounting engine tailored for general takaful, this collaboration is set to further strengthen their financial processes and reinforce their position in the takaful/insurance sector.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2207.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited and BADRI Management Consultancy commenced a strategic partnership",
    excerpt:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, participated in the Stakeholder Consultation Workshop…",
  },
  {
    Key: 2201,
    heading:
      "Salaam Takaful Limited proudly signs an MoU with Deaf Reach School",
    content:
      "Salaam Takaful Limited proudly signs an MoU with Deaf Reach School, reinforcing our commitment to fostering inclusivity and empowering individuals with disabilities by creating meaningful employment opportunities for the deaf community. This collaboration focuses on raising awareness and sensitizing its growth partners towards these individuals. By promoting diversity in the workplace, Salaam Takaful aims to unlock potential and ensure equal opportunities for all, driving positive social change.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2208.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited proudly signs an MoU with Deaf Reach School",
    excerpt:
      "Salaam Takaful Limited proudly signs an MoU with Deaf Reach School, reinforcing our commitment to fostering inclusivity and empowering individuals…",
  },
  {
    Key: 2200,
    heading:
      "Salaam Takaful Limited has emerged as the IPL Cricket Tournament 2024 champion!",
    content:
      "Salaam Takaful Limited has emerged as the IPL Cricket Tournament 2024 champion! Under the exceptional leadership of Mr. Kamran M. Hanif, the team showcased unmatched skills and determination, leading to a resounding victory.",
    content1:
      "To celebrate this remarkable achievement, Salaam Takaful Limited held a special ceremony to honor the entire squad, recognizing their dedication and hard work.",
    content2:
      "Salaam Takaful Limited believes in fostering a culture that goes beyond the workplace and understands the importance of well-being and the power of extracurricular activities in keeping the team healthy, motivated, and energized. The company is committed to nurturing a balanced and dynamic environment where the growth partners can thrive, both professionally and personally.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2209.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited has emerged as the IPL Cricket Tournament 2024 champion!",
    excerpt:
      "Salaam Takaful Limited has emerged as the IPL Cricket Tournament 2024 champion! Under the exceptional leadership of Mr. Kamran M. Hanif, the team showcased unmatched skills and determination, leading to a resounding victory.…",
  },
  {
    Key: 2199,
    heading:
      "Salaam Takaful Limited and Pakistan Insurance Institute (PII) commenced a strategic partnership",
    content:
      "Salaam Takaful Limited and the Pakistan Insurance Institute (PII) have signed an MoU for the delivery of agent foundation course for Salaam Takaful employees as well as building and delivering Takaful and Retakaful trainings.",
    content1:
      "The MoU, signed by Mr. Rizwan Hussain, MD & CEO Salaam Takaful Limited, and Mr. Khalid Hamid, CEO of National Insurance Company Limited and Chairman of the Pakistan Insurance Institute, marks a significant step towards delivering Shariah-compliant training programs in General Takaful, Family Takaful, and Re-Takaful. This collaboration is set to drive innovation in the takaful sector through combined expertise and resources.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2210.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited and Pakistan Insurance Institute (PII) commenced a strategic partnership",
    excerpt:
      "Salaam Takaful Limited and the Pakistan Insurance Institute (PII) have signed an MoU for the delivery of agent foundation course …",
  },
  {
    Key: 2198,
    heading:
      "Salaam Takaful Limited and Al Ghazali University commenced a strategic partnership",
    content:
      "Salaam Takaful Limited has signed an MoU with Al Ghazali University, marking the start of a strategic partnership. This collaboration will facilitate students through various initiatives, including Qarz-e-Hasna (interest-free loans), the Spark program for innovation, an Ambassador program for leadership, Internship &amp; Apprenticeship opportunities, the Faculty Ignite program, and university competitions. Additionally, Salaam Takaful will provide corporate exposure opportunities to Aalim graduates from Al Ghazali University, promoting social inclusion and help them becoming a part of the mainstream corporate world. In line with its ESG-driven philosophy, Salaam Takaful is committed to breaking financial barriers to education and fostering talent. This partnership underscores Salaam Takaful&rsquo;s dedication to inclusive and equitable education, paving the way for a brighter, more accessible future for all.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2198.jpg",
    date: "02-08-2024",
    archead:
      "Salaam Takaful Limited and Al Ghazali University commenced a strategic partnership",
    excerpt:
      "Salaam Takaful Limited has signed an MoU with Al Ghazali University, marking the start of a strategic partnership…..",
  },
  // {
  //     Key: 2197,
  //     heading: "Salaam Takaful Limited and EU Funded GRASP Celebrate Landmark Issuance of Islamic insurance policies for Agricultural Advancement in Sindh and Balochistan",
  //     content: "Salaam Takaful Limited is thrilled to highlight the recent success at the EU funded GRASP (Growth for Rural Advancement and Sustainable Progress) Islamic insurance policies issuance ceremony. This landmark event represents a significant advancement in supporting SMEs within Sindh and Balochistan horticulture and livestock sectors. In collaboration with EU funded GRASP, Salaam Takaful has distributed takaful policies covering numerous acres, with a substantial total value. This initiative is crucial for mitigating agricultural risks and enhancing financial stability in these vital regions. Mr. Wajahat Khwaja, Executive Director and Head of Strategic Initiatives at Salaam Takaful Limited, emphasized the importance of these tailored insurance solutions. He noted that the policies are designed to support agriculture comprehensively and can be implemented on a national level, providing remote accessibility and inclusivity for farmers across Pakistan. The event was honored by the presence of Rana Mashhood Ahmad Khan, Chairman of the Prime Minister's Youth Program, who underscored the importance of integrating technology into farming practices. His objective is to guide young farmers toward tech-driven agricultural solutions, fostering innovation and sustainability in the sector. Representatives from the Ministry of National Food Security &amp; Research also attended, highlighting the government's commitment to sustainable agricultural growth and resilience against climate-related challenges. This milestone underscores a nationwide commitment to fostering agricultural development and building resilience across Pakistan. Read the complete story here: https://www.brecorder.com/news/40314800",
  //     feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2197.jpg",
  //     date: "30-07-2024",
  //     archead: "Salaam Takaful Limited and EU Funded GRASP Celebrate Landmark Issuance of Islamic insurance policies for Agricultural Advancement in Sindh and Balochistan",
  //     excerpt: "Salaam Takaful Limited is thrilled to highlight the recent success at the EU funded…."
  //   },
  {
    Key: 2196,
    heading:
      "Salaam Takaful Limited Reaching New Heights - PKR 2.5 Billion Milestone Achieved in the First Half of 2024",
    content:
      "Salaam Takaful Limited proudly announces the achievement of PKR 2.5 billion in Gross Written Contribution as of June 2024. This remarkable milestone reflects its steadfast commitment to providing ethical, reliable, and innovative Islamic insurance solutions.\nLooking ahead, Salaam Takaful remains dedicated to delivering unparalleled service and pioneering innovative initiatives for a secure and Shariah-compliant future.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2196.jpg",
    date: "24-07-2024",
    archead:
      "Salaam Takaful Limited Reaching New Heights - PKR 2.5 Billion Milestone Achieved in the First Half of 2024",
    excerpt:
      "Salaam Takaful Limited proudly announces the achievement of PKR 2.5 billion….",
  },
  {
    Key: 2191,
    heading:
      "Salaam Takaful Limited is the proud winner of Challengers Corporate Cup ",
    content:
      "Salaam Takaful Limited won the prestigious The Challengers Corporate Cup Cricket championship title.\nThis feat was achieved under the captaincy of Mr. Kamran M. Hanif who led the team comprehensively to lift the cup.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2191.jpg",
    date: "22-07-2024",
    archead:
      "Salaam Takaful Limited is the proud winner of Challengers Corporate Cup ",
    excerpt:
      "Salaam Takaful Limited won the prestigious The Challengers Corporate Cup….",
  },
  {
    Key: 2192,
    heading:
      "Salaam Takaful Limited extends support to Karachi Down Syndrome Program (KDSP)",
    content:
      "Salaam Takaful Limited commits to extend support to Karachi Down Syndrome Program (KDSP), reflecting Salaam Takaful's commitment to ESG-driven values. Through this collaboration, Salaam Takaful aims to create job opportunities for individuals with Down syndrome, highlighting their unique abilities and contributions.\nMoreover, Salaam Takaful will engage in craft activities, spend time with individuals at their premises, and invite them to Salaam Takaful to increase awareness and acceptance. This will help these children align their values and contribute to society, making them financially independent and more confident. This initiative emphasizes understanding, acceptance, and the importance of fostering an inclusive and compassionate society.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2192.jpg",
    date: "22-07-2024",
    archead:
      "Salaam Takaful Limited extends support to Karachi Down Syndrome Program (KDSP)",
    excerpt:
      "Salaam Takaful Limited commits to extend support to Karachi Down Syndrome Program… ",
  },
  {
    Key: 2193,
    heading:
      "Salaam Takaful Limited becomes a part of Auto Insurance Repository",
    content:
      "Salaam Takaful Limited becomes the first takaful operator to be a part of the Auto Insurance Repository initiative of the Central Depository Company of Pakistan Limited. Mr. Nayyar Hussain and Mr. Wajahat Khwaja represented Salaam Takaful Limited at the signing ceremony of the Memorandum of Understanding (MoU). The Auto Insurance Repository is a significant step forward in the auto insurance and takaful industry, aiming to improve underwriting, reduce risk, and streamline access to essential information, thereby enabling insurers to make informed decisions before binding customers and issuing policies. It will also bring transparency, speed, and convenience to the industry, aligning with the objectives of Ease of Doing Business (EODB) and enhanced consumer protection.\nThese steps underscore the importance of innovation and partnership in the industry. By working together, we aim to create a comprehensive and efficient repository system that will streamline auto insurance processes and provide greater ease and accessibility for our valued customers.\nWe are excited about the opportunities this collaboration will bring and look forward to contributing to the development of a robust Auto Insurance Repository.",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2193.jpg",
    date: "22-07-2024",
    archead:
      "Salaam Takaful Limited becomes a part of Auto Insurance Repository",
    excerpt:
      "Salaam Takaful Limited becomes the first takaful operator to be a part of the Auto….",
  },
  {
    Key: 2190,
    heading:
      "Saalam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
    content:
      "Salaam Takaful Limited, under its partnership with the Institute of Business Administration (IBA), Karachi, and in line with its ESG-driven philosophy, continues the distribution of Qarz-e-Hasna (a financing facility for students of various programs in IBA). Most recently, Mr. Abdul Qudoos Jagirani from Institute of Business Administration (IBA), became the beneficiary of this programme.\n\nThese measures emphasize the need for human capital development and enable students to be resilient against financial constraints in the pursuance of their higher education.\n\nWith this initiative, and many more of its kind, Salaam Takaful hopes to empower individuals by ensuring inclusive and equitable quality education and promoting lifelong learning opportunities for all.\n\n#SalaamTakafulLimited #Qarzehasna #islamicinsurance #takaful #ESG",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2190.jpg",
    date: "03-07-2024",
    archead:
      "Saalam Takaful Limited continues the distribution of Qarz-e-Hasna among the students",
    excerpt:
      "Salaam Takaful Limited, under its partnership with the Institute of Business Administration (IBA)…..",
  },
  {
    Key: 2189,
    heading:
      "Salaam Takaful Wins Best Mobile App at The Prestigious Pakistan Digital Awards",
    content:
      "Salaam Takaful Limited clinched the title of the Best Mobile App at the prestigious Pakistan Digital Awards. This accolade is a testament to our team's dedication and hard work. Our commitment to digitization and delivering unparalleled value to policyholders drives us to develop unique, innovative, and unorthodox solutions. Leveraging cutting-edge technology, we continually strive to enhance the user experience and set new industry standards. This achievement underscores our mission to revolutionize the Insurance and Takaful landscape with groundbreaking digital advancements.\n\nClick here to download our award-winning Salaam App: https://bit.ly/3U4iuAF",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2189.jpg",
    date: "12-06-2024",
    archead:
      "Salaam Takaful Wins Best Mobile App at The Prestigious Pakistan Digital Awards",
    excerpt: "",
  },
  //   {
  //     Key: 2188,
  //     heading: "CDC and Salaam Family Takaful sign an agreement to enhance transparency and efficiency in the insurance industry through centralized information sharing and repository systems",
  //     content: "Central Depository Company of Pakistan Limited and Salaam Family Takaful Limited have signed an agreement for the latter’s participation in the Centralized Insurance Repository and Information Sharing Solution (CISSII). This collaboration represents a major advancement in Pakistan's insurance and takaful sector, focusing on enhancing transparency, efficiency, and digitalization. Newly licensed by SECP, Salaam Family Takaful Limited is the first ever digital-only Islamic life insurance provider, committed to supporting the growth and development of the insurance industry. By joining forces with the Central Depository Company of Pakistan Limited (CDC), Salaam Family Takaful Limited aims to leverage CDC’s state-of-the-art technological platform and extensive experience in similar projects.\n\nThe Centralized Information Sharing Solution for the Insurance Industry (CISSII) and Centralized Insurance Repository (CIR), developed and administered by CDC, are key cross-industry systems that facilitate the sharing of critical policy-related information among stakeholders. Launched in 2014 and 2020 respectively, these initiatives have laid the foundations for formal information-sharing mechanisms and have harmonized the industry’s data-sharing practices.",
  //     feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2188.jpg",
  //     date: "12-06-2024",
  //     archead: "CDC and Salaam Family Takaful sign an agreement to enhance transparency and efficiency in the insurance industry through centralized information sharing and repository systems",
  //     excerpt: "Central Depository Company of Pakistan Limited and Salaam Family Takaful"
  //   },
  {
    Key: 2187,
    heading:
      "Salaam Family Takaful Limited receives license from SECP to operate as the First Ever Digital Islamic Life Insurance Company",
    content:
      "Salaam Family Takaful Limited has officially arrived. In a recent ceremony at SECP’s headquarters in Islamabad, Mr. Akif Saeed, Chairman of SECP, handed over the coveted license of the first ever Digital-Only Islamic Life Insurance Operator to Mr. Rizwan Hussain, the MD and CEO of the newly formed Salaam Family Takaful Limited. The new entity’s Shariah board was also present to witness this momentous event, which was well covered across the country’s leading media publications.\n\nSalaam Family Takaful is set to redefine the industry with a cutting-edge end-to-end digital experience. Our new brand will be launched very soon, epitomizing customer centricity and innovation, poised to revolutionize the market with unparalleled policyholder benefits and real-time information access. This groundbreaking venture sets new benchmarks in the global Islamic Life Insurance segment.\n\nStay tuned for the unveiling of more groundbreaking and disruptive products that promise to transform the landscape of Islamic Life Insurance forever.\n\nA few glimpses of the coverage are as follows:\n\nYouTube video\nAPP.com.pk article\nThe Business Recorder article\nDawn article\nArab News article\nExpress article\nProPakistani article",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2187.jpg",
    date: "11-06-2024",
    archead:
      "Salaam Family Takaful Limited receives license from SECP to operate as the First Ever Digital Islamic Life Insurance Company",
    excerpt:
      "Salaam Family Takaful Limited has officially arrived. In a recent ceremony at SECP’s ….",
  },
  {
    Key: 2186,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2186.jpg",
    heading:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as an IBA SBS 3rd International Conference 2024",
    archead:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as an IBA SBS 3rd International …",
    content:
      "Mr. Nayyar Hussain, Head of Strategy & New Initiatives at Salaam Takaful Limited, recently shared invaluable insights at the IBA SBS 3rd International Conference 2024 as a panelist. Hosted by the Institute of Business Administration, Mr. Nayyar participated in a panel discussion focused on 'Innovation & Disruption: Business Success Through AI'. During the panel, Mr. Nayyar discussed Pakistan's insurance industry's adoption of digital technologies, including regulatory sandbox, digital-only insurance framework, augmented underwriting based on predictive models, and automated insurance approvals, highlighting their role in enhancing customer satisfaction and improving adoption. His insights underscored Salaam Takaful's commitment to leading in technology and customer-centric solutions. #SalaamTakafulLimited #islamicinsurance #IBASBS #AI #Innovation #Disruption #Takaful #networking #successstories #ESG",
    excerpt:
      "Mr. Nayyar Hussain, Head of Strategy &amp; New Initiatives at Salaam Takaful Limited, recently shared invaluable insights at the IBA SBS 3rd International Conference 2024 as a panelist. Hosted by the Institute of Business Administration, Mr. Nayyar participated in a panel discussion focused on 'Innovation &amp; Disruption: Business Success Through...",
    date: "06-06-2024",
  },
  {
    Key: 2185,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/21851.jpg",
    heading:
      "Salaam Takaful Limited recently signed an MoU with Pakistan Poverty Alleviation Fund (PPAF) to commence a strategic partnership",
    archead:
      "Salaam Takaful Limited recently signed an MoU with Pakistan Poverty Alleviation Fund …",
    content:
      "Salaam Takaful Limited has signed a Memorandum of Understanding (MOU) with the Pakistan Poverty Alleviation Fund (PPAF). This strategic partnership aims to enhance farmers’ resilience against climate change across Pakistan through Parametric-based Crop Takaful solutions, marking a significant step forward in the mission to provide innovative and accessible takaful solutions. During the proceedings, members of PPAF and representatives from PPAF partner organizations were briefed about the Parametric Crop Takaful Product, which was well received and commended as a brilliant remedy for unique challenges faced by the agricultural sector. To ensure a thorough understanding and effective promotion of the solutions, PPAF arranged training sessions in Karachi and Quetta, which were quite beneficial for all participants, where they were acquainted with the necessary knowledge for on-ground implementation. With a presence in 147 districts through partnerships with 130 organizations, PPAF has been at the forefront of strategic development from the grassroots level. Their focus on prioritizing communities in dire conditions aligns perfectly with the vision of Salaam Takaful Limited to ensure a secure and prosperous future for all.",
    excerpt:
      "Salaam Takaful Limited has signed a Memorandum of Understanding (MOU) with the K-R Pakistan Poverty Alleviation Fund. This strategic partnership aims to enhance farmers&rsquo; resilience against climate change across Pakistan through Parametric-….",
    date: "30-05-2024",
  },
  {
    Key: 2184,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2184.jpg",
    heading:
      "Mr. Wajahat Khawaja represented Salaam Takaful Limited as a Panelist at the International Conference on Business & Management 2024 held at Mohammad Ali Jinnah University (MAJU), Karachi.",
    archead:
      "Mr. Wajahat Khawaja represented Salaam Takaful Limited as a Panelist at the International …",
    content:
      "As a panelist at the International Conference on Business & Management 2024 held at Mohammad Ali Jinnah University (MAJU), Karachi, Mr. Wajahat Khawaja, Executive Director - Strategic Initiatives at Salaam Takaful Limited, highlighted the transformative potential of fintech in the insurance and takaful industry of Pakistan. He emphasized how Salaam Takaful leverages digitization to enhance accessibility, efficiency, and personalization of takaful products and services, setting a benchmark for the industry. This part of the conference highlighted the vital role of technological integration in advancing Islamic finance and ensuring its competitive edge in the global market.",
    excerpt:
      "As a panelist at the International Conference on Business &amp; Management 2024 held at Mohammad Ali Jinnah University (MAJU), Karachi, Mr. Wajahat Khawaja, Executive Director - Strategic Initiatives at Salaam Takaful Limited, highlighted the transformative potential of fintech in the insurance...",
    date: "30-05-2024",
  },
  {
    Key: 2181,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2181.jpg",
    heading:
      "Salaam Takaful Limited recently participated in design thinking workshop for licensing  and regulatory approvals processes organized by SECP under the project LEAP",
    archead:
      "Salaam Takaful Limited recently participated in design thinking workshop for licensing …",
    content:
      "Salaam Takaful Limited is honored to participate in the ambitious journey of the SECP towards digital transformation under the Leading Efficiency through Automation Prowess (LEAP) project. Salaam Takaful&rsquo;s active participation in the recent &lsquo;Design Thinking Workshop for Licensing and Regulatory Approvals Processes&rsquo; highlights its dedication to supporting this innovative initiative. Through these types of collaborations, Salaam Takaful aims to contribute to SECP's vision of a Digital Pakistan.",
    excerpt:
      "Salaam Takaful Limited is honored to participate in the ambitious journey of the SECP towards digital transformation under the Leading Efficiency through Automation Prowess (LEAP) project. Salaam Takaful….",
    date: "20-05-2024",
  },
  {
    Key: 2180,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2180.jpg",
    heading:
      'Catch the exclusive speaking session of Mr. Wajahat Khawaja in the "Challenges & opportunities for climate Risk Takaful" organized by the World Bank',
    archead:
      'Catch the exclusive speaking session of Mr. Wajahat Khawaja in the "Challenges…',
    content:
      'The World Bank is organizing an exclusive webinar titled "The Challenges and Opportunities for Climate Risk Takaful". Mr. Wajahat Khawaja, Executive Director - Head of Strategic Initiatives, Salaam Takaful Limited, has been invited to speak at this esteemed event.',
    linkOne: "Please register now using this link",
    linkNew:
      "https://worldbankgroup.zoom.us/webinar/register/WN_556HvB9nRCyiBidPrhsPhw?fbclid=IwZXh0bgNhZW0CMTAAAR0HuS3yi5X2xtEY2aMcYuFdXpbRC8mq-aFVyli5lxA7sWMOFwWmYBHk5fE_aem_Acfn0_M04jkpobDt7JZtZ6wZilqVkfcEkDRSx2KeZNQfBLtNU34FWGOE0uok-Ez_uC-y_-C1QToFlMW34yHC5_5-#/registration",
    excerpt:
      "The World Bank is organizing an exclusive webinar titled. The Challenges and Opportunities for Climate Risk Takaful&rsquo;. Mr. Wajahat Khawaja, Executive Director - Head of Strategic Initiatives, Salaam Takaful Limited, has been invited to speak at this esteemed event. Please register now using the...",
    date: "15-05-2024",
  },
  {
    Key: 2178,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2178.jpg",
    heading:
      "Salaam Takaful Limited and Creek General Hospital commenced a strategic partnership",
    archead:
      "Salaam Takaful Limited and Creek General Hospital commenced a strategic partnership",
    content:
      'Salaam Takaful Limited and Creek General Hospital, Karachi signed an MoU to commence a strategic partnership. Under this agreement, the hospital&rsquo;s Outpatient Department (OPD) services will be offered free, exclusively to the Health Takaful policyholders of Salaam Takaful. Furthermore, they will also be able to get an exclusive 30% discount on baseline tests and radiology services, easing financial burdens associated with essential diagnostic procedures.<br class="html-br" /><br class="html-br" />Salaam Takaful in line with its ESG-driven philosophy always goes an extra mile to create that much-needed Social Impact. The MoU was signed by Mr. Mohsin Murtaza Hussain, Head of Health Department, Salaam Takaful Limited, and Mr. Muhammad Danish Khan, CEO, Creek General Hospital.<br class="html-br" /><br class="html-br" />To learn more about Salaam Health Takaful product variants please visit&nbsp;<a class="x1i10hfl xjbqb8w x1ejq31n xd10rxx x1sy0etr x17r0tee x972fbf xcfux6l x1qhh985 xm0m39n x9f619 x1ypdohk xt0psk2 xe8uvvx xdj266r x11i5rnm xat24cr x1mh8g0r xexx8yu x4uap5 x18d9i69 xkhd6sd x16tdsg8 xggy1nq x1a2a7pz xt0b8zv x1hl2dhg x1fey0fg" tabindex="0" href="https://www.salaamtakaful.com/Products/SalaamSehatTakaful?fbclid=IwZXh0bgNhZW0CMTAAAR2V2RzbONjPmEi3pQc2amsVupEd1nMQ6LwATosPNztP2pTxX-FBaGldLgA_aem_ARv6gNQZuqnEvwC0z8lIVXCz_hjjUfTyOWB3ARqEjQo2V4L7p3hF4puXTVWOl6qbp-XEFqaXcL2-QshiFB0oAJFq" target="_blank" rel="nofollow noreferrer">https://www.salaamtakaful.com/Products/SalaamSehatTakaful</a>&nbsp;or dial 021-111-875-111.',
    excerpt:
      "Salaam Takaful Limited and Creek General Hospital, Karachi signed an MoU to commence a strategic partnership. Under this agreement, the hospital&rsquo;s Outpatient Department (OPD)…",
    date: "08-05-2024",
  },
  {
    Key: 2173,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/21731.jpg",
    heading:
      "Salaam Takaful Limited hosted a Sehri for its Health Business Partners ",
    archead:
      "Salaam Takaful Limited hosted a Sehri for its Health Business Partners ",
    content:
      "Salaam Takaful Limited, the largest general takaful operator and first Islamic Insurtech in Pakistan, hosted a Sehri for its Health Business Partners as a gesture of appreciation for their commitment to hard work and enthusiasm. With the philosophy of maintaining good relationships with its strategic partners the company's commitment to nurturing robust relationships and fostering collaboration within its network. Through lively interactions and shared meals, partners engaged in meaningful exchanges, fostering mutual trust, and enhancing collaboration.  This initiative is integral to cultivating a supportive community where collaboration thrives, ultimately contributing to improved services. Salaam Takaful Limited's belief in the importance of robust relationships underscores its commitment to excellence in service delivery.",
    excerpt:
      "Salaam Takaful Limited, the largest general takaful operator and first Islamic Insurtech in Pakistan, hosted a Sehri for its Health Business Partners as a gesture of appreciation for their commitment to hard work and enthusiasm….",
    date: "26-03-2024",
  },
  {
    Key: 2172,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/21721.jpg",
    heading:
      "Salaam Takaful's Day Out with Karachi Down Syndrome Program (KDSP) children on World Down Syndrome Day",
    archead:
      "Salaam Takaful's Day Out with Karachi Down Syndrome Program (KDSP) children on World ..",
    content:
      "World Down Syndrome Day is a day to celebrate the unique abilities and contributions of individuals with Down syndrome. This annual observance serves as a reminder of the importance of inclusion, acceptance, and support for individuals with Down syndrome. This World Down Syndrome Day, Salaam Takaful Limited collaborated with the Karachi Down Syndrome Program (KDSP) in a heartwarming engagement session. It began with an informative orientation session led by the KDSP team, delving into Down syndrome and strategies for fostering inclusivity. Following this, Salaam Takaful&rsquo;s team joined the children from KDSP in a Canvas Craft activity, creating beautiful artwork for an upcoming exhibition. These artworks not only showcased creativity but also symbolized its commitment to supporting individuals with special needs and fostering their inclusion in society. This collaboration is in line with Salaam Takaful&rsquo;s ESG-driven philosophy. As we reflect on this session, it's crucial to raise awareness about Down syndrome and other such characteristics to promote understanding as well as acceptance within society. By coming together we shine a light on the abilities and contributions of individuals with special needs, fostering a more inclusive and compassionate world for all.",
    excerpt:
      "World Down Syndrome Day is a day to celebrate the unique abilities and contributions of individuals with Down syndrome. This annual observance serves as a reminder of the importance of inclusion, acceptance….",
    date: "21-03-2024",
  },
  {
    Key: 2167,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2167.jpg",
    heading:
      "Salaam Takaful Limited wins the IAP Cricket Tournament consecutively for the third time",
    archead:
      "Salaam Takaful Limited wins the IAP Cricket Tournament consecutively for the third time",
    content:
      "Salaam Takaful Limited successfully defended the prestigious Insurance Association of Pakistan (IAP) Cricket championship title, to become the champion for the third time in a row. This feat was achieved under the captaincy of Mr. Kamran M. Hanif who once again led the team comprehensively to lift the cup.  ",
    excerpt:
      "Salaam Takaful Limited successfully defended the prestigious Insurance Association of Pakistan (IAP) Cricket championship title, to become the champion for the third time in a row. This feat was achieved under the captaincy of Mr. Kamran M. Hanif who once again led the team comprehensively to lift the cup.",
    date: "06-03-2024",
  },
  {
    Key: 2166,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2166.jpg",
    heading:
      "Salaam Takaful Limited and Digitt Plus commenced a strategic partnership",
    archead:
      "Salaam Takaful Limited and Digitt Plus commenced a strategic partnership",
    content:
      "Salaam Takaful Limited has recently signed an MoU with Digitt Plus. Through this partnership, Salaam Takaful will offer its Parametric-based Crop Takaful solutions to small-scale farmers via Digitt Plus platform. This alliance is committed to advancing digital financial services in rural communities and empowering agricultural sectors through financial inclusion.    Digitt Plus is a leading Agri-Fintech company, approved by the State Bank of Pakistan, promoting financial inclusion for the agricultural and rural sectors through digital financial services.    The MoU was signed by Mr. Rizwan Hussain, MD & CEO of Salaam Takaful Limited, and Mr. Ahmed Saleemi, CEO, of Digitt Plus.",
    excerpt:
      "Salaam Takaful Limited has recently signed an MoU with Digitt Plus. Through this partnership, Salaam Takaful will offer its Parametric-based Crop Takaful solutions to small-scale farmers via Digitt Plus platform. This alliance is…",
    date: "28-02-2024",
  },
  {
    Key: 2165,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2165.jpg",
    heading:
      "Salaam Takaful Limited and Akhtar & Hasan Actuaries commenced a strategic collaboration",
    archead:
      "Salaam Takaful Limited and Akhtar & Hasan Actuaries commenced a strategic collaboration",
    content:
      "Salaam Takaful Limited is pleased to announce a recent strategic collaboration with Akhtar & Hasan Actuaries, marking a significant milestone in advancing the Insurance and Takaful industry in Pakistan. This partnership focuses on joint knowledge initiatives, leveraging the combined expertise of both entities to elevate risk assessment methodologies, introduce innovative Takaful products, and drive financial inclusion across the country.    The agreement was signed by Mr. Rizwan Hussain, MD and CEO of Salaam Takaful Limited, and Faisal Zai, Senior Consulting Actuary at Akhtar & Hasan Actuaries. Notably, Akhtar & Hasan Actuaries will serve as Salaam Takaful's pricing partner, contributing extensive actuarial modeling capabilities to enhance decision-making processes.    Specializing in identifying, measuring, and managing risks for corporations and individuals, Akhtar & Hasan Actuaries brings tailored consultation services to life and general insurance, as well as Takaful companies. This collaboration underscores a commitment to developing customized solutions and strategies for sustainable growth in the industry.    ",
    excerpt:
      "Salaam Takaful Limited is pleased to announce a recent strategic collaboration with Akhtar & Hasan Actuaries, marking a significant milestone in advancing the Insurance and Takaful industry in Pakistan. This partnership focuses on joint knowledge initiatives, leveraging the combined expertise of both entities to elevate risk assessment methodologies, introduce innovative Takaful products, and drive financial inclusion across the country.    The agreement was signed by Mr. Rizwan Hussain, MD and CEO of Salaam Takaful Limited, and Faisal Zai, Senior Consulting Actuary at Akhtar & Hasan Actuaries. Notably, Akhtar & Hasan Actuaries will serve as Salaam Takaful's pricing partner, contributing extensive actuarial modeling capabilities to enhance decision-making processes.    Specializing in identifying...",
    date: "27-02-2024",
  },
  {
    Key: 2164,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2164.jpg",
    heading:
      "Salaam Takaful Limited shines at Career Readiness Day at Sir Syed University, Karachi",
    archead:
      "Salaam Takaful Limited shines at Career Readiness Day at Sir Syed University, Karachi",
    content:
      "Salaam Takaful Limited recently participated in Career Readiness Day organized by Sir Syed University of Engineering & Technology (SSUET). Career Readiness Day brought an exclusive opportunity to the students where they got firsthand experience of giving professional interviews. Salaam Takaful, being an active supporter of Academia-Corporate relations, played a crucial role in facilitating students on this front. These kinds of activities are aligned with the social aspect of Salaam Takaful’s ESG-driven philosophy.",
    excerpt:
      "Salaam Takaful Limited recently participated in Career Readiness Day organized by Sir Syed University of Engineering & Technology (SSUET). Career Readiness Day brought an exclusive opportunity to the students where they got firsthand experience….",
    date: "13-02-2024",
  },
  {
    Key: 2163,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/21631.jpg",
    heading:
      "Salaam Takaful Limited partners with National Foods Limited to provide Crop Takaful coverage",
    archead:
      "Salaam Takaful Limited partners with National Foods Limited to provide Crop Takaful coverage",
    content:
      "Salaam Takaful Limited and National Foods Limited recently signed an MoU to commence a strategic partnership to provide Parametric-based Crop Takaful coverage to farmers. Under this partnership, a pilot project will be conducted in the Sindh region, that provides comprehensive weather-related risk coverage for tomato farmers.    By combining their expertise, both entities aim to provide farmers with comprehensive and accessible Islamic insurance coverage, safeguarding their livelihoods and enabling sustainable growth in the agricultural sector. This is in line with Salaam Takaful’s vision of creating a robust ecosystem to make farmers resilient against climate change under UNSDGs.",
    excerpt:
      "Salaam Takaful Limited and National Foods Limited recently signed an MoU to commence a strategic partnership to provide Parametric-based Crop Takaful coverage to farmers. Under this partnership, a pilot project will be conducted in the Sindh region, that provides comprehensive weather-related....",
    date: "19-01-2024",
  },
  {
    Key: 2162,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2162.png",
    heading:
      "Salaam Takaful Limited achieved an extraordinary gross written contribution of PKR 4.1 Billion in 2023, showcasing an exceptional 36.66% year-on-year growth",
    archead:
      "Salaam Takaful Limited achieved an extraordinary gross written contribution of PKR 4.1 Billion ..",
    content:
      "AlhamduLillah! The Rise Continues; Showcasing an exceptional 36.66% year-on-year growth, Salaam Takaful Limited achieved an extraordinary gross written contribution of PKR 4.1 Billion in 2023. This remarkable milestone solidifies its position as Pakistan's premier and largest general takaful operator, fueled by the trust of its valued stakeholders. The journey of Salaam Takaful has been defined by its dedication to elevating quality service, digital innovation, and customer-centric solutions.    Looking ahead to 2024, Salaam Takaful remains dedicated to delivering unparalleled service and pioneering innovative initiatives for a secure and Shariah-compliant future.",
    excerpt:
      "AlhamduLillah! The Rise Continues; Showcasing an exceptional 36.66% year-on-year growth, Salaam Takaful Limited achieved an extraordinary gross written contribution of PKR 4.1 Billion in 2023. This remarkable milestone solidifies its position as Pakistan's premier and largest general...",
    date: "16-01-2024",
  },
  {
    Key: 2161,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/21611.jpg",
    heading: "Salaam Takaful's Phenomenal Record: The Rise Continues!",
    archead: "Salaam Takaful's Phenomenal Record: The Rise Continues!",
    content:
      "AlhamduLillah! The Rise Continues; Showcasing an exceptional 36.66% year-on-year growth, Salaam Takaful Limited achieved an extraordinary gross written contribution of PKR 4.1 Billion in 2023. This remarkable milestone solidifies its position as Pakistan's premier and largest general takaful operator, fueled by the trust of its valued stakeholders. The journey of Salaam Takaful has been defined by its dedication to elevating quality service, digital innovation, and customer-centric solutions.    Looking ahead to 2024, Salaam Takaful remains dedicated to delivering unparalleled service and pioneering innovative initiatives for a secure and Shariah-compliant future.",
    excerpt:
      "AlhamduLillah! The Rise Continues; Showcasing an exceptional 36.66% year-on-year growth, Salaam Takaful Limited achieved an extraordinary gross written contribution of PKR 4.1 Billion in 2023. This remarkable milestone…",
    date: "02-01-2024",
  },
  {
    Key: 2160,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2160.jpg",
    heading:
      "Salaam Takaful Limited congratulates Indus Motor Company on the launch of first locally assembled toyota corolla cross hybrid in Pakistan",
    archead:
      "Salaam Takaful Limited congratulates Indus Motor Company on the launch of first …",
    content:
      "Salaam Takaful Limited extends heartfelt congratulations to Indus Motor Company on the momentous occasion of the launch of the first locally assembled Toyota Corolla Cross Hybrid in Pakistan.    This remarkable achievement not only marks a significant milestone in the automotive industry. We applaud Indus Motor Company for their dedication to innovation and their contribution to bringing environmentally friendly vehicles to the Pakistani market. As partners in progress, we are enthusiastic about continued success and collaboration.",
    excerpt:
      "Salaam Takaful Limited extends heartfelt congratulations to Indus Motor Company on the momentous occasion of the launch of the first locally assembled Toyota Corolla Cross Hybrid in Pakistan.    This remarkable achievement not only marks a significant milestone in the automotive industry. We applaud Indus Motor Company for their dedication to innovation and their contribution to bringing environmentally friendly vehicles to the Pakistani market. As partners in progress, we are enthusiastic about continued success and collaboration.",
    date: "02-01-2024",
  },
  {
    Key: 2159,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2159.jpg",
    heading:
      "Mufti Sajjad Usmani of Salaam Takaful Limited spoke at IBA Karachi on ethical finance and Takaful Principles",
    archead:
      "Mufti Sajjad Usmani of Salaam Takaful Limited spoke at IBA Karachi on ethical finance..",
    content:
      "Mufti Sajjad Usmani of Salaam Takaful Limited recently spoke at the Institute of Business Administration, Karachi on Ethical Finance and Takaful Principles. He discussed Shariah Justification, the Wakala Waqf Model, and the Contrast between Insurance and Takaful. The session aimed at shaping ethical finance perspectives for undergraduate BBA and BS students.    Dr. Irum Saba, Associate Professor, and Program Director MS-IBF at the School of Business Studies, who is also a Shariah Board Technical Member at Salaam Takaful facilitated this one-of-its-kind session. These kinds of collaborations with academia highlight Salaam Takaful’s commitment to foster understanding of Takaful principles among students.",
    excerpt:
      "Mufti Sajjad Usmani of Salaam Takaful Limited recently spoke at the Institute of Business Administration, Karachi on Ethical Finance and Takaful Principles. He discussed Shariah Justification, the Wakala Waqf Model…",
    date: "02-01-2024",
  },
  {
    Key: 2158,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2158.jpg",
    heading:
      "Mr.Wajahat Khawaja of Salaam Takaful Limited spoke at IIAL - London Conference",
    archead:
      "Mr.Wajahat Khawaja of Salaam Takaful Limited spoke at IIAL - London Conference",
    content:
      "As a speaker at the Islamic Insurance Association of London – 6th Annual IIAL London Conference, Mr. Wajahat Khawaja, Executive Director of Strategic Initiatives, highlighted Salaam Takaful's pioneering role in introducing technological solutions to benefit policyholders. The Islamic Insurance Association of London hosted an event emphasizing London's crucial role in the evolving landscape of Islamic (re)insurance. The theme underscored the necessity for London's active participation to avoid being left behind in this transformative journey.    Mr. Wajahat emphasized how Salaam Takaful stands at the forefront as the first Islamic Insurtech, setting a significant example for the industry. He discussed the company's commitment to harnessing the power of technology to enhance client services and its dedication to leading the way in the ever-evolving insurance/takaful landscape.",
    excerpt:
      "As a speaker at the Islamic Insurance Association of London – 6th Annual IIAL London Conference, Mr. Wajahat Khawaja, Executive Director of Strategic Initiatives, highlighted Salaam Takaful's pioneering role in introducing…",
    date: "02-01-2024",
  },
  {
    Key: 2157,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2157.jpg",
    heading:
      "Salaam Takaful Limited and Iranian Insurance Research Centre (IRC) commenced a strategic partnership",
    archead:
      "Salaam Takaful Limited and Iranian Insurance Research Centre (IRC) commenced a strategic ..",
    content:
      "Salaam Takaful Limited has recently signed an MoU with Iranian Insurance Research Centre (IRC) to commence strategic partnership. The partnership strives for global advancement in the insurance and takaful industry through collaborative knowledge initiatives. Together, both parties will focus on research, training programs, and events to nurture skilled professionals and boost industry expertise. The exchange of intelligence and consultations enhances their joint objective of advancing knowledge in insurance, Islamic finance including takaful.    The MoU was signed by Mr. Nayyar Hussain, Executive Director - Head of Strategy & New Initiatives, Salaam Takaful Limited and Prof. Dr. Mohammad Mahdi Asgari, Chief Executive Officer, Iranian Insurance Research Center (IRC). The distinguished presence of Mohammad-Reza Farzin, Governor of the Central Bank of Iran, added significance to the occasion.",
    excerpt:
      "Salaam Takaful Limited has recently signed an MoU with Iranian Insurance Research Centre (IRC) to commence strategic partnership. The partnership strives for global advancement in the insurance and takaful industry….",
    date: "02-01-2024",
  },
  {
      Key: 2156,
      feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2256.jpeg",
      heading: "Commencement of Qarz-e-Hasna to Sir Syed University Students",
      archead: "Commencement of Qarz-e-Hasna to Sir Syed University Students",
      content: "Salaam Takaful Limited under its partnership with Sir Syed University of Engineering and Technology ( SSUET), Karachi, and in line with its ESG-driven philosophy, commenced the disbursement of Qarz-e-Hasna (a financing facility for deserving students).    This milestone reiterates the emphasis on the need of human capital development and enables students to eliminate financial problems that create hurdles in pursuance of their higher education in Pakistan.    With this action, and many more of its kind, Salaam Takaful Limited hopes to empower individuals by ensuring inclusive and equitable quality education and promoting lifelong learning opportunities for all.",
      excerpt: "Salaam Takaful Limited under its partnership with Sir Syed University of Engineering and Technology ( SSUET), Karachi, and in line with its ESG-driven philosophy, commenced the disbursement of Qarz-e-Hasna …",
      date: "02-01-2024"
  },
  {
    Key: 2155,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2155.jpg",
    heading:
      "Salaam Takaful Limited recently convened its third Shariah Board Meeting",
    archead:
      "Salaam Takaful Limited recently convened its third Shariah Board Meeting",
    content:
      "Salaam Takaful Limited recently convened its third Shariah Board Meeting, bringing together esteemed board members and renowned Shariah experts to discuss new strategic initiatives and upcoming projects.    The meeting provided a collaborative platform for sharing insights, addressing challenges, and setting a strategic course for the organization's continued growth and success. Guided by the principles of Islamic finance and Takaful, Salaam Takaful Limited remains committed to ensuring its business practices, and products, align with Islamic ethics and values while remaining innovative and forward-thinking.",
    excerpt:
      "Salaam Takaful Limited recently convened its third Shariah Board Meeting, bringing together esteemed board members and renowned Shariah experts to discuss new strategic initiatives and upcoming projects…",
    date: "06-12-2023",
  },
  {
    Key: 2154,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2154.jpg",
    heading:
      "Mr. Kamran M. Hanif represented Salaam Takaful Limited at the Pakistan’s First Insurtech Summit as a panelist",
    archead:
      "Mr. Kamran M. Hanif represented Salaam Takaful Limited at the Pakistan’s First Insurtech ..",
    content:
      "Mr. Kamran M. Hanif, Executive Director Commercial, recently shared invaluable insights at the Pakistan’s First Insurtech Summit as a panelist. The event was hosted by Pakistan Fintech Network. Mr. Kamran was an active participant in the panel discussion titled 'Non-Life Insurtech Revolution: A World of Digital Possibilities for Every Pakistani.'    Mr. Kamran's valuable insights and expertise highlighted Salaam Takaful’s commitment to embracing the digital transformation of the non-life insurance/ takaful sector. The summit provided a platform for discussing how technology can revolutionize insurance services, making them more accessible and tailored to the needs of every Pakistani.",
    excerpt:
      "Mr. Kamran M. Hanif, Executive Director Commercial, recently shared invaluable insights at the Pakistan’s First Insurtech Summit as a panelist. The event was hosted by…",
    date: "05-12-2023",
  },
  {
    Key: 2153,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2153.jpg",
    heading:
      "Mr. Wajahat Khawaja represented Salaam Takaful Limited as a guest speaker at Pakistan's First Insurtech Summit",
    archead:
      "Mr. Wajahat Khawaja represented Salaam Takaful Limited as a guest speaker at Pakistan's First ..",
    content:
      "As a guest speaker at Pakistan's First Insurtech Summit, Mr. Wajahat Khawaja, Executive Director of Strategic Initiatives, highlighted Salaam Takaful's pioneering role in introducing technological solutions to benefit policyholders. The event, hosted by Pakistan Fintech Network, centered around the theme of 'Insurtech Accelerate: Unleashing the Power of Technological Innovation in Pakistan's Insurance Industry.'    Mr. Wajahat emphasized how Salaam Takaful stands at the forefront as the first Islamic insurtech, setting a significant example for the industry. He discussed the company's commitment to harnessing the power of technology to enhance client services and its dedication to leading the way in the ever-evolving insurance / takaful landscape.    ",
    excerpt:
      "As a guest speaker at Pakistan's First Insurtech Summit, Mr. Wajahat Khawaja, Executive Director of Strategic Initiatives, highlighted Salaam Takaful's pioneering role in introducing technological solutions to benefit policyholders….",
    date: "05-12-2023",
  },
  {
    Key: 2152,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2152.jpg",
    heading:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited in Pakistan's First Insurtech Summit as a panelist",
    archead:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited in Pakistan's First Insurtech Summit..",
    content:
      "Mr. Nayyar Hussain, Head of Strategy & New Initiative, recently shared invaluable insights at the Pakistan's First Insurtech Summit as a panelist. The event, hosted by Pakistan Fintech Network. Mr. Nayyar participated panel duscussion focusing on 'Life Insurance in Transformation: Recipe for the Next 10 Million Happy Customers.'    Mr. Nayyar Hussain's participation highlighted Salaam Takaful's dedication to staying at the forefront of the evolving insurance/ takaful landscape, where technology and customer-centric solutions are key. The discussion centered on the innovative strategies and technologies that can make life insurance/ takaful more accessible and efficient for the next generation of customers.  ",
    excerpt:
      "Mr. Nayyar Hussain, Head of Strategy & New Initiative, recently shared invaluable insights at the Pakistan's First Insurtech Summit as a panelist. The event, hosted by Pakistan Fintech Network. Mr. Nayyar….",
    date: "05-12-2023",
  },
  {
    Key: 2151,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2151.jpg",
    heading:
      "Salaam Takaful Limited and Concave AGRI commenced a strategic partnership",
    archead:
      "Salaam Takaful Limited and Concave AGRI commenced a strategic partnership",
    content:
      "Salaam Takaful Limited has recently signed an MoU with Concave AGRI to commence strategic partnership. This partnership will enable both the parties to concentrate on providing customized Islamic insurance solutions designed to safeguard the financial well-being of farmers in the midst of climate-related difficulties.    The MoU was signed by Mr. Rizwan Hussain - MD and CEO, Salaam Takaful Limited and Muhammad Ali Iqbal, president, Concave AGRI.",
    excerpt:
      "Salaam Takaful Limited has recently signed an MoU with Concave AGRI to commence strategic partnership. This partnership will enable both the parties to concentrate on providing customized Islamic..",
    date: "02-11-2023",
  },
  {
    Key: 2150,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2150.jpg",
    heading:
      "Mr. Wajahat Khawaja represented Salaam Takaful Limited as a Panelist at the National Disaster Risk Management Fund Seminar 2023",
    archead:
      "Mr. Wajahat Khawaja represented Salaam Takaful Limited as a Panelist at the National Disaster..",
    content:
      "Our Executive Director of Strategic Initiatives, Mr. Wajahat Khawaja, recently shared invaluable insights at the NDRMF seminar on 'Leveraging Carbon Markets to Enable Private Investment.'     These thought-provoking seminars are crucial for navigating the complexities of today's world and are at the heart of Salaam Takaful's ambition in the Takaful industry. They provide a platform for experts, thought leaders, and professionals from diverse sectors to come together, fostering innovation and collaboration, as Salaam Takaful aspire to be an integral part of the ecosystem that safeguards and protects such investments.",
    excerpt:
      "Our Executive Director of Strategic Initiatives, Mr. Wajahat Khawaja, recently shared invaluable insights at the NDRMF seminar on 'Leveraging Carbon Markets to Enable Private Investment.'     These thought-provoking seminars are…",
    date: "31-10-2023",
  },
  {
    Key: 2149,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2149.jpg",
    heading:
      "Salaam Takaful Limited and AIESEC in Pakistan commenced a strategic partnership",
    archead:
      "Salaam Takaful Limited and AIESEC in Pakistan commenced a strategic partnership",
    content:
      "Salaam Takaful Limited recently signed an MoU with AIESEC in Pakistan to commence a strategic partnership. This partnership will enable Salaam Takaful to provide Travel Takaful coverage to the outgoing exchange participants of AIESEC Pakistan.   The MoU was signed by Mr. Kamran M. Hanif, Executive Director – Commercial, Salaam Takaful Limited and Mr. Muhammad Shayan Raza, Country Head Business Development, AIESEC.",
    excerpt:
      "Salaam Takaful Limited recently signed an MoU with AIESEC in Pakistan to commence a strategic partnership. This partnership will enable Salaam Takaful to provide Travel Takaful coverage to the outgoing exchange participants..",
    date: "26-10-2023",
  },
  {
    Key: 2148,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2148.jpg",
    heading:
      "Salaam Takaful Limited wins 2nd position for Best Corporate and Sustainability Report Awards 2022 in the Insurance category by CA & ICMA Pakistan",
    archead:
      "Salaam Takaful Limited wins 2nd position for Best Corporate and Sustainability Report Awards…",
    content:
      "Another remarkable feat achieved, Alhamdulillah!  Salaam Takaful Limited has once again been conferred with 2nd position for Best Corporate and Sustainability Report Awards 2022 in the Insurance category by CA & ICMA Pakistan.  This consecutive recognition with top positions for 5 consecutive years is another acknowledgement of our commitment to encourage exquisite compliance with reporting regulations, being a comprehensively transparent business operation, and phenomenal financial performance. In the past years we have successfully improved the overall standard of corporate reporting and took it to the highest level as part of the company’s quest to build and sustain investor trust and confidence at local and international levels. We pledge that we will continue to demonstrate highest standards of transparency & governance, ethics with utmost adherence to Shariah guidelines.  Congratulations to the whole team behind this award. Many more to come In’sha’Allah.",
    excerpt:
      "Another remarkable feat achieved, Alhamdulillah!  Salaam Takaful Limited has once again been conferred with 2nd position for Best Corporate and Sustainability Report Awards 2022..",
    date: "16-10-2023",
  },
  {
    Key: 2147,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2147.jpg",
    heading:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as an AgriTech Panelist at Digi Leaders Conference 2023",
    archead:
      "Mr. Nayyar Hussain represented Salaam Takaful Limited as an AgriTech Panelist at Digi Leaders..",
    content:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, served as an AgriTech Panelist at the Digi Leaders Conference 2023. The Digi Leaders Conference embarked on an enlightening journey to explore a diverse range of cutting-edge topics in the digital landscape. Esteemed speakers came together to delve into crucial subjects such as Digital Transformation, Health Tech, AgriTech, and the thriving realm of Startups.  This conference served as a pivotal platform for thought leaders and innovators to exchange ideas and insights, contributing to the ongoing evolution of the digital ecosystem.",
    excerpt:
      "Mr. Nayyar Hussain, Executive Director of Strategy and New Initiatives at Salaam Takaful Limited, served as an AgriTech Panelist at the Digi Leaders Conference 2023. The Digi Leaders Conference embarked on …",
    date: "13-10-2023",
  },
  {
    Key: 2146,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2146.jpg",
    heading:
      "Salaam Takaful Limited extends its exclusive Pay As You Drive Takaful for Khaadi Employees",
    archead:
      "Salaam Takaful Limited extends its exclusive Pay As You Drive Takaful for Khaadi Employees",
    content:
      "Salaam Takaful Limited and Khaadi have officially formalized their collaboration through the signing of a Memorandum of Understanding (MOU). This strategic partnership is designed to broaden the availability of PAY AS YOU DRIVE motor Takaful coverage. Specifically, this extended offering will now encompass not only Khaadi's employees but also their immediate family members, providing an added layer of financial security and protection for a broader circle of individuals associated with the Khaadi community.",
    excerpt:
      "Salaam Takaful Limited and Khaadi have officially formalized their collaboration through the signing of a Memorandum of Understanding (MOU). This strategic partnership is designed…",
    date: "04-10-2023",
  },
  {
    Key: 2145,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2145.jpg",
    heading:
      "Salaam Takaful Limited and OneClick Digital commenced a strategic partnership",
    archead: "OneClick Digital commenced a strategic partnership",
    content:
      "Salaam Takaful Limited has recently signed an MoU with OneClick Digital to commence strategic partnership. This partnership will enable OneClick Digital to sell Salaam Takaful products through its platform.    The MoU was signed by Mr. Kamran M. Hanif, Executive Director – Commercial, Salaam Takaful Limited and Mr. S. Bilal Ali Jafri, CEO, OneClick Digital.",
    excerpt:
      "Salaam Takaful Limited has recently signed an MoU with OneClick Digital to commence strategic partnership....",
    date: "04-10-2023",
  },
  {
    Key: 2144,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2144.jpg",
    heading:
      "Salaam Takaful Limited extends its support to the Layton Rahmatulla Benevolent Trust - LRBT ",
    archead: "Support to the Layton Rahmatulla Benevolent Trust - LRBT ",
    content:
      "Salaam Takaful Limited extends its support to the Layton Rahmatulla Benevolent Trust - LRBT  in line with its commitment to ESG principles. This collaboration underscores Salaam Takaful's morals of social responsibility and community betterment.     LRBT, through its purpose-built and appropriately-equipped hospitals, provides free comprehensive eye-care to any underprivileged patient who comes into their facilities.    On this occasion, Mr. Rizwan Hussain, MD & CEO of Salaam Takaful Limited, and Mr. Najmus Saqib, Chairman, LRBT, stressed on the importance of ESG related initiatives and why it is a compulsion to help the underprivileged.",
    excerpt:
      "Salaam Takaful Limited extends its support to the Layton Rahmatulla Benevolent Trust - LRBT  in line with its ….",
    date: "04-10-2023",
  },
  {
    Key: 2143,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2143.jpg",
    heading:
      "Salaam Takaful Limited organized awareness sessions on farmers' resilience against climate change in Multan & Depalpur",
    archead:
      "Awareness sessions on farmers' resilience against climate change…",
    content:
      "Salaam Takaful organized multiple awareness sessions for farmers in Multan and Depalpur, to educate them about the benefits of Takaful in building resilience against climate change. These sessions aimed to empower farmers with knowledge of Takaful principles and best practices in sustainable agriculture, in collaboration with Fauji Fresh n Freeze. This initiative is part of Salaam Takaful's larger effort to support the agricultural sector and promote sustainable livelihoods in Pakistan.    Salaam Takaful and Fauji Fresh n Freeze commenced this strategic partnership with an objective to make farmers resilient against climate change by providing them coverage against multiple weather-based perils.",
    excerpt:
      "Salaam Takaful organized multiple awareness sessions for farmers in Multan and Depalpur, to educate them about …`",
    date: "04-10-2023",
  },
  {
    Key: 2142,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2142.jpg",
    heading: "Salaam Takaful announces another Surplus Distribution",
    archead: "Announces another Surplus Distribution",
    content:
      "Alhamdulillah, with utmost pride, we are happy to state that this year too, Salaam Takaful Limited, the largest general takaful operator and first Islamic Insurtech in Pakistan, will be giving back Surplus amount of takaful fund to its policyholders.    The company has been upholding the true essence of takaful by being the only general takaful operator to regularly undertake this initiative every year. We are setting a benchmark based on our transparency & performance for the whole industry and In'sha'Allah will continue to do the unprecedented to prove that Salaam Takaful Limited is the right choice for all your risk coverage needs.",
    excerpt:
      "Alhamdulillah, with utmost pride, we are happy to state that this year too, Salaam Takaful Limited, the largest general …",
    date: "13-09-2023",
  },
  {
    Key: 2141,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2141.jpg",
    heading:
      "Salaam Takaful Limited commenced a strategic partnership with SmartDealer and Abhi",
    archead: "Strategic partnership with SmartDealer and Abhi",
    content:
      "Salaam Takaful Limited has joined forces with SmartDealer Technologies and Abhi (YC S21) with the aim to provide unparalleled support to Agri dealers. Together, these entities are set to devise an ecosystem which will foster growth and prosperity in the agricultural sector, with convenient financial inclusion front for Agri based dealers and farmers.    The MoU was signed by Mr. Rizwan Hussain, MD & CEO, Salaam Takaful Limited, Mr. Ehtisham Ali Khan, CEO, SmartDealer Technologies and Mr. Mohammad Zaidi, CCO, Abhi (YC S21).    This is another step towards Salaam Takaful's vision of creating social impact through innovative collaborations.",
    excerpt:
      "Salaam Takaful Limited has joined forces with SmartDealer Technologies and Abhi (YC S21) with the aim to provide…",
    date: "01-08-2023",
  },
  {
    Key: 2140,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2140.jpg",
    heading:
      "Salaam Takaful Limited and JazzCash commenced a strategic partnership",
    archead: "JazzCash commenced a strategic partnership",
    content:
      "Salaam Takaful Limited and JazzCash commenced a partnership by signing an MoU to Launch Innovative Hybrid Parametric Crop Takaful Coverage Model. This collaboration aims to provide tailored Islamic insurance solutions for farmers in Pakistan, addressing risks associated with agriculture and promoting sustainable growth in the agricultural sector. By combining their expertise and resources, both organizations are committed to revolutionizing the insurance / takaful industry and creating innovative solutions that cater to the specific needs of farmers. The MoU was signed by Mr. Rizwan Hussain, MD & CEO, Salaam Takaful Limited and Mr. Murtaza Ali, CEO, JazzCash.    The hybrid parametric crop takaful coverage will offer comprehensive protection to farmers against various perils. This partnership underscores the commitment of Salaam Takaful Limited to fostering financial inclusion and resilience within the agricultural sector of Pakistan.",
    excerpt:
      "Salaam Takaful Limited and JazzCash commenced a partnership by signing an MoU to Launch Innovative Hybrid Parametric….",
    date: "01-08-2023",
  },
  {
    Key: 2139,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2139.png",
    heading:
      "Salaam Takaful Limited has achieved GWC of PKR 2 billion in the first half of 2023",
    archead: "GWC of PKR 2 billion in the first half of 2023",
    content:
      "Salaam Takaful Limited has achieved another momentous milestone by reaching gross written contribution of PKR 2 billion in the first half of 2023, ended 30th June. This outstanding achievement is a testament of the firm trust our policyholders have bestowed upon us, and further cements our resolve to be more dedicated towards putting in relentless efforts for more innovation and digitization, and to be more committed towards delivering exceptional customer service.    Salaam Takaful's January to June Gross Written Contribution has witnessed an impressive growth of 54% as compared to the same period during the previous year.     Due to this incredible momentum, we are confident that we will raise the bar even further by the end of this year, in’sha’Allah.",
    excerpt:
      "Salaam Takaful Limited has achieved another momentous milestone by reaching gross written contribution of PKR 2 billion …",
    date: "07-07-2023",
  },
  {
    Key: 2138,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2138.png",
    heading:
      "Mr. Rizwan Hussain (MD & CEO, Salaam Takaful Limited) and Mr. Hiroshi Kawamura (MD, Pak Suzuki Motor Company Limited) discussed various areas of collaboration",
    archead: "Mr. Rizwan Hussain (MD & CEO, Salaam …",
    content:
      "Salaam Takaful Limited strongly believes in its “Partners-to-win” philosophy which fosters collaborative partnerships that result in mutual benefits for all involved parties. Being an integral part of Suzuki Insurance Arrangement Program, team Salaam Takaful participated in Pak Suzuki's used car gala, where Mr. Rizwan Hussain (MD & CEO, Salaam Takaful Limited) and Mr. Hiroshi Kawamura (MD, Pak Suzuki Motor Company Limited) discussed various areas of collaboration.    The meeting was marked by a shared commitment to create a win-win partnership that would enhance the offerings and services for both organizations. By leveraging their respective strengths and expertise, Salaam Takaful and Pak Suzuki aim to develop innovative takaful solutions specifically tailored for Suzuki customers.    Through such strategic alliances, Salaam Takaful Limited strives to build strong relationships with industry leaders and drive positive outcomes that benefit all stakeholders.",
    excerpt:
      "Salaam Takaful Limited strongly believes in its “Partners-to-win” philosophy which fosters collaborative ….",
    date: "04-07-2023",
  },
  {
    Key: 2137,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/2137.png",
    heading: "Salaam Takaful Limited congratulates its Flying Stars",
    archead: "Its Flying Stars….",
    content:
      "Salaam Takaful Limited congratulates its Growth Partners, Hammad Mughal and Habibullah Khan for ending up being highest run scorer and wicket taker respectively, in the recently concluded Insurance Premier League 2022-23.    Insurance Premier League is a high profile Cricket tournament, being played among best Cricket teams of Insurance and Takaful companies across Pakistan. In the 5th edition of this prestigious league, both of these gentlemen demonstrated extraordinary gameplay to earn the titles of best batsman and best bowler of the tournament.",
    excerpt:
      "Salaam Takaful Limited congratulates its Growth Partners, Hammad Mughal and Habibullah Khan for ending up….",
    date: "04-07-2023",
  },
];

export const SalamHealthCoverageAPI = [
  {
    key: "1",
    Plan: "A",
    Contribution: "8,000",
    Hospitalization: "100,000",
    RoomLimit: "2500",
    Outpatient: "1000",
  },
  {
    key: "2",
    Plan: "B",
    Contribution: "14,000",
    Hospitalization: "200,000",
    RoomLimit: "5000",
    Outpatient: "2000",
  },
  {
    key: "1",
    Plan: "C",
    Contribution: "17,000",
    Hospitalization: "300,000",
    RoomLimit: "7500",
    Outpatient: "3000",
  },
  {
    key: "1",
    Plan: "D",
    Contribution: "28,500",
    Hospitalization: "500,000",
    RoomLimit: "12500",
    Outpatient: "5000",
  },
  {
    key: "1",
    Plan: "E",
    Contribution: "45,000",
    Hospitalization: "1,000,000",
    RoomLimit: "25,000",
    Outpatient: "10,000",
  },
];

export const MotorsTabs = [
  {
    key: "1",
    mainheading: "Private Vehicle",
    content:
      "Full comprehensive coverage (as more specifically defined in our standard private car comprehensive policy) against accidental loss and/or damage and/or theft of the motor vehicle including legal liability of the participant to third parties arising out of the use of the motor vehicle. The policy is also extended to cover the risk of terrorism to the extent of the full sum covered of the vehicle.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/motortabs/privatecar.jpg",
    heading1: "Coverages",
    heading2: "Optional",
    Coverages: [
      {
        id: "2",
        li: "Burglary and theft",
      },
      {
        id: "3",
        li: "Fire & external explosion  ",
      },
      {
        id: "4",
        li: "Risk while in transit by air, road, rail, inland waterway, lift or elevator",
      },
      {
        id: "5",
        li: "Riot and strike damage,  ",
      },
      {
        id: "6",
        li: "Any natural incident (Earthquake, Flood, etc.)",
      },
      {
        id: "7",
        li: "Risk of terrorism.",
      },
      {
        id: "8",
        li: "Third Party ",
      },
    ],

    OptionalBenefits: [
      {
        id: "2",
        li: "Personal Accident Cover",
      },
    ],
  },
  // {
  //   key: "2",
  //   mainheading: "Pay As You Drive",
  //   content:
  //     "Salaam Takaful has introduced for the first time in Pakistan – a state-of-the-art telematics product, Pay As You Drive, a tech-based takaful coverage solution that tracks and records car’s mileage and contribution payment based on the number of recorded driven kilometers. This product is undoubtedly a trendsetter within the Pakistani market, following the global lineage of telematics accepted worldwide by insurers and Insurtech players. Pay As You Drive gives policyholders the benefits of comprehensive car takaful starting from just Rs. 10,000/- annually. Salaam Pay As You Drive comes bundled with free car tracking service which not only assists in mileage calculations but also provides various vehicle related data.",
  //   image: "https://asset.salaamtakaful.com/GeneralAssets/motortabs/payd.jpg",
  //   heading1: "Key features of Pay As You Drive are",
  //   heading2: "Coverages ",
  //   Coverages: [
  //     {
  //       id: "2",
  //       li: "Upfront Contribution Amount of Rs. 10,000/- only",
  //     },
  //     {
  //       id: "3",
  //       li: "Free Tracker worth Rs. 20,000/-  ",
  //     },
  //     {
  //       id: "4",
  //       li: "12-month Installment Plan ",
  //     },
  //     {
  //       id: "5",
  //       li: "Variable Contribution Amount (Pay only when you drive) ",
  //     },
  //   ],

  //   OptionalBenefits: [
  //     {
  //       id: "1",
  //       li: "100% Settlement of claims within 7 days",
  //     },
  //     {
  //       id: "2",
  //       li: "No Requirement of Police Final Report",
  //     },
  //     {
  //       id: "3",
  //       li: "Accident Damages",
  //     },
  //     {
  //       id: "4",
  //       li: "Accessories Theft",
  //     },
  //     {
  //       id: "5",
  //       li: "Burglary & Theft",
  //     },
  //     {
  //       id: "6",
  //       li: "Fire External Explosion",
  //     },
  //     {
  //       id: "7",
  //       li: "Total Loss",
  //     },
  //     {
  //       id: "8",
  //       li: "Theft/Snatch",
  //     },
  //     {
  //       id: "9",
  //       li: "Natural Catastrophes (Earthquake, Flood, Hail, Wind, etc.)",
  //     },
  //     {
  //       id: "10",
  //       li: "Riots & Strike Damage",
  //     },
  //     {
  //       id: "11",
  //       li: "Risk Of Terrorism",
  //     },
  //     {
  //       id: "12",
  //       li: "Third-Party Coverage Death Bodily Injury",
  //     },
  //     {
  //       id: "13",
  //       li: "Property Damages",
  //     },
  //     {
  //       id: "14",
  //       li: "Emergency Medical Expenses",
  //     },
  //     {
  //       id: "15",
  //       li: "In-house surveyors",
  //     },
  //     {
  //       id: "16",
  //       li: "Salaam App",
  //     },
  //     {
  //       id: "17",
  //       li: "Self-Assessment at an approved dealership",
  //     },
  //   ],
  // },
  {
    key: "2",
    mainheading: "Private Car Third Party",
    content:
      "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/motortabs/privatecars.jpg",
    heading1: "Coverages",
    Coverages: [
      {
        id: "2",
        li: "Legal liability of the participant to third parties arising out of the use of the motor vehicle.",
      },
      {
        id: "3",
        li: "Includes third party only who may be injured or killed in an accident and whose vehicle or property may be damaged.",
      },
    ],
  },
  {
    key: "3",
    mainheading: "Commercial vehicle",
    content:
      "Our commercial vehicle provides full comprehensive coverage (defined in our standard commercial vehicle comprehensive policy).",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/motortabs/comercial.jpg",
    heading1: "Coverages",
    heading2: "Optional",
    Coverages: [
      {
        id: "2",
        li: "Burglary and theft",
      },
      {
        id: "3",
        li: "Fire, external explosion ",
      },
      {
        id: "4",
        li: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
      },
      {
        id: "5",
        li: "Riot and strike damage, ",
      },
      {
        id: "6",
        li: "Any natural incident (Earthquake, Flood, etc.) ",
      },
      {
        id: "7",
        li: "Risk of terrorism. ",
      },
    ],
    OptionalBenefits: [
      {
        id: "1",
        li: "Death or physical injury to a third party (excluding the person covered) ",
      },
      {
        id: "2",
        li: "Compensation for any person driving with an order/permission not eligible for compensation under another policy.",
      },
      {
        id: "3",
        li: "Damage to third-party properties (excluding properties held in trust or custody by a third party's participant).",
      },
      {
        id: "4",
        li: "In the event of a third party's death, the company shall indemnify the personal representatives of the deceased, subject to regulatory limitations.",
      },
    ],
  },
  {
    key: "4",
    mainheading: "Motorcycle",
    content:
      "Salaamti Bike Takaful is designed to provide riders with comprehensive protection, ensuring peace of mind every time they hit the road. Whether you're navigating city streets or cruising through scenic routes, our tailored coverage safeguards your bike against accidents, theft, and unforeseen incidents. With flexible plans and hassle-free claim processes, Salaamti Bike Takaful is your reliable partner on every journey. Experience the freedom of the open road with the assurance that your ride is protected by shariah-compliant Takaful solution.",
    image: "https://asset.salaamtakaful.com/GeneralAssets/motortabs/bike.jpg",
    heading1: "Coverages",
    heading2: "Optional",
    Coverages: [
      {
        id: "2",
        li: "Burglary and theft",
      },
      {
        id: "3",
        li: "Fire, external explosion",
      },
      {
        id: "4",
        li: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
      },
      {
        id: "5",
        li: "Riot and strike damage,",
      },
      {
        id: "6",
        li: "Any natural incident (Earthquake, Flood, etc.)",
      },
      {
        id: "7",
        li: "Risk of terrorism.",
      },
    ],

    OptionalBenefits: [
      {
        id: "1",
        li: "Death or physical injury to a third party (excluding the person covered).",
      },
      {
        id: "2",
        li: "Compensation for any person driving with an order/permission not eligible for compensation under another policy.",
      },
      {
        id: "3",
        li: "Damage to third-party properties (excluding properties held in trust or custody by a third party's participant).",
      },
      {
        id: "4",
        li: "In the event of a third party's death, the company shall indemnify the personal representatives of the deceased, subject to regulatory limitations.",
      },
    ],
  },
  // {
  //     key: "6",
  //     mainheading: "Motorcycle Third Party",
  //     content:
  //         "Salaam Takaful Limited offers Motorcycle Third Party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under the Motor Vehicle Act 1939.",
  //     image: "https://asset.salaamtakaful.com/GeneralAssets/motortabs/bikes.jpg",
  //     heading1: "Coverages",
  //     Coverages: [
  //         {
  //             id: "2",
  //             li: "Legal liability of the participant to third parties arising from using the motor vehicle.",
  //         },
  //         {
  //             id: "3",
  //             li: "Includes third party, only those who may be injured or killed and whose vehicle or property may be damaged.",
  //         },
  //         {
  //             id: "4",
  //             li: "Condition: Does not cover damage to the Participant's own vehicle or property or any injuries or death to the Participant. (Please revert to Comprehensive cover for complete coverage).",
  //         },
  //     ],
  // },
];

export const MiscellaneousTakaful = [
  {
    key: "1",
    mainheading: "Salaam Burglary Takaful",
    content:
      "This policy provides coverage of loss and/or damage to the participant’s property whilst within the business premises against the risks of Theft/Burglary consequent upon forcible and violent entry. The policy also covers damage to the premises resulting from attempted Theft/Burglary. The policy is however issued only in conjunction with the fire and allied perils policy.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamBurglary.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamBurglaryCover.jpg",
    // heading1: 'Key features of Pay As You Drive are',
    // heading2: 'Coverages ',
    // Coverages: [
    //     {
    //         id: "2",
    //         li: 'Upfront Contribution Amount of Rs. 10,000/- only',
    //     },
    //     {
    //         id: "3",
    //         li: 'Free Tracker worth Rs. 20,000/-  ',
    //     },
    //     {
    //         id: "4",
    //         li: '12-month Installment Plan ',
    //     },
    //     {
    //         id: "5",
    //         li: 'Variable Contribution Amount (Pay only when you drive) ',
    //     },
    // ],

    // OptionalBenefits: [
    //     {
    //         id: "1",
    //         li: '100% Settlement of claims within 7 days',

    //     },
    //     {
    //         id: "2",
    //         li: 'No Requirement of Police Final Report',

    //     },
    //     {
    //         id: "3",
    //         li: 'Accident Damages',

    //     },
    //     {
    //         id: "4",
    //         li: 'Accessories Theft',

    //     },
    //     {
    //         id: "5",
    //         li: 'Burglary & Theft',

    //     },
    //     {
    //         id: "6",
    //         li: 'Fire External Explosion',

    //     },
    //     {
    //         id: "7",
    //         li: 'Total Loss',

    //     },
    //     {
    //         id: "8",
    //         li: 'Theft/Snatch',

    //     },
    //     {
    //         id: "9",
    //         li: 'Natural Catastrophes (Earthquake, Flood, Hail, Wind, etc.)',

    //     },
    //     {
    //         id: "10",
    //         li: 'Riots & Strike Damage',

    //     },
    //     {
    //         id: "11",
    //         li: 'Risk Of Terrorism',

    //     },
    //     {
    //         id: "12",
    //         li: 'Third-Party Coverage Death Bodily Injury',

    //     },
    //     {
    //         id: "13",
    //         li: 'Property Damages',

    //     },
    //     {
    //         id: "14",
    //         li: 'Emergency Medical Expenses',

    //     },
    //     {
    //         id: "15",
    //         li: 'In-house surveyors',

    //     },
    //     {
    //         id: "16",
    //         li: 'Salaam App',

    //     },
    //     {
    //         id: "17",
    //         li: 'Self-Assessment at an approved dealership',

    //     },
    // ]
  },
  {
    key: "2",
    mainheading: "Salaam Fidelity Takaful",
    content:
      "This policy is designed to provide coverage against acts of the risk of misappropriation or embezzlement committed by the permanent and authorized employees in the course of their employment for the participant on permanent payroll.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamFidelity.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamFidelityCover.jpg",
  },
  {
    key: "3",
    mainheading: "Salaam Plate Glass Takaful",
    content:
      "Coverage under this policy includes breakage (which does not include damage by scratching) of any glass installed at the premises specified. The policy also covers any writing or ornamentation on glass if specifically described for coverage.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamPlateGlass.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamPlateGlassCover.jpg",
  },
  {
    key: "4",
    mainheading: "Salaam Third-party Liability Takaful",
    content:
      "The policy covers the legal liability of the participant in respect of death &/or bodily injury and/or loss or damage to the third party and/or its property (other than the participant &/or his employees) as a direct result of an accident arising at the participant’s specified premises.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamThirdPartyLiability.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamThirdPartyLiabilityCover.jpg",
  },
  {
    key: "5",
    mainheading: "Salaam Money Takaful",
    content:
      "The policy covers loss or destruction of or damage to money whilst in transit between various specified locations. The policy can also be extended to cover money whilst in premises during and after working hours and in residence overnight. In addition, it may also cover loss of or damage to the safe or strong room because of theft or attempted theft or robbery.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamMoney.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamMoneyCover.jpg",
  },
  {
    key: "6",
    mainheading: "Salaam Workmen Compensation Takaful",
    content:
      "This policy is designed to indemnify the participant if at any time during the period of coverage of Takaful, any employee in the Participant’s immediate service shall sustain personal injury by accident or disease arising out of and in the course of his employment by the participant in the business and if the participant shall be liable to pay compensation for such injury either under:",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamWorkmen.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamWorkmenCover.jpg",
  },
  {
    key: "7",
    mainheading: "Salaam Product Liability Takaful",
    content:
      "This policy provides coverage for claims made against the participant by the third party arising out of products manufactured/ sold by the participant.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamProductLiability.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamProductLiabilityCover.jpg",
  },
  {
    key: "8",
    mainheading: "Salaam Directors’ & Officers' Takaful",
    content:
      "This policy provides coverage to directors and officers for claims made against them while serving on a board of directors and/or as an officer for any actual or alleged act or omission, error, misstatement, misleading statement, neglect or breach of duty by the covered person in the discharge of his/her duties. ",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamDirector.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamDirectorCover.jpg",
  },
];

export const EngineeringTakaful = [
  {
    key: "1",
    mainheading: "Contractors’ All-Risk Takaful",
    content:
      "Contractors’ All Risks policy offers comprehensive and adequate protection against any accidental mishap in connection with the execution of a building or civil engineering project. It covers unforeseen and sudden physical loss of or damage to contract works, construction plant and equipment, and/or construction machinery. The cover may extend for the participant’s surrounding property, third-party property damage and bodily injury, clearance of debris, the extra cost of overtime, express delivery, or air freight in connection with repairs or replacement.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/ContractorsRisk.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/ContractorsRiskCover.jpg",
    heading1: "",
    Coverages: [
      {
        id: "1",
        li: "Fire",
      },
      {
        id: "2",
        li: "Lightening",
      },
      {
        id: "3",
        li: "Explosion",
      },
      {
        id: "4",
        li: "Earthquake, landslide, storm, flooding etc.",
      },
      {
        id: "5",
        li: "Malicious damage",
      },
      {
        id: "6",
        li: "Lack of skill",
      },
      {
        id: "4",
        li: "Incorrect supervision",
      },
      {
        id: "5",
        li: "Theft",
      },
    ],
  },
  {
    key: "2",
    mainheading: "Electronic Equipment’s Takaful",
    content:
      "Electronic Equipment policy gives the widest possible cover appropriate for the exposure of electronic equipment to everyday operational hazards as well as catastrophic losses. It provides cover against losses arising from unforeseen and sudden physical loss or damage to electronic equipment. Policy may extend to cover external data media including magnetic discs & tapes, diskettes and the information stored thereon",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/ElectronicEquipment.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/ElectronicEquipmentCover.jpg",
    heading1: "",
    Coverages: [
      { id: "1", li: "Fire" },
      { id: "2", li: "Lightening" },
      { id: "3", li: "Explosion" },
      { id: "4", li: "Falling aircraft" },
      { id: "5", li: "Short-circuit" },
      { id: "6", li: "Electrical causes" },
      { id: "7", li: "Design, manufacturing" },
      { id: "8", li: "Assembly & erection faults" },
      { id: "9", li: "Defects in casting and material" },
      { id: "10", li: "Workshop errors" },
      { id: "11", li: "Bad workmanship" },
      { id: "12", li: "Faulty operation" },
      { id: "13", li: "Lack of skill" },
      { id: "14", li: "Malicious acts of workmen" },
      { id: "15", li: "Burglary" },
    ],
  },
  {
    key: "3",
    mainheading: "Computer All Risks Takaful",
    content:
      "Technology is getting more advanced day by day, especially in the field of computers where we are facing high values concentrated in small spaces with delicacy and susceptibility to damage. Computer all risks policy covers unforeseen and sudden loss of or damage to computers from any accidental cause except those specifically excluded in the policy whilst at work or at rest or while being dismantled for the purpose of cleaning, inspection, and overhauling or subsequent re-erection.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/Computer.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/ComputerCover.jpg",
  },
  {
    key: "4",
    mainheading: "Boiler and Pressure Vessel Takaful",
    content:
      "A boiler stores up tremendous energy which, on being suddenly released by the explosion, causes extensive damage and injury. The Boiler and Pressure Vessel policy covers boilers and pressure Vessels against explosion and collapse or distortion by bending or crushing caused by steam or fluid pressure. The policy may extend to cover the damages to surrounding property, liability to third parties and legal expenses where legal proceedings in connection with a claim have been defended.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets//Assets/img/singleproduct/Boiler.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/BoilerCover.jpg",
  },
  {
    key: "5",
    mainheading: "Machinery Breakdown Takaful",
    content:
      "Most plants and machinery form a sizeable proportion of the capital outlay of any industrial concern. The plant and machinery are exposed daily to operational hazards. Machinery breakdown policy covers unforeseen and sudden physical loss or damage with respect to risks such as defects in casting & material, faulty design, bad workmanship, carelessness, physical explosion, short circuit, lack of skill, storm, falling, impact, collision etc. The cover may extend to the participant’s surrounding property, third-party property damage and third-party bodily injury.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/MachineryBreakdown.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/MachineryBreakdownCover.jpg",
  },
  {
    key: "6",
    mainheading: "Contractors' Plant and Machinery Takaful",
    content:
      "Plants and machinery are widely in use these days. Contractors’ Plant and Machinery Policy cover loss or damage occurring at work, at rest or during maintenance operations of contractors' plant & machinery against all risks such as fire, lightning, explosion, theft, malicious damage, impact, collision, overturning etc. Cover may extend for the extra cost of overtime and holiday rates of pay, express delivery or air freight in connection with repairs or replacements.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/ContractorsPlant.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/ContractorsPlantCover.jpg",
  },
  {
    key: "7",
    mainheading: "Loss of Profit Following Machinery Breakdown Takaful",
    content:
      "When a key item of machinery in a factory breaks down, the owner is faced not only with an expensive repair but also with a continuing interruption of his business. With increasingly sophisticated machinery and longer delivery periods from makers, any such interruption is a cause of great concern to the owners, especially when the cash flow dries up, standing charges are not met, wages remain to be paid and creditors and shareholders are looking for a profit. To overcome all these situations, the Loss of Profit policy provides protection in respect of loss of gross profit to the business following an accident to the machinery. This loss is measured by comparison of the turnover with the comparable position in the previous twelve months, after allowing for trends in the business and other relevant factors. The increased cost of working incurred to save a loss of gross profit is also covered.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets//Assets/img/singleproduct/LossofProfit.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/LossofProfitCover.jpg",
  },
];

export const Sehat = [
  {
    key: "1",
    mainheading: "SALAAM SEHAT REGULAR",
    setheading: "Salaam Sehat Regular",
    content:
      "Salaam Sehat Regular is affordable health protection designed with your family in mind. Salaam Sehat Regular provides essential Takaful coverage for individuals and their families, including spouses and children. Offering reliable healthcare solutions at a cost that fits your budget, Salaam Sehat Regular is your partner in maintaining a healthy, worry-free life.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamSehatRegular.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamSehatRegularCover.jpg",
    heading1: "Coverages",
    Coverages: [
      {
        id: "2",
        li: "Hospitalization or in-patient treatment (list of covered expenses given in the Policy Document)",
      },
      {
        id: "3",
        li: "Accidental emergency treatment",
      },
      {
        id: "4",
        li: "Day care procedures (e.g. Endoscopy, Dialysis, etc.). Complete list of procedures covered is provided with the Policy Document",
      },
      {
        id: "5",
        li: "Specialized investigative procedures (e.g. Angiography, MRI, CT Scan, etc.).A Complete list of procedures covered is provided with the Policy Document",
      },
      {
        id: "6",
        li: "Optional Maternity Coverage available",
      },
      {
        id: "7",
        li: "Optional Critical Illnesses Coverage available",
      },
    ],
  },

  {
    key: "2",
    mainheading: "SALAAM SEHAT PLUS",
    setheading: "Salaam Sehat Plus",

    content:
      "Experience the peace of mind that comes with comprehensive health coverage. Salaam Sehat Plus offers extensive protection with generous limits, tailored to meet the demands of your fast-paced life. Whether it's routine check-ups or unexpected medical expenses, Salaam Sehat Plus ensures that you and your loved ones are well taken care of.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamSehatPlus.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamSehatPlusCover.jpg",
    heading1: "Coverages",
    Coverages: [
      {
        id: "2",
        li: "Hospitalization or in-patient treatment (list of covered expenses given in the Policy Document)",
      },
      {
        id: "3",
        li: "Accidental emergency treatment",
      },
      {
        id: "4",
        li: "Day care procedures (e.g. Endoscopy, Dialysis, etc.). Complete list of procedures covered is provided with the Policy Document",
      },
      {
        id: "5",
        li: "Specialized investigative procedures (e.g. Angiography, MRI, CT Scan, etc.). Complete list of procedures covered is provided with the Policy Document",
      },
      {
        id: "6",
        li: "Optional Maternity Coverage available",
      },
      {
        id: "7",
        li: "Optional Critical Illnesses Coverage available",
      },
      {
        id: "8",
        li: "25% Pre-Existing Conditions Coverage as soon as the policy starts",
      },
      {
        id: "9",
        li: "OPD Coverages",
      },
      {
        id: "10",
        li: "Additional Death Benefit",
      },
    ],
  },
  {
    key: "3",
    mainheading: "SALAAM MADADGAR",
    setheading: "Salaam Madadgar",

    content:
      "Our domestic helpers go above and beyond to care for our needs, becoming cherished members of our households. Their well-being is essential, as their health directly impacts not only their lives but also the well-being of our own families. With Salaam Madadgar, you can ensure that those who support you are equally supported with comprehensive health coverage.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamMadadgar.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamMadadgarCover.jpg",
    heading1: "Coverages",
    Coverages: [
      {
        id: "2",
        li: "Hospitalization or In-patient Treatment (list of covered expenses given in the Policy Document)",
      },
      {
        id: "3",
        li: "Accidental Emergency Treatment",
      },
      {
        id: "4",
        li: "Day Care Procedures (e.g. Endoscopy, Dialysis, etc.).",
      },
      {
        id: "5",
        li: "Pre-Hospitalization (Diagnosis, Consultation, Medicine) up to 30 days",
      },
      {
        id: "6",
        li: "Post-Hospitalization (Diagnosis, Consultation, Medicine) up to 30 days",
      },
      {
        id: "7",
        li: "Specialized Investigative Procedures (e.g. Angiography, MRI, CT scan, etc.).",
      },
      {
        id: "8",
        li: "Personal Accident Benefits is provided in case of death due to an accident (up to 60 years of age)",
      },
      {
        id: "9",
        li: "Complete list of procedures covered is provided with the Policy Document.",
      },
      {
        id: "10",
        li: "Ambulance Cover",
      },
      {
        id: "11",
        li: "Accidental Death Benefit",
      },
      {
        id: "12",
        li: "A Complete list of procedures covered is provided with the Policy Document.",
      },
    ],
  },
];

export const Forplanned = [
  {
    key: "1",
    heading: "To lodge a claim",
    text: "Show Health card for claim at Panel Hospital / Facility.File claim in case of utilizing non panel Facility / Hospital.",
  },

  {
    key: "2",
    heading: "Inform us",
    text: "Inform us 24-48 hours prior to your Admission date.",
  },

  {
    key: "3",
    heading: "Claim Form",
    text: "To download the claim form: Click Here",
    link: "https://asset.salaamtakaful.com/GeneralAssets/Assets/pdf/SalaamHealthClaimForm.pdf",
  },

  {
    key: "4",
    heading: "Copy of necessary documents to be attached with the form",
    text: "Health card and CNIC need.Original Hospital itemized bill with stamp and all original cash receipts Copies of prescriptions, tests reports, birth/death certificates need to be attached where required.",
  },

  {
    key: "5",
    heading: "Acceptance of Claim",
    text: "Our Medical Team will evaluate your case. We’ll authorize it in line with your policy plan. You will avail the treatment and get discharged from the hospital.",
  },
];

export const ForEmergency = [
  {
    key: "1",
    text: "Need for medical treatment in hospital as advised by qualified doctor through OPD/emergency",
  },

  {
    key: "2",
    text: "Visit nearest network / panel hospital for the treatment.",
  },

  {
    key: "3",
    text: "Present Health card and CNIC (copies may be retained by hospital for billing)",
  },

  {
    key: "4",
    text: "Hospital will take approval from Salaam Takaful Health Card through email/phone, as per plan/ entitlement of Patient",
  },

  {
    key: "5",
    text: "Sign the bill preferably at the time of discharge and pay the difference if any (room or limit difference)",
  },
];

export const Travel = [
  // {
  //     key: "1",
  //     mainheading: "SALAAM DOMESTIC TRAVEL TAKAFUL",
  //     setheading: "Salaamti Tour",

  //     content:
  //         "The beauty of our mountains, rivers and seas, the hospitality of our people, the depth of Pakistani culture and the rich flavors of our foods, all combine to make domestic travel within Pakistan an adventure of a lifetime. In your journey of exploring your beautiful homeland, let us safeguard you against unwelcome financial tensions related to your health and travel arising during the period of your trip.",
  //     image:
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamDomesticTravelTakaful.jpg",
  //     coverImage:
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamDomesticTravelTakafulCover.jpg",
  //     heading1: "Coverages",
  //     heading2: "Extended Coverages",
  //     Coverages: [
  //         {
  //             id: "2",
  //             li: "Accidental Death & Permanent Total Disability",
  //         },
  //         {
  //             id: "3",
  //             li: "Accidental Medical Reimbursement ",
  //         },
  //         {
  //             id: "4",
  //             li: "Emergency Medical Evacuation ",
  //         },
  //         {
  //             id: "5",
  //             li: "Repatriation of mortal remains",
  //         },
  //         {
  //             id: "6",
  //             li: "Loss of checked-in baggage",
  //         },
  //         {
  //             id: "7",
  //             li: "Loss of C.N.I.C",
  //         },
  //         {
  //             id: "8",
  //             li: "Home protection whilst traveling",
  //         },
  //     ],
  //     Extended: [
  //         {
  //             id: "1",
  //             li: "COVID-19, Adventure sports and Terrorism",
  //         },
  //     ],
  // },
  {
    key: "1",
    travelId: "H",
    mainheading: "SALAAM HAJJ AND UMRAH TRAVEL TAKAFUL",

    setheading: "Salaam Hajj and Umrah Travel Takaful",

    content:
      "Hoping to get connected with Allah in heart, mind and spirit? In such an ethereal experience, do you have any time for worldly worries related to your health or the protection of your assets? Salaam Takaful Hajj and Umrah cover provides you the opportunity to forsake those fears to us. We will provide you with medical, non-medical and travel assistance in the place of your travels. So that your pilgrimage is free from worldly stress.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamHajjandUmrahTravelTakaful.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamHajjandUmrahTravelTakafulCover.jpg",
    heading1: "Coverages",
    Coverages: [
      {
        id: "2",
        li: "Personal Accident",
      },
      {
        id: "3",
        li: "Medical Expenses & Hospitalization Abroad",
      },
      {
        id: "4",
        li: "Medical Evacuation",
      },
      {
        id: "5",
        li: "Emergency Dental Care",
      },
      {
        id: "6",
        li: "Repatriation of Family Member Traveling with the Participant",
      },
      {
        id: "7",
        li: "Repatriation of mortal remains",
      },
      {
        id: "8",
        li: "Return of Dependant Children",
      },
      {
        id: "9",
        li: "Travel and Stay Over of One Immediate Family Member",
      },
      {
        id: "10",
        li: "Emergency Return Home Following Death of Close Family Member",
      },
      {
        id: "11",
        li: "Personal Liability",
      },
      {
        id: "12",
        li: "Loss of Passport",
      },
      {
        id: "13",
        li: "Trip Cancellation",
      },
      {
        id: "14",
        li: "Delayed Departure",
      },
      {
        id: "15",
        li: "Loss of Checked-In Baggage",
      },
      {
        id: "16",
        li: "Compensation for delay in the arrival of luggage",
      },
      {
        id: "17",
        li: "Home Protection Whilst Traveling",
      },
    ],
  },
  {
    key: "2",
    mainheading: "SALAAM INTERNATIONAL TRAVEL TAKAFUL",
    setheading: "Salaamti Trip",
    travelId: "I",

    content:
      "Ensuring your safety must be the first step in your quest to explore the world. While navigating the world's uncertainties, be sure that we will have your back regarding your medical, non-medical and travel needs. With our Schengen Compliant Plan and the Support of Swan International Assistance – an international travel assistance company, no international boundary can stop us from coming to your aid.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamInternationalTravelTakaful.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamInternationalTravelTakafulCover.jpg",
    heading1: "Coverages",
    heading2: "Extended Coverages",
    Coverages: [
      {
        id: "2",
        li: "Personal Accident",
      },
      {
        id: "3",
        li: "Medical Expenses & Hospitalization Abroad ",
      },
      {
        id: "4",
        li: "Medical Evacuation ",
      },
      {
        id: "5",
        li: "Emergency Dental Care",
      },
      {
        id: "6",
        li: "Repatriation of Family Member Traveling with the Participant",
      },
      {
        id: "7",
        li: "Repatriation of mortal remains ",
      },
      {
        id: "8",
        li: "Return of Dependant Children",
      },
      {
        id: "9",
        li: "Travel and Stay Over of One Immediate Family Member ",
      },
      {
        id: "10",
        li: "Emergency Return Home Following Death of Close Family Member ",
      },
      {
        id: "11",
        li: "Personal Liability ",
      },
      {
        id: "12",
        li: "Loss of Passport ",
      },
      {
        id: "13",
        li: "Trip Cancellation ",
      },
      {
        id: "14",
        li: "Delayed Departure ",
      },
      {
        id: "15",
        li: "Loss of Checked-In Baggage ",
      },
      {
        id: "15",
        li: "Compensation for delay in the arrival of luggage",
      },
      {
        id: "16",
        li: "Home Protection Whilst Traveling ",
      },
    ],
    Extended: [
      {
        id: "8",
        li: "Extended coverage: COVID-19, Adventure sports and Terrorism",
      },
    ],
  },
];

export const Crops = [
  {
    key: "1",
    mainheading: "SALAAM CROP ZARAI TAKAFUL",
    content:
      "From the time the farmer sows the seed to the time that the plant bears fruit and is harvested, all the hopes and dreams of the farmers are associated with their crop. Our product protects the monetary investment the farmer has put into growing the crop in case a natural disaster wipes it all away so that the farmers’ hopes and dreams are not fractured beyond repair.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropZaraiTakaful.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropZaraiTakafulCover.jpg",
    heading1: "Coverages",
    heading2: "Extended Coverage",
    heading3: "",
    heading4: "",
    text: "",
    Coverages: [
      {
        id: "3",
        li: "Flood ",
      },
      {
        id: "4",
        li: "Excessive rain",
      },
      {
        id: "5",
        li: "Windstorm ",
      },
      {
        id: "6",
        li: "Hail",
      },
      {
        id: "7",
        li: "Frost",
      },
      {
        id: "8",
        li: "Drought",
      },
      {
        id: "9",
        li: "Locust attack",
      },
      {
        id: "10",
        li: "Pest Attack",
      },
      {
        id: "11",
        li: "Earthquake",
      },
      {
        id: "12",
        li: "Diseases, like viral and bacterial attacks, and insect attack caused by excessive rain and flood preventing spraying.",
      },
    ],

    OptionalBenefits: [
      {
        id: "1",
        li: "Free Crop Advisory Services",
      },
      {
        id: "2",
        li: "Free Weather Updates",
      },
      {
        id: "3",
        li: "Farmers and their Households will have free access to doctor consultation through Salaam App 24/7",
      },
    ],
  },

  {
    key: "2",
    mainheading: "SALAAM CROP PARAMETRIC TAKAFUL",
    content:
      "Salaam Takaful is dedicated to improving the lives of smallholder farmers and enhancing agricultural efficiency in Pakistan. Our Crop Parametric Takaful aligns with UN Sustainable Development Goals, ensuring resilience against climate change's adverse effects and supporting food security. This innovative coverage aids vulnerable communities, mitigates hunger, and empowers farmers to recover from disasters without government declarations or manual assessments. Our farmer-friendly coverage offers mid-season payouts, no government calamity declaration, individual risk assessment, and eliminates manual loss evaluations. Our pricing is extremely customizable, flexible, and depending upon the needs and coverages of the farmers. The pricing process and parameter setting is also transparent.",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropParametricTakaful.jpg",
    coverImage:
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropParametricTakafulCover.jpg",
    heading1: "Coverages",
    heading2: " Extended Coverage",
    heading3: "",
    heading4: "",
    text: "",
    Coverages: [
      {
        id: "2",
        li: "Drought",
      },
      {
        id: "3",
        li: "Excess Rainfall",
      },
      {
        id: "4",
        li: "Flood",
      },
      {
        id: "5",
        li: "Heat",
      },
      {
        id: "5",
        li: "Wind",
      },
      {
        id: "5",
        li: "Locust Attack",
      },
    ],

    OptionalBenefits: [
      {
        id: "1",
        li: "Remote Farm Health Monitoring and Analysis (with farm insights)",
      },
      {
        id: "2",
        li: "Crop Advisory",
      },
      {
        id: "2",
        li: "Weather Index Tracking",
      },
      {
        id: "2",
        li: "Farmers and their Households will have free access to doctor consultation through Salaam App 24/7",
      },
    ],
  },

  // {
  //     key: '3',
  //     mainheading: 'SALAAM CROP ZARAI TAKAFUL',
  //     content: 'From the time the farmer sows the seed to the time that the plant bears fruit and is harvested, all the hopes and dreams of the farmers are associated with their crop. Our product protects the monetary investment the farmer has put into growing the crop in case a natural disaster wipes it all away so that the farmers’ hopes and dreams are not fractured beyond repair.',
  //     image: 'https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropZaraiTakaful.jpg',
  //     coverImage: 'https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropZaraiTakafulCover.jpg',
  //     heading1: 'Coverages',
  //     heading2: 'Extended Coverage',
  //     heading3: '',
  //     heading4: "",
  //     text: "",
  //     Coverages: [
  //         {
  //             id: "3",
  //             li: 'Flood ',
  //         },
  //         {
  //             id: "4",
  //             li: 'Excessive rain',
  //         },
  //         {
  //             id: "5",
  //             li: 'Windstorm ',
  //         },
  //         {
  //             id: "6",
  //             li: 'Hail',
  //         },
  //         {
  //             id: "7",
  //             li: 'Frost',
  //         },
  //         {
  //             id: "8",
  //             li: 'Drought',
  //         },
  //         {
  //             id: "9",
  //             li: 'Locust attack',
  //         },
  //         {
  //             id: "10",
  //             li: 'Pest Attack',
  //         },
  //         {
  //             id: "11",
  //             li: 'Earthquake',
  //         },
  //         {
  //             id: "12",
  //             li: 'Diseases, like viral and bacterial attacks, and insect attack caused by excessive rain and flood preventing spraying.',
  //         },
  //     ],

  //     OptionalBenefits: [
  //         {
  //             id: "1",
  //             li: 'Free Crop Advisory Services',
  //         },
  //         {
  //             id: "2",
  //             li: 'Free Weather Updates',
  //         },
  //         {
  //             id: "3",
  //             li: 'Farmers and their Households will have free access to doctor consultation through Salaam App 24/7',
  //         },
  //     ]
  // },

  // {
  //     key: '4',
  //     mainheading: 'SALAAM CROP PARAMETRIC TAKAFUL',
  //     content: "Salaam Takaful is dedicated to improving the lives of smallholder farmers and enhancing agricultural efficiency in Pakistan. Our Crop Parametric Takaful aligns with UN Sustainable Development Goals, ensuring resilience against climate change's adverse effects and supporting food security. This innovative coverage aids vulnerable communities, mitigates hunger, and empowers farmers to recover from disasters without government declarations or manual assessments. Our farmer-friendly coverage offers mid-season payouts, no government calamity declaration, individual risk assessment, and eliminates manual loss evaluations. Our pricing is extremely customizable, flexible, and depending upon the needs and coverages of the farmers. The pricing process and parameter setting is also transparent.",
  //     image: 'https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropParametricTakaful.jpg',
  //     coverImage: 'https://asset.salaamtakaful.com/GeneralAssets/Assets/img/singleproduct/SalaamCropParametricTakafulCover.jpg',
  //     heading1: 'Coverages',
  //     heading2: ' Extended Coverage',
  //     heading3: '',
  //     heading4: "",
  //     text: "",
  //     Coverages: [
  //         {
  //             id: "2",
  //             li: 'Drought',
  //         },
  //         {
  //             id: "3",
  //             li: 'Excess Rainfall',
  //         },
  //         {
  //             id: "4",
  //             li: 'Flood',
  //         },
  //         {
  //             id: "5",
  //             li: 'Heat',
  //         },
  //         {
  //             id: "5",
  //             li: 'Wind',
  //         },
  //         {
  //             id: "5",
  //             li: 'Locust Attack',
  //         },
  //     ],

  //     OptionalBenefits: [
  //         {
  //             id: "1",
  //             li: 'Remote Farm Health Monitoring and Analysis (with farm insights)',
  //         },
  //         {
  //             id: "2",
  //             li: 'Crop Advisory',
  //         },
  //         {
  //             id: "2",
  //             li: 'Weather Index Tracking',
  //         },
  //         {
  //             id: "2",
  //             li: 'Farmers and their Households will have free access to doctor consultation through Salaam App 24/7',
  //         }
  //     ]
  // },
];

export const indvidualproducts = [
  {
    key: "1",
    name: "Salaam Motor Takaful",
    link: "/individualproduct/salammotor",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/individual/motorcycle.jpg",
  },
  {
    key: "2",
    name: "Salaam Sehat Takaful",
    link: "/individualproduct/salamsehat",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/individual/health.jpg",
  },
  {
    key: "3",
    name: "Salaam Travel Takaful ",
    link: "/individualproduct/salamtravel",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/individual/travel.jpg",
  },
  {
    key: "4",
    name: " Salaam Home Takaful",
    link: "/individualproduct/salamhome",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/individual/home.jpg",
  },
  {
    key: "5",
    name: "Salaam Personal Accident Takaful",
    link: "/individualproduct/salampersonal",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/individual/personal-accident.jpg",
  },
  // {
  //   key: "6",
  //   name: "Salaam Pet Takaful",
  //   link: "/individualproduct/salampet",
  //   feature:
  //     "https://asset.salaamtakaful.com/GeneralAssets/individual/PetTakafulBanner.jpg",
  // },
];

export const corporates = [
  // {
  //   key: "1",
  //   name: "Salaam Group Health Takaful",
  //   link: "/corporateproduct/salaam-group-health",
  //   feature:
  //     "https://asset.salaamtakaful.com/GeneralAssets/corporate/group-health.jpg",
  // },
  // {
  //   key: "2",
  //   name: "Salaam Crop Takaful",
  //   link: "/corporateproduct/salamcrop",
  //   feature:
  //     "https://asset.salaamtakaful.com/GeneralAssets/individual/crop.jpg",
  // },
  {
    key: "3",
    name: "Salaam Livestock Takaful",
    link: "/corporateproduct/salamlivestock",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/individual/livestock.jpg",
  },
  {
    key: "4",
    name: " Salaam Fire Takaful",
    link: "/corporateproduct/salam-fire",
    feature: "https://asset.salaamtakaful.com/GeneralAssets/corporate/fire.jpg",
  },
  {
    key: "5",
    name: "Salaam Marine Takaful",
    link: "/corporateproduct/salam-marine",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/corporate/marine.jpg",
  },
  {
    key: "6",
    name: "Salaam Engineering Takaful ",
    link: "/corporateproduct/salam-engineering",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/corporate/engineering.jpg",
  },
  {
    key: "7",
    name: "Salaam Miscellaneous Takaful",
    link: "/corporateproduct/salam-miscellaneous",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/corporate/miscellaneous.jpg",
  },
];

export const financials = [
  {
    key: "1",
    name: "Salaam Bankers Blanket Takaful",
    link: "/financialproduct/salaam-banker",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/financial/bankers-blanket.jpg",
  },
  {
    key: "2",
    name: "Salaam Plastic Card Takaful",
    link: "/financialproduct/salaam-plasticcard",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/financial/plastic-card.jpg",
  },
  {
    key: "3",
    name: "Salaam Safe Deposit Box Takaful Coverage ",
    link: "/financialproduct/salaam-deposit",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/financial/deposit-insurance.jpg",
  },
  {
    key: "4",
    name: "Salaam Professional Indeminity Takaful",
    link: "/financialproduct/salaam-professional",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/financial/personal-indeminity.jpg",
  },
  {
    key: "5",
    name: "Salaam Computer Crime Takaful",
    link: "/financialproduct/salaam-computer",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/financial/computer-crime.jpg",
  },
  {
    key: "6",
    name: "Salaam Cyber Risk Takaful",
    link: "/financialproduct/salaam-cyber",
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/financial/cyber-risk.jpg",
  },
];

export const SalaamDirectors = [
  {
    key: "1",
    name: "Mr. Salim Habib Godil ",
    designation: "Chairman",
    detail:
      "Mr. Salim Habib Godil, a renowned entrepreneur, has diverse business interests in sectors such as automotive, construction, real estate, transportation, mobility, travel, and security solutions. His notable achievements include owning the largest Toyota retail dealership in the country and serving as the Chairman of Pak Limousine Services, the pioneering radio cab business in Pakistan. Additionally, Mr. Godil holds the position of Chairman at Armored Vehicles Pakistan (formerly Striet Pakistan), the largest privately owned armored vehicle manufacturer in Pakistan. Recognizing his outstanding contributions to significant public endeavors, he has been honored with the prestigious Hilal-e-Imtiaz, one of Pakistan`s highest civilian awards. Furthermore, Mr. Godil is a Certified Director and being the Chairman of the board, is committed to corporate governance of the highest order.",
    animation: "horizontal",
    caranim: "up",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/directors/SaleemGrey.jpg",
  },

  {
    key: "2",
    name: "Mr. Rizwan Hussain",
    designation: "Director & Vice Chairman",
    detail:
      "Mr. Rizwan Hussain is a seasoned professional with over 35 years of exceptional experience in leadership roles within the local and foreign insurance sectors. With a track record of success in product innovation and business networks expansion, Mr. Rizwan quickly rose through the ranks, assuming multiple departmental responsibilities early in his career. In 2018, he took on the esteemed position of Managing Director and CEO of Salaam Takaful Limited, where he has remained steadfast in his commitment to growth, adaptation, and innovation within the industry. His unwavering focus is to shape the future of insurance and takaful, providing unparalleled customer experiences, and fostering resilient communities with utmost transparency and stanch adherence to corporate governance. Under his leadership, Salaam Takaful is now the largest general takaful operator and the first Islamic insurtech in Pakistan. His vision extends beyond his own organization, as he also serves as a Director on the Board of Amana Takaful Insurance in Sri Lanka. Being a Certified Director, he embodies the highest standards of professional competence and governance.",
    animation: "vertical",
    caranim: "up",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/directors/RizwanGrey.jpg",
  },

  {
    key: "3",
    name: "Mr. Shahzad Salim Godil",
    designation: "Director",
    detail:
      "Mr. Shahzad Salim Godil, a graduate in business management, economics, and entrepreneurship from Clark University, Massachusetts, has made significant contributions as director in a prestigious conglomerate in Pakistan. His visionary leadership has been pivotal in the Group`s expansion into diverse sectors such as construction, transportation and mobility, and travel. Mr. Godil brings an entrepreneurial mindset to the Board. He also holds Director positions in prominent companies including Toyota retail dealerships, Pak Limousine Services, Armored Vehicles Pakistan (formerly Striet Pakistan), Metro Security Services (Pvt.) Ltd, Central Facilitation Agency (Pvt.) Ltd, Automall, and Central Builders and Developers. He is also a Certified Director.",
    animation: "horizontal",
    caranim: "up",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/directors/SalimGodilGrey.jpg",
  },

  {
    key: "4",
    name: "Syed Salman Hussain",
    designation: "Director",
    detail:
      "Mr. Salman Hussain is a mechanical engineering graduate from NED University, Karachi, and holds a master’s in business from Cranfield University, United Kingdom. He is the Founder and CEO of iTecknologi Group of Companies, a prominent technology conglomerate in Pakistan. With a strong background in technology, Mr. Salman has gained valuable management consulting experience with McKinsey Middle East. He has provided consultations to numerous state-owned and private firms in the Middle East and the wider region, including the International Finance Corporation and World Bank. Additionally, he is a Certified Director.",
    animation: "vertical",
    caranim: "down",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/directors/SalmanSahabGrey.jpg",
  },

  {
    key: "5",
    name: "Mr. Faisal Murad ",
    designation: "Director",
    detail:
      "With over 21 years of diverse professional experience in the retail business segment, Mr. Faisal Murad plays a crucial role in supporting HBFC`s vertically integrated business objectives through strategic initiatives. Throughout his career, he has held management positions in renowned organizations such as KASB Technology Limited, KASB Bank Limited, IGI Investment Bank Limited, MCB Bank Limited, Global Securities Pakistan Limited, and Summit Bank Limited, where he provided leadership and strategic direction. Mr. Faisal`s commitment to continuous growth is reflected in his participation in advanced-level trainings from prestigious national and international institutions. He holds an MBA (Marketing) and a B.Sc. (Computer Science) from reputable institutions in the country and is a Certified Director.",
    animation: "horizontal",
    caranim: "down",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/directors/FaisalGrey.jpg",
  },

  // {
  //     key: "6",
  //     name: 'Mr. Tamim Shabbir',
  //     designation: 'Director',
  //     detail: 'Mr. Tamim Shabbir (FCA) is the Chief Financial Officer of Al Baraka Pakistan Bank. He brings with him a wealth of experience spanning over 23 years in Banking, Finance, Audit, and Tax functions. Prior to joining Al Baraka Bank, he held Financial Control roles at Meezan Bank and Faysal Bank. Mr. Shabbir has also contributed his expertise to Ernst and Young, United Kingdom, and completed his Chartered Accountancy training at A.F Ferguson & Co (a member firm of Price Waterhouse Coopers). He is a distinguished Fellow member of the Institute of Chartered Accountants of Pakistan (ICAP) and has also obtained his Chartered Management Accountancy certification from the Chartered Institute of Management Accountants (CIMA), United Kingdom.',
  //     animation: 'vertical',
  //     caranim: "down",
  //     image: "https://asset.salaamtakaful.com/GeneralAssets/directors/tamim.png"
  // },

  {
    key: "6",
    name: "Dr. Irum Saba",
    designation: "Director",
    detail:
      "Dr. Irum Saba, an accomplished professional with over 17 years of experience in regulatory affairs, research, training, and teaching, has made significant contributions to internationally renowned organizations. Currently serving as an Associate Professor in the Department of Finance and Program Director of MS Islamic Banking and Finance at the Institute of Business Administration (IBA), Karachi, she holds the distinction of being the first Pakistani female to be a part of the International Shariah Advisory Board in South East Asia and the Middle East. Her noteworthy achievements have been recognized with the title of WOMENi Pakistan, acknowledging her significant contributions to the Islamic Finance Industry in Pakistan and globally. Dr. Irum Saba has also been honored by being included in the esteemed list of top 10 Influential Women in Islamic Business & Finance 2021. Dr. Irum Saba is a Chartered Islamic Finance Professional (CIFP) and holds a PhD in Islamic Finance from INCEIF. She is a member of the Grand Council of the Chartered Institute of Islamic Finance Professionals (CIIF) in Malaysia and is also a Shariah-registered financial planner (Shariah RFP). Additionally, she has earned a master’s and PGD in Islamic banking and insurance from the Institute of Islamic Banking and Insurance (IIBI), London. Dr. Irum has authored numerous articles and book chapters on management, corporate governance, Islamic finance, and microfinance. Moreover, she is a Certified Director.",
    animation: "horizontal",
    caranim: "up",
    image: "https://asset.salaamtakaful.com/GeneralAssets/directors/saba.jpg",
  },
  {
    key: "7",
    name: "Mr. Shahid Mobin Siddiqui",
    designation: "Director",
    detail:
      "Mr. Shahid Mobin Siddiqui is a seasoned professional with over 20 years of extensive experience in Law, Corporate Affairs, and Regulatory Compliance. Renowned for his exceptional leadership and strategic vision, Mr. Siddiqui currently serves as the Company Secretary and Head of Legal Affairs at Al Baraka Bank (Pakistan) Limited (ABPL). In this pivotal role, he expertly oversees the bank’s legal, corporate, and regulatory functions, providing invaluable guidance on complex legal matters while ensuring robust corporate governance and compliance frameworks.",
    detail1:
      "In addition to his core responsibilities, he is currently serving as the Secretary of Board Executive Committee (BEC) and previously served as Secretary to key Board Committees, including the Board Pakistan Capital Increase Committee (BPCIC), and Board Nomination & Remuneration Committee (BN&RC).",
    detail2:
      "He is also the Chairperson of Management Disciplinary Action Committee (DAC),  Member of MANCOM, CCM and SAMCOM and his contributions empower informed decision-making, strengthen governance protocols, and promote culture of accountability at the highest levels of the organization.",
    detail3:
      "Throughout his distinguished career, Mr. Siddiqui has held leadership positions at prominent financial institutions namely Meezan Bank, Faysal Bank, Soneri Bank and Samba Bank. These roles have equipped him with unparalleled expertise in legal strategy, compliance, and corporate governance. His proactive approach to navigating regulatory challenges and fostering collaboration among stakeholders has been instrumental in driving organizational success.",
    detail4:
      "Beyond his professional responsibilities, Mr. Siddiqui is committed to knowledge-sharing and capacity-building. He has served as a guest speaker at the National Institute of Public Administration (NIPA), Karachi, a premier institution dedicated to enhancing public sector leadership. His insights and expertise have inspired emerging leaders and contributed to the development of future industry professionals.",
    detail5:
      "Academically, Mr. Siddiqui holds an LL.M., and a Master of Public Administration (Human Resource Management) from the University of Karachi, reflecting a strong foundation in both legal and management disciplines. He is a Certified Director from the Pakistan Institute of Corporate Governance, underscoring his deep understanding of corporate governance best practices. Additionally, he has completed professional training in Leading and Managing Change at the Lahore University of Management Sciences (LUMS), further enhancing his ability to lead organizational transformation effectively.",
    detail6:
      "With his extensive experience, academic credentials, and commitment to excellence, Mr. Shahid Mobin Siddiqui continues to be a key contributor to Pakistan’s banking and legal sectors, setting benchmarks in governance and compliance practices.",
    animation: "horizontal",
    caranim: "up",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/directors/ShahidMobinSiddiqui.jpg",
  },
];
export const ManagementTeam = [
  {
    key: "1",
    name: "Mr. Nadeem Raza",
    designation: "Chief Financial Officer & Company Secretary",
    detail:
      "Mr. Nadeem Raza is the Chief Financial Officer and Company Secretary of Salaam Takaful Limited, bringing over 32 years of distinguished experience in finance, insurance, and financial services. He is widely recognized for his expertise in corporate finance, strategic planning, risk management, corporate governance, and financial transformation. Throughout his career, he has held senior executive roles at leading organizations, including UBL Insurers Limited, New Hampshire Insurance (American International Group) and Singer Pakistan, where he played a pivotal role in driving financial performance, operational efficiency, and strategic growth. His professional strengths include P&L management, treasury operations, tax strategy, capital structuring, audit oversight, SOX compliance, and revenue optimization. Mr. Raza holds a bachelor’s degree from the University of Karachi, an MBA, and multiple professional certifications, reflecting his strong commitment to financial excellence, governance, and leadership",
    animation: "horizontal",
    caranim: "up",
    image:
      "https://asset.salaamtakaful.com/GeneralTakafulAssets/management/NadeemCFO.jpg",
  },
  {
    key: "2",
    name: "Mr. Zeeshan Raza",
    designation: "Chief Executive Officer",
    detail:
      "Mr. Zeeshan M. Raza is the Chief Executive Officer of Salaam Takaful Limited, with over 30 years of extensive leadership experience in Pakistan’s insurance and takaful sectors. He is known for his strategic vision, operational excellence, and ability to drive sustainable growth and transformation. Mr. Raza holds an MBA and is a Certified Insurance Institute (CII, UK) professional, reflecting his strong technical and professional credentials. Before joining Salaam Takaful, he served as CEO of UBL Insurers Limited and Habib Insurance Company Limited, where he led significant improvements in performance, profitability, and market presence. His experience spans core insurance functions, including underwriting, marketing, information technology, human resources, and corporate strategy. Earlier in his career, he also contributed to academia as a university lecturer, highlighting his commitment to leadership development.",
    animation: "horizontal",
    caranim: "up",
    image:
      "https://asset.salaamtakaful.com/GeneralTakafulAssets/management/zeeshanrazaCEO.jpg",
  },
];

export const Esgtabss = [
  {
    key: "1",
    mainheading: "Environment",
    content:
      "On the environmental side we constantly push for a greener future, both internally & externally. Our initiatives in green financing remain relevant today as well as in the upcoming future, as we continue to minimize consumption. Salaam Takaful is also a pioneer in bringing digitization within the takaful industry, so much so, that we have made our organizational processes completely paperless, with an objective of digitizing everything to the hilt.",
    image: `${process.env.REACT_APP_URL_ASSETS}Assets/Sustainability/Environment.jpg`,
  },
  {
    key: "2",
    mainheading: "Social",
    content:
      "If we talk about the social aspect in ESG, Salaam Takaful has again a lot of feathers in the cap. Takaful itself is based on the idea of social protection which is a structure of mutual cooperation and solidarity for the purpose of protecting the weak and vulnerable in society. This reflects that our very existence is for the upliftment of the society in general. Besides, arrangement of health and wellness camps, introduction of parametric based crops for farmers resilience, launch of MTO programme for Madaris graduates and impacting thousands of lives through our health programs are few of the other notable contributions of Salaam Takaful Limited.",
    image: `${process.env.REACT_APP_URL_ASSETS}Assets/Sustainability/Social.jpg`,
  },
  {
    key: "3",
    mainheading: "Governance",
    content:
      "Governance is not something new for us. Our founders understood transparency as a key foundation and embedded those principles in our culture. For this we have spared no cost on our commitments to governance & transparency. In fact, we have tried to take those extra steps and set an example for those around us.",
    image: `${process.env.REACT_APP_URL_ASSETS}Assets/Sustainability/Governance.jpg`,
  },
];

export const Intern = [
  {
    key: "1",
    title: "Organizational Development",
    Detail: [
      {
        id: "1",
        image:
          "https://www.salaamtakaful.com/assets/images/Management/TraineeProgram.jpg",
        heading1: "Shariah General Training:",
        text1:
          "Various trainings are conducted throughout the years to inculcate adequate skills to ensure professional growth for the employees. Being a Shariah Compliant company, it is essential to understand the principles and aspects of Takaful, hence Shariah training is an important aspect of the company. The training is devised by our very own Shariah advisor, Mufti Sajjad Ashraf Usmani, which focus on the aspect and importance of having policy and procedure in accordance with the line of shariah, the operation process of how Takaful operates and its difference from conventional Insurance.",
        heading2: "Development Programs:",
        text2:
          "The purpose of the development programs is to allow our valued employees to acquire skills (such as nonverbal ques and positive thinking) which would enhance productivity and help employees in their personal and professional growth.",
        li1: "",
        li2: "",
        li3: "",
        li4: "",
        li5: "",
        li6: "",
        text3: "",
      },
    ],
  },

  {
    key: "2",
    title: "Health & Recreational Facility",
    Detail: [
      {
        id: "2",
        image:
          "https://www.salaamtakaful.com/assets/images/Management/Healthrecreational.png",
        heading1: "Health & Recreational Facility",
        text1:
          "Salaam Takaful Limited believes that healthy and energetic work force collaborates better, improves company’s productivity and generates employee satisfaction. To contribute to positive environment, keeping employee health paramount. Salaam Takaful Limited has taken multiple initiative such as:",
        heading2: "",
        text2: "",
        li1: "Initiation of “Gym” facility for all employees",
        li2: "Ramadan Iftaar",
        li3: "Yearly Picnic",
        li4: "Calories & BMI check-up at office premises",
        li5: "Adequate measure such as use of sanitizers & mask during throughout the facility",
        li6: "Availability of health professionals for assistance",
        text3: "",
      },
    ],
  },

  {
    key: "3",
    title: "CSR",
    Detail: [
      {
        id: "3",
        image: "https://www.salaamtakaful.com/assets/images/Management/CSR.png",
        heading1: " “Salaamti Humesha k lie” ",
        text1:
          "Salaam Takaful Limited, in line with its mission & Slogan has always believed in contributing to the benefit of the community and its environment. Our strategies to work towards the sustainable living can be witnessed in our initiatives as mentioned below:",
        heading2: "",
        text2: "",
        li1: "Medical Eye Camp, providing Free Eye Check to over 100 participants.",
        li2: "Blood Donation Camp",
        li3: "",
        li4: "",
        li5: "",
        li6: "",
        text3: "",
      },
    ],
  },

  {
    key: "4",
    title: "Cricket Match",
    Detail: [
      {
        id: "4",
        image:
          "https://www.salaamtakaful.com/assets/images/Management/CricketMatch.png",
        heading1: " ",
        text1:
          "Salaam Takaful Limited enthusiastically participates in various cricket tournaments throughout the year. Out of the multiple tournaments Salaam Takaful Limited cricket team, with the efforts of its teammate and leadership of their captain, have achieved the following results:",
        heading2: "",
        text2: "",
        li1: "Winner IAP (Insurance Association of Pakistan) Tape Ball Cricket Tournament, 2019",
        li2: "Winner Dubai Islamic Bank, Hard Ball Cricket Tournament – 2019",
        li3: "Semi-Finalist IAP (Insurance Association of Pakistan) Tape Ball Cricket Tournament, 2018",
        li4: "Participant in Insurance Premier League, Hard Ball Cricket Tournament, 2019",
        li5: "",
        li6: "",
        text3:
          "These tournaments not only infuse unity amongst the employees but also focus on team building",
      },
    ],
  },

  {
    key: "5",
    title: "Trainee Program",
    Detail: [
      {
        id: "5",
        image:
          "https://www.salaamtakaful.com/assets/images/Management/TraineeProgram.jpg",
        heading1: " Trainee Program",
        text1:
          "Salaam Takaful Limited strongly believes in the principle Equality and Diversity. We are always on the lookout for energetic and dynamic individuals and hence have launched two programs:",
        heading2: "",
        text2: "",
        li1: "Management Trainee Program",
        li2: "Sales Trainee Program",
        li3: "",
        li4: "",
        li5: "",
        li6: "",
        text3:
          "To combine the energy of individuals with the expertise of skilled management personnel to shape the future leaders of tomorrow.",
      },
    ],
  },
];

export const Jobs = [
  {
    key: "1",
    title: "Actuarial",
    Detail: [
      {
        key: "1",
        heading1: "Sales Manager",
        detailjob: [
          {
            key: "1",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "2",
        heading1: "Sales BOD",
        detailjob: [
          {
            key: "2",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "3",
        heading1: "Call Sales",
        detailjob: [
          {
            key: "3",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "4",
        heading1: "Sales Director",
        detailjob: [
          {
            key: "4",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "5",
        heading1: "Sales Bidder",
        detailjob: [
          {
            key: "5",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "6",
        heading1: "Sales Financer",
        detailjob: [
          {
            key: "6",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "7",
        heading1: "Sales Finance Manager",
        detailjob: [
          {
            key: "7",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      // Add more items as needed
    ],
  },

  {
    key: "2",
    title: "Administration",
    Detail: [
      {
        key: "1",
        heading1: "Finance Manager",
        detailjob: [
          {
            key: "1",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "2",
        heading1: "Sales BOD",
        detailjob: [
          {
            key: "2",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "3",
        heading1: "Call Sales",
        detailjob: [
          {
            key: "3",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "4",
        heading1: "Sales Director",
        detailjob: [
          {
            key: "4",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "5",
        heading1: "Sales Bidder",
        detailjob: [
          {
            key: "5",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "6",
        heading1: "Sales Financer",
        detailjob: [
          {
            key: "6",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "7",
        heading1: "Sales Finance Manager",
        detailjob: [
          {
            key: "7",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      // Add more items as needed
    ],
  },

  {
    key: "3",
    title: "Agency Management",
    Detail: [
      {
        key: "1",
        heading1: "Admin Manager",
        detailjob: [
          {
            key: "1",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "2",
        heading1: "Sales BOD",
        detailjob: [
          {
            key: "2",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "3",
        heading1: "Call Sales",
        detailjob: [
          {
            key: "3",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "4",
        heading1: "Sales Director",
        detailjob: [
          {
            key: "4",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "5",
        heading1: "Sales Bidder",
        detailjob: [
          {
            key: "5",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "6",
        heading1: "Sales Financer",
        detailjob: [
          {
            key: "6",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "7",
        heading1: "Sales Finance Manager",
        detailjob: [
          {
            key: "7",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      // Add more items as needed
    ],
  },

  {
    key: "4",
    title: "Business Development",
    Detail: [
      {
        key: "1",
        heading1: "HR Manager",
        detailjob: [
          {
            key: "1",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "2",
        heading1: "Sales BOD",
        detailjob: [
          {
            key: "2",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "3",
        heading1: "Call Sales",
        detailjob: [
          {
            key: "3",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "4",
        heading1: "Sales Director",
        detailjob: [
          {
            key: "4",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "5",
        heading1: "Sales Bidder",
        detailjob: [
          {
            key: "5",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "6",
        heading1: "Sales Financer",
        detailjob: [
          {
            key: "6",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "7",
        heading1: "Sales Finance Manager",
        detailjob: [
          {
            key: "7",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      // Add more items as needed
    ],
  },

  {
    key: "5",
    title: "Claims",
    Detail: [
      {
        key: "1",
        heading1: "Paid Intenship",
        detailjob: [
          {
            key: "1",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "2",
        heading1: "Sales BOD",
        detailjob: [
          {
            key: "2",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "3",
        heading1: "Call Sales",
        detailjob: [
          {
            key: "3",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",

            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "4",
        heading1: "Sales Director",
        detailjob: [
          {
            key: "4",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",
            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "5",
        heading1: "Sales Bidder",
        detailjob: [
          {
            key: "5",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",
            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },

      {
        key: "6",
        heading1: "Sales Financer",
        detailjob: [
          {
            key: "6",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",
            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res4: "Riot and strike damage,",
            res5: "Any natural incident (Earthquake, Flood, etc.)",
            res6: "Risk of terrorism.",
            res7: "Third Party",
            res8: "",
            res9: "",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },
      {
        key: "7",
        heading1: "Sales Finance Manager",
        detailjob: [
          {
            key: "7",
            textinfo:
              "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.                            ",
            res1: "Burglary and theft",
            res2: "Fire & external explosion",
            res3: "Burglary and theft",
            res4: "Fire & external explosion",
            res5: "Risk while in transit by air, road, rail, inland waterway, lift or elevetor.",
            res6: "Riot and strike damage,",
            res7: "Any natural incident (Earthquake, Flood, etc.)",
            res8: "Risk of terrorism.",
            res9: "Third Party",
            res10: "",
            resp1: "Personal Accident Cover (Optional)",
            resp2: "",
            resp3: "",
            resp4: "",
            resp5: "",
            resp6: "",
            resp7: "",
            resp8: "",
            resp9: "",
            resp10: "",
            edu1: "Personal Accident Cover (Optional)",
            edu2: "",
            edu3: "",
            edu4: "",
            edu5: "",
          },
        ],
      },
    ],
  },

  // {
  //     key: '6',
  //     title: 'Commercial'
  // },

  // {
  //     key: '7',
  //     title: 'Corporate Relationship'
  // },

  // {
  //     key: '8',
  //     title: 'Customer Service'
  // },

  // {
  //     key: '9',
  //     title: 'Emerging Lines'
  // },

  // {
  //     key: '10',
  //     title: 'Finance & Accounts'
  // },

  // {
  //     key: '11',
  //     title: 'Health'
  // },

  // {
  //     key: '12',
  //     title: 'Human Resource'
  // },

  // {
  //     key: '13',
  //     title: 'Information Technology'
  // },

  // {
  //     key: '14',
  //     title: 'Legal & Compliance'
  // },

  // {
  //     key: '15',
  //     title: 'Marketing'
  // },

  // {
  //     key: '16',
  //     title: 'Operations'
  // },

  // {
  //     key: '17',
  //     title: 'Retakaful'
  // },

  // {
  //     key: '18',
  //     title: 'Sales'
  // },

  // {
  //     key: '19',
  //     title: 'Service Quality & Excellence'
  // },

  // {
  //     key: '20',
  //     title: 'Shariah'
  // },

  // {
  //     key: '21',
  //     title: 'Underwriting'
  // },
];

export const newJobArray = [
  {
    key: 1,
    title: "Marketing",
    AvailablePositions: [
      {
        key: 1,
        positon: "Senior/Executive Officer",
        jobDetail:
          "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.",
        Responsiblities: [
          "Assist in developing and implementing marketing plans and campaigns.",
          "Support the creation and distribution of marketing content across channels.",
          "Help manage digital marketing efforts, including social media and email campaigns.",
          "Provide assistance in tracking campaign performance and preparing reports.",
          "Coordinate logistics for events, trade shows, and promotional activities.",
          "Assist in maintaining relationships with customers and partners.",
          "Contribute to market research and data collection for strategy improvement.",
        ],
        Requirements: [
          "Bachelor’s degree in marketing, Business Administration, or a related field.",
          "6 months–2 years of experience in marketing or a related role (fresh graduates encouraged to apply).",
          "Familiarity with digital marketing tools and social media platforms.",
          "Strong communication, organizational, and teamwork skills.",
          "Eagerness to learn and grow in a dynamic marketing environment.",
        ],
        WeOffer: [
          "Handsome Salary",
          "Group Life/Personal Accident Takaful",
          "Provident Fund",
          "Pay Continuation",
          "Gratuity",
          "EOBI",
          "Inpatient Medical Coverage",
          "Paid Leaves",
        ],
        applyNow: "jobs@salaamtakaful.com",
      },
    ],
  },
  {
    key: 2,
    title: "Motor Claims",
    AvailablePositions: [
      {
        key: 1,
        positon: "Executive Officer",
        jobDetail:
          "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.",
        Responsiblities: [
          "Review and process insurance claims by verifying policy coverage, documentation, and claim details.",
          "Assess claim validity and determine settlement amounts based on company guidelines and policy terms.",
          "Coordinate with internal departments such as underwriting and customer service to ensure seamless claim processing.",
          "Communicate with clients and service providers to gather necessary information and resolve claim-related queries.",
          "Maintain accurate records of claim activities and ensure compliance with regulatory and company standards.",
          "Identify potential fraud and escalate cases for further investigation as needed.",
          "Provide timely updates to stakeholders on claim status and resolution timelines.",
        ],
        Requirements: [
          "At least bachelor’s degree in related field.",
          "1-3 years of experience in claims handling or a similar role in the insurance industry.",
          "Strong analytical and problem-solving skills to assess claims and determine appropriate resolutions.",
          "Knowledge of insurance policies and claims procedures with a focus on accuracy.",
        ],
        WeOffer: [
          "Handsome Salary",
          "Group Life/Personal Accident Takaful",
          "Provident Fund",
          "Pay Continuation",
          "Gratuity",
          "EOBI",
          "Inpatient Medical Coverage",
          "Paid Leaves",
        ],
        applyNow: "jobs@salaamtakaful.com",
      },
    ],
  },
  {
    key: 3,
    title: "Non-Motor Underwriting",
    AvailablePositions: [
      {
        key: 1,
        positon: "Executive Officer - Underwriting",
        jobDetail:
          "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.",
        Responsiblities: [
          "Prepare and issue non-motor insurance quotations (Fire, Marine, Miscellaneous etc.), ensuring accuracy and adherence to underwriting guidelines.",
          "Support the timely issuance of approved non-motor insurance policies while ensuring compliance with internal processes.",
          "Coordinate with clients for renewals, issue renewal notices, and ensure timely updates to coverages.",
          "Facilitate efficient renewal processes for seamless policy continuity.",
          "Maintain and update the non-motor underwriting portfolio by tracking policy performance and analyzing risk factors.",
          "Ensure timely booking of new and renewed policies to maintain portfolio integrity.",
          "Assist with daily motor underwriting tasks, including resolving queries and managing client documentation.",
          "Ensure all non-motor insurance policies align with company objectives and regulatory standards.",
        ],
        Requirements: [
          "Bachelor's degree in Insurance, Business Administration, or a related field.",
          "1-3 years of experience in non-motor underwriting or insurance operations.",
          "Proficiency in Microsoft Office, especially excel with strong analytical skills and attention to detail.",
          "Excellent communication and problem-solving abilities.",
          "Ability to manage multiple tasks and prioritize effectively.",
        ],
        WeOffer: [
          "Handsome Salary",
          "Group Life/Personal Accident Takaful",
          "Provident Fund",
          "Pay Continuation",
          "Gratuity",
          "EOBI",
          "Inpatient Medical Coverage",
          "Paid Leaves",
        ],
        applyNow: "jobs@salaamtakaful.com",
      },
    ],
  },
  {
    key: 4,
    title: "IT Support",
    AvailablePositions: [
      {
        key: 1,
        positon: "IT Support Officer",
        jobDetail:
          "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.",
        Responsiblities: [
          "Provide first-level technical support for hardware, software, and network-related issues.",
          "Diagnose and troubleshoot IT problems to ensure minimal downtime and efficient resolution.",
          "Install, configure, and maintain IT equipment such as computers, printers, and network devices.",
          "Respond to user inquiries and provide solutions via phone, email, or in-person support.",
          "Monitor and maintain IT systems to ensure optimal performance and security.",
          "Document issues, solutions, and maintenance activities in the helpdesk system.",
          "Assist in IT-related projects and contribute to system upgrades and enhancements.",
        ],
        Requirements: [
          "Bachelor’s degree in Computer Science, Information Technology, or a related field.",
          "At least 1 year of experience in IT support or a similar role.",
          "Proficiency in Windows and Mac operating systems and troubleshooting methodologies.",
          "Experience with IT support tools and remote support software.",
          "Commitment to continuous learning to stay updated with evolving IT technologies.",
        ],
        WeOffer: [
          "Handsome Salary",
          "Group Life/Personal Accident Takaful",
          "Provident Fund",
          "Pay Continuation",
          "Gratuity",
          "EOBI",
          "Inpatient Medical Coverage",
          "Paid Leaves",
        ],
        applyNow: "jobs@salaamtakaful.com",
      },
    ],
  },
  {
    key: 5,
    title: "Motor Underwriter",
    AvailablePositions: [
      {
        key: 1,
        positon: "Motor Underwriter",
        jobDetail:
          "Salaam Takaful Limited offers Private Car Third party, a reliable solution to protect you against an accident to Third Party which meets legal motor insurance/takaful requirements under Motor Vehicle Act 1939.",
        Responsiblities: [
          "Evaluate motor insurance applications to determine eligibility and risk levels based on provided information.",
          "Assess risk factors and calculate premiums in alignment with company guidelines and market standards.",
          "Ensure compliance with underwriting policies, regulatory requirements, and documentation standards.",
          "Collaborate with claims and sales teams to provide underwriting support and resolve customer queries.",
          "Maintain accurate records and ensure timely issuance of policies for seamless customer experience.",
          "Monitor and analyse portfolio performance to identify trends and suggest improvements in underwriting practices.",
          "Provide recommendations for risk acceptance, policy terms, and coverage limits to optimize profitability and mitigate losses.",
        ],
        Requirements: [
          "At least bachelor’s degree in related field.",
          "2-4 years of experience in motor insurance underwriting.",
          "Strong analytical, decision-making skills with effective communication and negotiation abilities.",
          "Knowledge of motor insurance policies and regulations.",
        ],
        WeOffer: [
          "Handsome Salary",
          "Group Life/Personal Accident Takaful",
          "Provident Fund",
          "Pay Continuation",
          "Gratuity",
          "EOBI",
          "Inpatient Medical Coverage",
          "Paid Leaves",
        ],
        applyNow: "jobs@salaamtakaful.com",
      },
    ],
  },
];

export const financialreportspdf = [
  {
    key: "10",
    heading: "2025",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2025.pdf`,
      //   title: "First Quarterly Report 2025.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2025FirstQuarterly.jpg`,
      // },
      // {
      //   key: "2",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/HalfYearlyReport2025.pdf`,
      //   title: "  Half Yearly 2025 Report.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2025HalfYearly.jpg`,
      // },
      // {
      //   key: "3",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2025.pdf`,
      //   title: "Third Quarterly Report 2025.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2025ThirdQuarterly.jpg`,
      // },
      // {
      //     key: "3",
      //     link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2016.pdf`,
      //     title: "  Third Quarterly Report 2024.pdf",
      //     image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022ThirdQuarterly.jpg`
      // },
      {
          key: "4",
          link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2025.pdf`,
          title: "  Annual Report 2025.pdf",
          image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/AnnualReport2025.jpg`
      },
    ],
  },
  {
    key: "1",
    heading: "2024",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2024.pdf`,
      //   title: "First Quarterly Report 2024.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2024FirstQuarterly.jpg`,
      // },
      {
        key: "2",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2024.pdf`,
        title: "Annual Report 2024.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/AnnualReport2024.jpg`,
      },
      // {
      //     key: "2",
      //     link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2016.pdf`,
      //     title: "  Half Yearly 2024 Report.pdf",
      //     image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022HalfYearly.jpg`
      // },
      // {
      //     key: "3",
      //     link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2016.pdf`,
      //     title: "  Third Quarterly Report 2024.pdf",
      //     image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022ThirdQuarterly.jpg`
      // },
      // {
      //     key: "4",
      //     link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2016.pdf`,
      //     title: "  Annual Report 2024.pdf",
      //     image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022.jpg`
      // },
    ],
  },
  {
    key: "2",
    heading: "2023",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2023.pdf`,
      //   title: "First Quarterly Report 2023.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2023FirstQuarterly.jpg`,
      // },
      // {
      //   key: "2",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/HalfYearlyReport2023.pdf`,
      //   title: "Half Yearly Report 2023.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2023HalfYearly.jpg`,
      // },
      // {
      //   key: "3",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2023.pdf`,
      //   title: "Third Quarterly Report 2023.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2023ThirdQuarterly.jpg`,
      // },
      {
        key: "4",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2023.pdf`,
        title: "Annual Report 2023.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2023.jpg`,
      },
    ],
  },
  {
    key: "3",
    heading: "2022",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2022.pdf`,
      //   title: "First Quarterly Report 2022.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022FirstQuarterly.jpg`,
      // },
      // {
      //   key: "2",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/HalfYearlyReport2022.pdf`,
      //   title: "Half Yearly Report 2022.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022HalfYearly.jpg`,
      // },
      // {
      //   key: "3",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2022.pdf`,
      //   title: "Third Quarterly Report 2022.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022ThirdQuarterly.jpg`,
      // },
      {
        key: "4",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2022.pdf`,
        title: "Annual Report 2022.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2022.jpg`,
      },
    ],
  },
  {
    key: "4",
    heading: "2021",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2021.pdf`,
      //   title: "First Quarterly Report 2021.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2021FirstQuarterly.jpg`,
      // },
      // {
      //   key: "2",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/HalfYearlyReport2021.pdf`,
      //   title: "Half Yearly Report 2021.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2021HalfYearly.jpg`,
      // },
      // {
      //   key: "3",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2021.pdf`,
      //   title: "Third Quarterly Report 2021.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2021ThirdQuarterly.jpg`,
      // },
      {
        key: "4",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2021.pdf`,
        title: "Annual Report 2021.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2021.jpg`,
      },
    ],
  },

  {
    key: "5",
    heading: "2020",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2020.pdf`,
      //   title: "First Quarterly Report 2020.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2020FirstQuarterly.jpg`,
      // },
      // {
      //   key: "2",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/HalfYearlyReport2020.pdf`,
      //   title: "Half Yearly Report 2020.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2020HalfYearly.jpg`,
      // },
      // {
      //   key: "3",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2020.pdf`,
      //   title: "Third Quarterly Report 2020.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2020ThirdQuarterly.jpg`,
      // },
      {
        key: "4",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2020.pdf`,
        title: "Annual Report 2020.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2020.jpg`,
      },
    ],
  },
  {
    key: "6",
    heading: "2019",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2019.pdf`,
      //   title: "First Quarterly Report 2019.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2019FirstQuarterly.jpg`,
      // },
      // {
      //   key: "2",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/HalfYearlyReport2019.pdf`,
      //   title: "Half Yearly Report 2019.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2019HalfYearly.jpg`,
      // },
      // {
      //   key: "3",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2019.pdf`,
      //   title: "Third Quarterly Report 2019.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2019ThirdQuarterly.jpg`,
      // },
      {
        key: "4",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2019.pdf`,
        title: "Annual Report 2019.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2019.jpg`,
      },
    ],
  },
  {
    key: "7",
    heading: "2018",
    pdf: [
      // {
      //   key: "1",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FirstQuarterlyReport2018.pdf`,
      //   title: "First Quarterly Report 2018.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2018FirstQuarterly.jpg`,
      // },
      // {
      //   key: "2",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/HalfYearlyReport2018.pdf`,
      //   title: "Half Yearly Report 2018.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2018HalfYearly.jpg`,
      // },
      // {
      //   key: "3",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2018.pdf`,
      //   title: "Third Quarterly Report 2018.pdf",
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2018ThirdQuarterly.jpg`,
      // },
      {
        key: "4",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ThirdQuarterlyReport2018.pdf`,
        title: "  Annual Report 2018.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2018.jpg`,
      },
    ],
  },
  {
    key: "8",
    heading: "2017",
    pdf: [
      {
        key: "1",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2017.pdf`,
        title: "Annual Report 2017.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2017.jpg`,
      },
    ],
  },
  {
    key: "9",
    heading: "2016",
    pdf: [
      {
        key: "1",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AnnualReport2016.pdf`,
        title: " Annual Report 2016.pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ThumbnailAnnualReport2016.jpg`,
      },
    ],
  },
];

export const Financialhighlight = [
  {
    key: "1",
    heading: "2018 - 2023",
    pdf: [
      {
        key: "1",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/FinancialHighlights.pdf`,
        title: " Financial Highlights.pdf",
      },
    ],
  },
];

export const Nogmpdf = [
  {
    key: "1",
    heading: "Extraordinary General Meeting",
    pdf: [
      {
        key: "6",
        title: "Notice of 13th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf13thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/NoticeOfThe13thExtraordinaryGeneralMeeting.jpg`,
      },
      {
        key: "6",
        title: "Notice of 12th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf12thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/NoticeOfThe12thExtraordinaryGeneralMeeting.jpg`,
      },
      {
        key: "6",
        title: "Notice of 11th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf11thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/NoticeOfThe11thExtraordinaryGeneralMeeting.jpg`,
      },
      {
        key: "5",
        title: "Notice of 10th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf10thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/NoticeOfThe10thExtraordinaryGeneralMeeting.jpg`,
      },
      {
        key: "4",
        title: "Notice of 9th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf9thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof9THExtraordinaryGeneralMeeting.jpg`,
      },
      {
        key: "3",
        title: "Notice of 8th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf8thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof8thExtraordinaryGeneralMeeting.jpg`,
      },
      {
        key: "2",
        title: "Notice of 7th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf7thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof7thExtraordinaryGeneralMeeting.jpg`,
      },
      {
        key: "1",
        title: "Notice of 6th Extraordinary General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/NoticeOf6thExtraordinaryGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof6thExtraordinaryGeneralMeeting.jpg`,
      },
    ],
  },
  {
    key: "2",
    heading: "Annual General Meeting",
    pdf: [
      {
        key: "10",
        title: "Notice of 19th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof19thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof19THAnnualGeneralMeeting.jpg`,
      },
      {
        key: "9",
        title: "Notice of 18th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof18thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof18THAnnualGeneralMeeting.jpg`,
      },
      {
        key: "8",
        title: "Notice of 17th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof17thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof17THAnnualGeneralMeeting.jpg`,
      },
      {
        key: "7",
        title: "Notice of 16th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof16thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof16THAnnualGeneralMeeting.jpg`,
      },
      {
        key: "6",
        title: "Notice of 15th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof15thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof15thAnnualGeneralMeeting.jpg`,
      },
      {
        key: "5",
        title: "Notice of 14th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof14thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof14thAnnualGeneralMeeting.jpg`,
      },
      {
        key: "4",
        title: "Notice of 13th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof13thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof13thAnnualGeneralMeeting.jpg`,
      },
      {
        key: "3",
        title: "Notice of 12th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof12thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof12thAnnualGeneralMeeting.jpg`,
      },
      {
        key: "2",
        title: "Notice of 11th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof11thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof11thAnnualGeneralMeeting.jpg`,
      },
      {
        key: "1",
        title: "Notice of 10th Annual General Meeting.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/Noticeof10thAnnualGeneralMeeting.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/Noticeof10thAnnualGeneralMeeting.jpg`,
      },
    ],
  },
];

export const perposalpds = [
  {
    key: "1",
    heading: "FINANCIAL LINES & MISCELLANEOUS",
    pdf: [
      {
        key: "1",
        title: "Salaam All Risks Contents Takaful Contract Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamAllRiskContentsTakafulContractProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamAllRisksContentsTakafulContractProposalForm.jpg`,
      },
      {
        key: "2",
        title: " Salaam Fidelity Guarantee Proposal Form Updated.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamFidelityGuaranteeProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamFidelityGuaranteeProposalForm.jpg`,
      },
      {
        key: "3",
        title: " Salaam Mobile phone Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMobilePhoneProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamMobilephoneProposalForm.jpg`,
      },
      {
        key: "4",
        title: " Salaam Money Takaful Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMoneyTakafulProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamMoneyTakafulProposalForm.jpg`,
      },
      {
        key: "5",
        title: "Salaam Personal Accident Proposal Form.pdf ",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamPersonalAccidentProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamPersonalAccidentProposalForm.jpg`,
      },
      {
        key: "6",
        title: " Salaam Plate Glass Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamPlateGlassProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamPlateGlassProposalForm.jpg`,
      },
      {
        key: "7",
        title: " Salaam Product Liability Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamProductLiabilityProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamProductLiabilityProposalForm.jpg`,
      },
      {
        key: "8",
        title: " Salaam Third Party Liability Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamThirdPartyLiabilityProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamThirdPartyLiabilityProposalForm.jpg`,
      },
      {
        key: "9",
        title: " Salaam Workmen's Compensation Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamWorkmen'sCompensationProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamWorkmen'sCompensationProposalForm.jpg`,
      },
    ],
  },
  {
    key: "2",
    heading: "MARINE",
    pdf: [
      {
        key: "1",
        title: "Salaam Marine Questionnaire Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMarineQuestionnaireForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamMarineQuestionnaireForm.jpg`,
      },
    ],
  },
  {
    key: "3",
    heading: "FIRE",
    pdf: [
      {
        key: "1",
        title: " Salaam Fire Takaful Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamFireTakafulProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamFireTakafulProposalForm.jpg`,
      },
    ],
  },
  {
    key: "4",
    heading: "MOTOR",
    pdf: [
      {
        key: "1",
        title: "Salaam Motor Vehicle Proposal Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMotorVehicleProposalForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamMotorVehicleProposalForm.jpg`,
      },
    ],
  },
];

export const healthform = [
  {
    key: "1",
    heading: "HEALTH FORMS",
    pdf: [
      {
        key: "1",
        title: "Salaam Health Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamHealthClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamHealthClaimForm.jpg`,
      },
      {
        key: "2",
        title: "Salaam Pre-Auth Intimation Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/PreAuthIntimationForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamPreAuthIntimationForm.jpg`,
      },
    ],
  },
  {
    key: "2",
    heading: "FINANCIAL LINES & MISCELLANEOUS FORMS",
    pdf: [
      {
        key: "1",
        title: "Salaam Money Takaful Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMoneyTakafulClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamMoneyTakafulClaimForm.jpg`,
      },
      {
        key: "2",
        title: "Salaam Plate Glass Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamPlateGlassClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamPlateGlassClaimForm.jpg`,
      },
      {
        key: "3",
        title: "Salaam Machinery Breakdown Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMachineryBreakdownClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamMachinaryBreakdownClaimForm.jpg`,
      },
      {
        key: "4",
        title: "Salaam Fidelity Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamFidelityClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamFidelityClaimForm.jpg`,
      },
      {
        key: "5",
        title: "Salaam Plastic Card Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamPlasticCardClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamPlasticCardClaimForm.jpg`,
      },
      // {
      //     key: "5",
      //     title: "Salaam Plastic Card Claim Form.pdf",
      //     link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamElectronicEquipmentTakafulClaimForm.pdf`,
      //     image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamElectronicEquipmentTakafulClaimForm.jpg`
      // },
    ],
  },
  {
    key: "3",
    heading: "FIRE & ENGINEERING FORMS",
    pdf: [
      {
        key: "1",
        title: "Salaam Fire Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamFireClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamFireClaimForm.jpg`,
      },
      // {
      //     key: "2",
      //     title: "Salaam Fire And Engineering Claim Form.pdf",
      //     link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamFireAndEngineeringClaimForm.pdf`,
      //     image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamFireAndEngineeringClaimForm.jpg`
      // },
    ],
  },
  {
    key: "4",
    heading: "MOTOR CLAIM FORMS",
    pdf: [
      {
        key: "1",
        title: "Salaam Motor Vehicle Claim Form.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMotorVehicleClaimForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamMotorClaimForm.jpg`,
      },
    ],
  },
];

export const complainResolution = [
  {
    key: "1",
    heading: "COMPLAINT RESOLUTION FORM",
    pdf: [
      {
        key: "1",
        title: "Complaint Form",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ComplaintForm.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ComplaintForm.jpg`,
      },
      {
        key: "2",
        title: "Complaint Form (Urdu)",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ComplaintFormUrdu.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ComplaintForm.jpg`,
      },
    ],
  },
];

export const uncahsed = [
  {
    key: "1",
    heading: "UN-ENCASHED BENEFITS",
    pdf: [
      {
        key: "1",
        title: " Unclaimed Benefits as at June 2023.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/UnclaimedBenefits.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/UnclaimedBenefits.jpg`,
      },
    ],
  },
];

export const Policiespdf = [
  {
    key: "1",
    heading: "SALAAM TAKAFUL POLICIES",
    pdf: [
      {
        key: "1",
        title: " Ethical Business Practices Policy.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/EthicalBusinessPractices.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/EthicalBusinessPractices.jpg`,
      },

      {
        key: "2",
        title: " Whistle Blowing Policy.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/WhistleBlowing.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/WhistleBlowing.jpg`,
      },
      // {
      //   key: "4",
      //   title: "Anti-Bribery & Corruption Policy.pdf",
      //   link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/AntiBriberyAndCorruptionPolicy.pdf`,
      //   image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/AntiBriberyAndCorruption.jpg`,
      // },
    ],
  },
];

export const proxypdf = [
  {
    key: "1",
    heading: "PROXY FORMS",
    pdf: [
      {
        key: "1",
        title: "ProxyForm (English)",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ProxyForm(English).pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ProxyFormEnglish.jpg`,
      },
      {
        key: "2",
        title: "Proxy Form (Urdu)",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/ProxyForm(Urdu).pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/ProxyFormUrdu.jpg`,
      },
    ],
  },
];

export const hospitalpdfs = [
  {
    key: "1",
    heading: "PANEL HOSPITALS",
    pdf: [
      {
        key: "1",
        title: "Panel Hospitals List.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/PanelHospitalList.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/PanelHospitallist.jpg`,
      },
    ],
  },
];

export const disform = [
  {
    key: "1",
    heading: "DISCOUNT CENTER",
    pdf: [
      {
        key: "1",
        title: " Salaam OPD Discount Centres.pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/DiscountCentresList.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/DiscountCentre.jpg`,
      },
    ],
  },
];

export const collateral = [
  {
    key: "1",
    heading: "SALAAM TAKAFUL LIMITED CORPORATE PROFILE",
    pdf: [
      {
        key: "1",
        title: " Salaam Takaful Limited Corporate Profile.Pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamTakafulLimitedCorporateProfile.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/CorporateProfile.jpg`,
      },
    ],
  },
  {
    key: "2",
    heading: "SALAAM MOTOR TAKAFUL",
    pdf: [
      {
        key: "1",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamComprehensiveMotorTakafulBrochure.pdf`,
        title: "Salaam Comprehensive Motor Takaful Brochure.Pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/salaammotortakaful.jpg`,
      },
      {
        key: "2",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamPayAsYouDriveMotorTakafulBrochure.pdf`,
        title: "Salaam Pay As You Drive Motor Takaful Brochure.Pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/payd.jpg`,
      },
      {
        key: "3",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamtiBikeBrochure.pdf`,
        title: "Salaamti Bike Brochure.Pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/salaamtibike.jpg`,
      },
    ],
  },

  {
    key: "3",
    heading: "SALAAM TRAVEL TAKAFUL",
    pdf: [
      {
        key: "1",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamTravelTakafulBrochure.pdf`,
        title: "Salaam Travel Takaful Brochure.Pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/traveltakaful.jpg`,
      },
    ],
  },

  // {
  //   key: "4",
  //   heading: "SALAAM CROP TAKAFUL",
  //   pdf: [
  //     {
  //       key: "1",
  //       link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamParametricBasedCropTakafulBrochure.pdf`,
  //       title: "Salaam Parametric Based Crop Takaful Brochure.Pdf",
  //       image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/crop.jpg`,
  //     },
  //   ],
  // },

  {
    key: "5",
    heading: "SALAAM HOME TAKAFUL",
    pdf: [
      {
        key: "1",
        title: "Salaam Home Takaful Brochure.Pdf",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamHomeTakafulBrochure.pdf`,
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/SalaamHome.jpg`,
      },
    ],
  },
  {
    key: "6",
    heading: "SALAAM MARINE TAKAFUL",
    pdf: [
      {
        key: "1",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamMarineTakafulBrochure.pdf`,
        title: "Salaam Marine Takaful Brochure.Pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/marine.jpg`,
      },
    ],
  },
  {
    key: "7",
    heading: "SALAAM PERSONAL ACCIDENT TAKAFUL",
    pdf: [
      {
        key: "1",
        link: `${process.env.REACT_APP_URL_ASSETS}Assets/pdf/SalaamPersonalAccidentBrochure.pdf`,
        title: "Salaam Personal Accident Brochure.Pdf",
        image: `${process.env.REACT_APP_URL_ASSETS}Assets/thumbnail/CorporateProfile.jpg`,
      },
    ],
  },
];

export const shariahData = [
  {
      key: "1",
      name: 'Dr. Mufti Irshad Ahmad Aijaz',
      designation: 'Chairman Shariah Board',
      detail: "<p>Dr. Mufti Irshad Ahmad Aijaz holds <em>Shahadat-ul-Aalamia</em> (Masters in Arabic and Islamic Studies) and <em>Takhassus fi al-Ifta</em> (Specialization in Islamic Jurisprudence and Fatwa) from Jamia Dar-ul-Uloom, Karachi. He has also completed his MBA in Finance and a PhD in Islamic Studies. <br /> <br /> He regularly delivers lectures on Islamic Economics and Finance at different forums and educational institutions including National Institute of Banking and Finance, IBA Karachi and Centre of Islamic Economics (a division of Jamia Dar-ul-Uloom, Karachi).</p>",
      // detail1: "",
      animation: 'vertical',
      caranim: "up",
      image: "https://asset.salaamtakaful.com/GeneralAssets/shariah/irshad.jpg"
  },
  {
      key: "2",
      name: 'Prof. Dr. Noor Ahmed Shahtaaz ',
      designation: 'Member Shariah Board',
      detail: "<p>Prof. Dr. Noor Ahmed Shahtaaz is a highly distinguished Islamic scholar, jurist, and Shariah advisor with over 27 years of academic and research experience at the University of Karachi. He currently serves as Juris Consult/Advisor at the Federal Shariat Court and is a Member of the Shariah Advisory Board of Bank Makrama Ltd. He has previously held key national roles including Member of the Council of Islamic Ideology and Shariah Advisory Committee of the State Bank of Pakistan. Dr. Shahtaaz holds a Ph.D. in Islamic Studies, along with qualifications in law, Arabic, and Islamic finance. He has authored and edited numerous books and published 150+ research articles on Islamic jurisprudence and banking. He is also the founder and honorary editor of leading Islamic research journals. His expertise spans Fiqh, Hadith, Islamic Law, and Islamic Banking, with extensive contributions at national and international forums</p>",
      // detail1: "",
      animation: 'vertical',
      caranim: "up",
      image: "https://asset.salaamtakaful.com/GeneralAssets/shariah/noor.jpg"
  },
  // {
  //   key: "2",
  //   name: "Dr. Mufti Muhammad Yunus Ali",
  //   designation: "Shariah Board Member",
  //   detail:
  //     "<p>Dr. Mufti Muhammad Yunas Ali holds a PhD degree in Islamic Banking & Finance from University of Karachi. His PhD dissertation titled “Shari’ah non-compliance risk and its impact on Islamic Banking”. He already possesses a Master’s degree in Islamic Banking & Finance from Sheikh Zayed Islamic Centre, University of Karachi. Religiously, he has completed Takhassus-fil-Fiqh wal-Ifta (Specialization in Islamic Jurisprudence and Fatwa Writing) and also completed Al-Shahadul Aalamiyyah (Equivalent to Masters in Arabic and Islamic Sciences) from Tanzeem-ul-Madaris Ahle-Sunnat Pakistan and got 3rd position in all Pakistan. He has over 17 years of experience in the field of Research and Ifta.<br /><br />He is also a visiting lecturer in Sheikh Zayed Islamic Centre of University of Karachi, Islamic Learning Department – Faculty of Islamic Studies in University of Karachi, Al. Manaar Islamic Research Centre, and Jamiah Dar-ul-Uloom Memon Karachi MA Jinnah Road.<br /><br />He has a remarkable academic record and written various Books including Interpretation and Marginal Notes on “Jaddul Mumtar” (Arabic commentary of Alahazrat Imam Ahmad Raza Khan on Radd - ul - Muhtar / Fatawa Shami) and “Bahar e Shariat” (Complete Collection of Islamic Laws), booklets and research papers which are published in HEC approved journals as well.</p>",
  //   animation: "horizontal",
  //   caranim: "up",
  //   image: "https://asset.salaamtakaful.com/GeneralAssets/shariah/younus.jpg",
  // },
  {
    key: "3",
    name: "Ayatullah Sheikh Shabbir Hasan Lakhani (Maisami)",
    designation: "Shariah Board Member",
    detail:
      "<p>Ayatullah Sheikh Shabbir Hasan Lakhani (Maisami) holds a Master`s degree in Arabic and Islamic Sciences and a Sanad of Ijtehad, received from Ayatollah Sheikh Mohammad Hadi Marifat and Ayatollah Syed Muhammed Kazim Hairee. He specializes in areas such as the Islamic Education System, Islamic Economic System, Islamic Banking System, and Islamic Justice System. He has also attended Durs-e-Kharej (Ijtehad) of renowned scholars such as Ayatollah Waheed-e-Khorasani, Ayatollah Syed Mohammad Kazim Hairee, and Ayatollah Sheikh Mohammad Hadi Marifat. Additionally, he has received Ijazas of Umur-e-Hisbeyah from prominent figures like Ayatollah Aluzma Syed Mohammad Raza Gulpaygani, Ayatollah Aluzma Sheikh Nasir Makarim Shirazi, and Ayatollah Aluzma Sheikh Fazel Lankarani. Apart from his academic achievements, he established offices in multiple cities and completed three years towards an MBBS degree at Dow Medical College Karachi in 1981. He completed his intermediate education at Lawrence College, Murree, and matriculation at Habib Public School, Karachi. <br /><br />  Ayatullah Sheikh Shabbir Hasan Lakhani (Maisami) is an accomplished Islamic scholar with a wide range of achievements. He co-founded and has been managing the Zahra (S.A.) Academy for over 35 years. Additionally, he introduced the first-ever summer camps, Mazhab Shinasi, which have over 25,000 alumni worldwide. He is also a prolific writer, having authored six books in three languages, and serves as a Shariah Advisor to various organizations, including the State Bank of Pakistan and the Halal Food Authority Pakistan. Moreover, he is a member of several boards, including the Board of Governors of Halal Food Authority Pakistan and serves as an advisor to the Chairman of Wefaq-ul-Madaris Shia, Pakistan.Ayatullah Sheikh Shabbir Hasan Lakhani also has experience in the media industry, having been the Chief Operating Officer of Such TV from 2010 to 2012. Under his leadership, the channel developed a vision and strategy and broadcasted television programs within a year of its inception. He was responsible for profit and loss management and developed a team of experienced professionals under difficult financial constraints. Furthermore, he established offices in multip cities. </p>",
    animation: "horizontal",
    caranim: "up",
    image:
      "https://asset.salaamtakaful.com/GeneralAssets/shariah/ayatullah.jpg",
  },
  {
    key: "4",
    name: "Mufti Sajjad Ashraf Usmani",
    designation: "Shariah Advisor and Shariah Board Member",
    detail:
      "<p>Mufti Sajjad Usmani is a qualified CSAA (Certified Shariah Advisor & Auditor) from AAOIFI (Accounting and Auditing Organization for Islamic Financial Institutions, Bahrain), Takhassus Fil Ifta (Specialization in Islamic Jurisprudence and Fatwa) and Dars-e-Nizami/Shahadat-ul-Aalamia from Jamia Dar-ul-Uloom, Karachi and a certified anatomist of Sukuk, Islamic Banking & Finance. <br /><br />He is a seasoned professional with over 12 & 8 years of working experience from writing Fatawa to serving as a Shariah Advisor of the leading financial institutions of Pakistan respectively.He has blend experience of providing Shariah consultancy to four (4) Takaful Companies as Shariah Advisor since 2015 and also served as Shariah Advisor of the Tier 2 Mudharabah Sukuk issued by Meezan Bank Limited. Currently he is also the Shariah Board Member at National Bank of Pakistan (Aitamad Islamic). <br /><br />He also has 7 years’ working experience with leading Auditing firms like A.F.F (PWC) & Deloitte Pakistan, as a Shariah Consultant & Head of Shariah Audit and has supervised various Shariah Audits of renowned Islamic Banks, Takaful Companies and Sukuks under the audit firm’s umbrella. He knows the practical problems being faced by the Islamic Financial InstitutionMufti Sb has qualified Takhassus (specialization) in Islamic Jurisprudence and Dar se Nizami from Jamia Darul Uloom, Karachi and a certified anatomist of Sukuks, Islamic Banking & Finance. He is also pursuing MBA besides having a bachelor’s degree in Economics from the University of Karachi that makes him the perfectly blended professional in the field of Islamic Finance & Takaful.He is a teacher of Hadith and Fiqh (Islamic Jurisprudence) at Jamia Dar-ul-Uloom, Karachi besides teaching in various leading Islamic educational institutions like IBA CEIF & Center for Islamic Economic since 2011. </p>",
    animation: "horizontal",
    caranim: "up",
    image: "https://asset.salaamtakaful.com/GeneralAssets/shariah/sajjad.jpg",
  },
  {
    key: "5",
    name: "Dr. Irum Saba",
    designation: "Shariah Board Technical Member",
    detail:
      "<p>Dr. Irum Saba has more than 17 years of progressive regulatory, research, training, and teaching experience with organizations of international repute.Currently, she is in Institute of Business Administration(IBA), Karachi working as an Associate Professor in the Department of Finance and Program Director of MS Islamic Banking and Finance.She has the honor to be the first Pakistani female to be part of the International Shariah Advisory Board in South East Asia and Middle East.Recently, she has been awarded the title of WOMENi Pakistan in recognition of her contribution to the Islamic Finance Industry in Pakistan and internationally. Furthermore, Dr.Irum Saba has also been included in the prestigious list of top 10 Influential Women in Islamic Business & Finance 2021, while attaining the honor of being the first female whose name has been added in the register of Shariah Advisors by SECP as per the Shariah Advisors Regulations, 2017.</p>",
    animation: "vertical",
    caranim: "up",
    image: "https://asset.salaamtakaful.com/GeneralAssets/shariah/saba.jpg",
  },
];
export const advisorData = [
  {
    key: "1",
    name: "Mufti Sajjad Ashraf Usmani",
    designation: "Shariah Advisor and Shariah Board Member",
    detail:
      "<p>Mufti Sajjad Usmani is a qualified CSAA (Certified Shariah Advisor & Auditor) from AAOIFI (Accounting and Auditing Organization for Islamic Financial Institutions, Bahrain), Takhassus Fil Ifta (Specialization in Islamic Jurisprudence and Fatwa) and Dars-e-Nizami/Shahadat-ul-Aalamia from Jamia Dar-ul-Uloom, Karachi and a certified anatomist of Sukuk, Islamic Banking & Finance. <br /><br />He is a seasoned professional with over 12 & 8 years of working experience from writing Fatawa to serving as a Shariah Advisor of the leading financial institutions of Pakistan respectively.He has blend experience of providing Shariah consultancy to four (4) Takaful Companies as Shariah Advisor since 2015 and also served as Shariah Advisor of the Tier 2 Mudharabah Sukuk issued by Meezan Bank Limited. Currently he is also the Shariah Board Member at National Bank of Pakistan (Aitamad Islamic). <br /><br />He also has 7 years’ working experience with leading Auditing firms like A.F.F (PWC) & Deloitte Pakistan, as a Shariah Consultant & Head of Shariah Audit and has supervised various Shariah Audits of renowned Islamic Banks, Takaful Companies and Sukuks under the audit firm’s umbrella. He knows the practical problems being faced by the Islamic Financial InstitutionMufti Sb has qualified Takhassus (specialization) in Islamic Jurisprudence and Dar se Nizami from Jamia Darul Uloom, Karachi and a certified anatomist of Sukuks, Islamic Banking & Finance. He is also pursuing MBA besides having a bachelor’s degree in Economics from the University of Karachi that makes him the perfectly blended professional in the field of Islamic Finance & Takaful.He is a teacher of Hadith and Fiqh (Islamic Jurisprudence) at Jamia Dar-ul-Uloom, Karachi besides teaching in various leading Islamic educational institutions like IBA CEIF & Center for Islamic Economic since 2011. </p>",
    animation: "horizontal",
    caranim: "up",
    image: "https://asset.salaamtakaful.com/GeneralAssets/shariah/sajjad.jpg",
  },
];

export const annualperformance = [
  {
    id: "1",
    cat: "all",
    desc: [
      {
        key: "1",
        heading: "Salaam Takaful Limited  Annual Performance Review, 2023",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/AQud7yNZwbc?si=P-rjc_tQYw82NqBK",
      },
      {
        key: "2",
        heading: "Salaam Takaful Limited  Annual Performance Review, 2022",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/oK2sgKGEvdk",
      },
      {
        key: "3",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2021",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/zj6Cej3RJiw",
      },
      {
        key: "4",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2020",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: ".https://www.youtube.com/embed/e3tp2rXkX0M",
      },
      {
        key: "5",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2019",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/TCULJMILfJc",
      },
      {
        key: "6",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2018",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/BaK5QgLl8EQ",
      },
    ],
  },

  {
    id: "2",
    cat: "Gallery",
    desc: [
      {
        key: "11",
        heading: "Salaam Takaful Limited  Annual Performance Review, 2022",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/oK2sgKGEvdk",
      },
    ],
  },

  {
    id: "3",
    cat: "videos",
    desc: [
      {
        key: "7",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2021",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/zj6Cej3RJiw",
      },
      {
        key: "8",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2020",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: ".https://www.youtube.com/embed/e3tp2rXkX0M",
      },
      {
        key: "9",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2019",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/TCULJMILfJc",
      },
      {
        key: "10",
        heading: "Salaam Takaful Limited | Annual Performance Review, 2018",
        image:
          "https://asset.salaamtakaful.com/GeneralAssets/gallery/gallery.png",
        link: "https://www.youtube.com/embed/BaK5QgLl8EQ",
      },
    ],
  },
];

export const branches = [
  {
    city: "Karachi (Kashif Center)",
    address:
      "Office No. 702, 7th Floor Kashif Center, Shahrah-e-Faisal, Karachi 75400, Pakistan.",
    contact: {
      tel: ["+92-21-36450013"],
      email: "shoaib.hussain@salaamtakaful.com",
      mapLink: "https://maps.app.goo.gl/EpyUVzeKQUbApW5Z8",
    },
  },
  {
    city: "Karachi (DHA Phase-VI)",
    address:
      "C-35, Lane No. 1, Office # 201, 2nd Floor Ittehad Commercial, Opp. PSO Petrol Pump, Khayaban-e-Ittehad, Phase-VI, D.H.A., Karachi.",
    contact: {
      tel: ["+92-21-33325133"],
      mapLink: "https://maps.app.goo.gl/L2WpvxTHZduVGpUt7",
    },
  },
  {
    city: "Karachi (DHA Phase-II)",
    address:
      "Office # 301, Plot No. 61-C, Main Korangi Road, Phase-II Ext., DHA, Karachi.",
    contact: {
      tel: ["+92-21-37122743"],
      mapLink: "https://maps.app.goo.gl/n7smXCMyr9BSnzef7",
    },
  },
  {
    city: "Islamabad",
    address:
      "1st Floor, Awan Arcade Building 1B, Block R, Jinnah Avenue, Blue Area.",
    contact: {
      tel: ["+92-51-8318368"],
      email: "majid.sultan@salaamtakaful.com",
      mapLink: "https://maps.app.goo.gl/yryEqKzA6ApR8xnB6",
    },
  },
  {
    city: "Lahore",
    address:
      "High-Q Tower, Plot No.1, Floor No 9, Office No. 901 / 902 Gulberg – V Jail Road.",
    contact: {
      tel: ["04236400736", "04235751282-85"],
      email: "yasir.khan@salaamtakaful.com",
      mapLink: "https://maps.app.goo.gl/Hk7bz74YEA63rChP8",
    },
  },
  {
    city: "Multan",
    address:
      "10-B, Old Bahawalpur Road, Opposite KFC, Multan Cantt.",
    contact: {
      UAN: "111-875-111",
      tel: ["0311-1445226"],
      email: "m.kaleemullah@salaamtakaful.com",
      mapLink: "https://maps.app.goo.gl/MXc4sPygxwGM18zw6",
    },
  },
  {
    city: "Faisalabad",
    address:
      "Electro City Plaza, 1st floor, P-5, Wahab Centre, Main Susan Road, Madina Town.",
    contact: {
      tel: ["0418720062", "0418720063", "0333-6502276"],
      mapLink: "https://maps.app.goo.gl/jPtVLLWqb3Gy3mi48",
    },
  },
  {
    city: "Peshawar",
    address: "6th Floor, State Life Building, 34-The Mall, Peshawar Cantt.",
    contact: {
      tel: ["+92-915254186"],
      mapLink: "https://maps.app.goo.gl/yMthP6vAbR21FRqL9",
    },
  },
  {
    city: "Sialkot",
    address:
      "Office # Y-11, 1st Floor, Yousaf Plaza, Opp : Pak Medical Center, Defence Road. Sialkot",
    contact: {
      tel: ["+92-333-8697699"],
      email: "arif.bhatti@salaamtakaful.com",
      mapLink: "https://maps.app.goo.gl/J8HunnQjy6H5x2AMA",
    },
  },
];
export const LifeAtSalaamAmenitiesData = [
  // {
  //     key: "1",
  //     heading: "Fitness Center",
  //     speed: 1800,
  //     description:
  //         "At Salaam Takaful, we prioritize the well-being of our employees by providing state-of-the-art gym facilities. Our fully equipped gym is designed to support physical health and foster a positive work-life balance. From cardio equipment to strength training machines, our gym is a space where employees can rejuvenate and maintain their fitness goals. We also organize fitness classes and wellness challenges, promoting a healthy and active lifestyle among our team members.",
  //     images: [
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/FitnessCenter/1.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/FitnessCenter/2.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/FitnessCenter/3.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/FitnessCenter/4.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/FitnessCenter/5.jpg",
  //     ],
  // },
  // {
  //     key: "2",
  //     heading: "Recreation Room",
  //     description:
  //         "Salaam Takaful understands the significance of providing moments of relaxation and rejuvenation for our employees. Our thoughtfully designed recreation room is a retreat for unwinding and recharging. Immerse yourself in a game of pool, find solace in the quiet reading corner, enjoy the therapeutic benefits of our massage chair, or engage in friendly competition with activities like darts, board games, and table tennis. This space is carefully crafted to foster camaraderie and relaxation, ensuring a dynamic and friendly workplace culture. Join us in creating lasting memories through the array of regular events and activities that add vibrancy to our shared work environment.",
  //     images: [
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/RecreationRoom/1.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/RecreationRoom/2.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/RecreationRoom/3.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/RecreationRoom/4.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/RecreationRoom/5.jpg",
  //         "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/RecreationRoom/6.jpg",
  //     ],
  //     speed: 3200,
  // },
  {
    key: "3",
    heading: "Segregated Prayer Area",
    description:
      "At Salaam Takaful, inclusivity is at the heart of our workplace ethos. Recognizing the diverse cultural and religious backgrounds of our esteemed team, we have established a Segregated Prayer Area within our premises. This dedicated space is meticulously designed to facilitate the diverse spiritual needs of our employees, allowing them to observe their religious practices with ease and convenience. We firmly believe that fostering an inclusive and respectful workplace culture is not only an integral part of our identity but also paramount to the overall well-being of our valued team members.",
    images: [
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/SegregatedPrayerArea/PR1.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/SegregatedPrayerArea/PR2.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/SegregatedPrayerArea/PR3.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/SegregatedPrayerArea/PR4.jpg",
    ],
    speed: 4000,
  },
  {
    key: "4",
    heading: "Girls’ Common Room",
    description:
      "In our commitment to providing an environment that supports the diverse needs of our workforce, Salaam Takaful proudly presents the Girls Common Room. This exclusive space is tailored to cater to the specific preferences and requirements of our female team members. Whether it's a comfortable area for breaks, collaborative discussions, or a private sanctuary for personal moments, the Girls Common Room is a reflection of our dedication to creating an inclusive workplace that prioritizes the comfort and empowerment of every individual within our team.",
    images: [
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/GIRLSCOMMONROOM/Girls-Common-Room.jpg",
    ],
    speed: 5000,
  },
];
export const LifeAtSalaamGrowthData = [
  {
    key: "1",
    heading: "Events",
    images: [
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/1.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/2.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/3.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/4.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/5.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/6.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/7.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/8.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/9.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/10.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/11.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/EVENTS/12.jpg",
    ],
    speed: 1800,
    data: [
      {
        heading: "Team Building Events",
        description:
          "At Salaam Takaful, we believe in the power of team spirit. Regular events, such as team-building activities and casual gatherings, are organized to strengthen the bonds among our employees. These events provide opportunities for collaboration, communication, and a shared sense of purpose, contributing to a positive and dynamic work environment.",
      },
      {
        heading: "Special Events",
        description:
          "We love to celebrate milestones and create lasting memories. Salaam Takaful hosts special events throughout the year, including annual parties, holiday celebrations, and significant milestones. These events bring our team together in a festive spirit, fostering a sense of belonging and camaraderie that extends beyond the workplace.",
      },
      {
        heading: "Community Engagement",
        description:
          "Salaam Takaful is committed to making a positive impact beyond the workplace. We actively engage with the community through various initiatives, including charity drives, volunteering, and partnerships with local organizations. By contributing to the community, we not only fulfill our corporate social responsibility but also strengthen the bonds between our employees and the wider society.",
      },
    ],
  },
  {
    key: "2",
    heading: "Engagements",
    description:
      "Salaam Takaful understands the significance of providing moments of relaxation and rejuvenation for our employees. Our thoughtfully designed recreation room is a retreat for unwinding and recharging. Immerse yourself in a game of pool, find solace in the quiet reading corner, enjoy the therapeutic benefits of our massage chair, or engage in friendly competition with activities like darts, board games, and table tennis. This space is carefully crafted to foster camaraderie and relaxation, ensuring a dynamic and friendly workplace culture. Join us in creating lasting memories through the array of regular events and activities that add vibrancy to our shared work environment.",
    images: [
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/ENGAGEMENT/1.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/ENGAGEMENT/2.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/ENGAGEMENT/3.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/ENGAGEMENT/4.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/ENGAGEMENT/5.jpg",
    ],
    data: [
      {
        heading: "Walkathon",
        description:
          "Promoting employee well-being is a priority at Salaam Takaful. Our annual walkathons and wellness challenges encourage a healthy and active lifestyle among our team members.These events not only contribute to physical fitness but also create a sense of community and teamwork, fostering a positive and supportive workplace culture. ",
      },
      {
        heading: "Awards and Recognitions",
        description:
          "Salaam Takaful takes pride in recognizing and celebrating the achievements of our employees. Whether it's individual milestones, outstanding contributions, or industry awards, we showcase and acknowledge the accomplishments of our team members. This culture of appreciation motivates our employees and reinforces the value we place on their dedication and hard work.",
      },
    ],
    speed: 3000,
  },
  {
    key: "3",
    heading: "Breakfast Event",
    images: [
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/1.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/2.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/3.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/4.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/5.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/6.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/7.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/8.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/9.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/10.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/11.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/12.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/13.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/BREAKFAST/14.jpg",
    ],
    speed: 2800,
    data: [
      {
        heading: "Breakfast Gathering",
        description:
          "Salaam Takaful celebrated a memorable Breakfast Event, bringing our team together to start the day with warmth and camaraderie. The event reflected our commitment to fostering a positive workplace culture where colleagues connect over shared moments. From a thoughtfully arranged spread to the lively conversations and smiles, the breakfast gathering reinforced the spirit of unity and well-being that defines life at Salaam.",
      },
    ],
  },
];

export const LifeAtSalaamLearningData = [
  {
    key: "1",
    heading: "Professional Mastery",
    description:
      "At Salaam Takaful, we are dedicated to sculpting the expertise of our team through targeted Professional Skill Development. This initiative focuses on the mastery of tools critical to our operations, including project management, Excel, and artificial intelligence (AI). Our commitment extends to comprehensive training programs, ensuring our employees not only adapt to industry trends but become proficient leaders in utilizing these technologies.",
    images: [
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/PROFESSIONALMASTERY/1.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/PROFESSIONALMASTERY/2.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/PROFESSIONALMASTERY/3.jpg",
    ],
    speed: 1500,
  },
  {
    key: "2",
    heading: "Nurturing Soft Skills",
    description:
      "Salaam Takaful places a premium on continuous improvement through our Skill Enhancement programs, specifically tailored to refine the soft skills essential in the Takaful industry. By focusing on interpersonal dynamics, communication, adaptability, and problem-solving, we empower our team to excel not only in their roles but also in contributing to the harmonious and collaborative culture at the heart of our organization's success.",
    images: [
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/NurturingSoftSkills/1.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/NurturingSoftSkills/2.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/NurturingSoftSkills/3.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/NurturingSoftSkills/4.jpg",
      "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/NurturingSoftSkills/5.jpg",
    ],
    speed: 2400,
  },
];

export const LifeAtSalaamCertification2026Data = [
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/1.jpeg",
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/2.jpeg",
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/3.jpeg",
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/4.jpeg",
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/5.jpeg",
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/6.jpeg",
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/7.jpeg",
  "https://asset.salaamtakaful.com/GeneralAssets/Assets/lifeatsalaam/2026CERTIFICATION/8.jpeg",
];
/**
 * Organizational Chart Data - Hierarchical Structure
 * 
 * Each node has:
 * - id: unique identifier
 * - name: display name
 * - level: styling level (board, executive, cxo, advisory, committee, head, department, subdepartment)
 * - children: array of child nodes (optional)
 * - dotted: boolean for dotted line reporting (optional)
 * - position: 'left' | 'center' | 'right' for top-level positioning (optional)
 */
export const OrganizationChartData = {
  id: "board",
  name: "BOARD",
  level: "board",
  children: [
    {
      id: "shariah-advisor",
      name: "Shariah Advisor",
      level: "advisory",
      position: "left",
      children: [
        {
          id: "shariah-compliance",
          name: "Shariah Compliance Officer",
          level: "department",
        },
      ],
    },
    {
      id: "ceo",
      name: "Chief Executive Officer",
      level: "executive",
      position: "center",
      children: [
        {
          id: "cfo",
          name: "Chief Financial Officer & Company Secretary",
          level: "cxo",
          dotted: true,
          children: [
            { id: "finance", name: "Finance & Accounts", level: "department" },
            { id: "admin", name: "Administration", level: "department" },
            { id: "legal", name: "Legal & Corporate Affairs", level: "department" },
            { id: "it", name: "Information Technology", level: "department" },
            {
              id: "compliance",
              name: "Compliance & Risk Management",
              level: "department",
              children: [
                { id: "compliance-officer", name: "Compliance Officer", level: "subdepartment" },
              ],
            },
          ],
        },
        {
          id: "sales-marketing",
          name: "Head of Sales & Marketing",
          level: "head",
          children: [
            { id: "branch", name: "Branch Network", level: "department" },
            { id: "agents", name: "Agents", level: "department" },
            { id: "brokers", name: "Brokers", level: "department" },
            { id: "aggregators", name: "Aggregators (Branch & Direct)", level: "department" },
            { id: "agency", name: "Agency Department", level: "department" },
          ],
        },
        {
          id: "operations",
          name: "Head of Operations",
          level: "head",
          children: [
            { id: "uw", name: "U/w all classes", level: "department" },
            { id: "claims", name: "Claims all Classes", level: "department" },
            { id: "treaty", name: "Treaty", level: "department" },
          ],
        },
        {
          id: "retail-sales",
          name: "Head of Retail Sales",
          level: "head",
          children: [
            { id: "retail-agent", name: "Retail Sales Agent", level: "department" },
            { id: "customer-service", name: "Customer Service", level: "department" },
            { id: "telesales", name: "Telesales", level: "department" },
            { id: "retail-back", name: "Retail Sales (Back Office)", level: "department" },
          ],
        },
        {
          id: "hr",
          name: "Human Resources",
          level: "head",
        },
        {
          id: "products",
          name: "Products & Development",
          level: "department",
        },
        {
          id: "marketing",
          name: "Marketing",
          level: "department",
        },
        {
          id: "exec-secretariat",
          name: "Executive Secretariat",
          level: "department",
        },
      ],
    },
    {
      id: "audit-committee",
      name: "Board Audit Committee",
      level: "committee",
      position: "right",
      children: [
        {
          id: "internal-audit",
          name: "Internal Audit Department",
          level: "department",
          dottedToAll: true,
        },
      ],
    },
  ],
};

export const Articles = [
  {
    Key: 2205,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/UnderstandingConceptTabarru.jpg",
    heading:
      "Understanding the Concept of Tabarru: The Core of Islamic Insurance",
    archead:
      "Understanding the Concept of Tabarru: The Core of Islamic Insurance",
    content:
      "Insurance plays a vital role in providing financial security, but not all forms align with Islamic principles. In conventional insurance, practices like interest (riba) and uncertainty (gharar) can conflict with Shariah law, making them impermissible in Islam. This is where Takaful insurance steps in, offering a solution rooted in the spirit of mutual assistance and shared responsibility. At the heart of Shariah-compliant insurance, Tabarru plays a key role, representing a voluntary contribution intended to help others in times of need.",
    excerpt: "",
    content1:
      'Tabarru, derived from the Arabic word for "donation," forms the foundation of the Takaful model, making it distinct from conventional insurance. Participants contribute to a Takaful pool with the intention of mutual aid rather than profit. This collective approach transforms insurance into a community-driven system, promoting Islamic values such as compassion and solidarity. Salaam Takaful Limited, a leading Shariah-compliant insurance company, implements this principle across its diverse range of products, ensuring transparency and trust in every transaction.',
    content2:
      "The principle of Tabarru ensures that all financial dealings in Takaful are both ethical and compliant with Islamic guidelines. Unlike conventional policies where premiums are paid directly to a company, Takaful participants donate to a shared pool managed on their behalf. Any surplus in the pool is either reinvested for the collective benefit or distributed among the contributors. This not only eliminates exploitation but also fosters a sense of community. With Salaam Takaful's focus on ethical practices and Islamic insurance solutions, participants can rest assured that their contributions are being utilized responsibly.",
    content3:
      "Moreover, Tabarru enables risk-sharing in a manner that is both equitable and sustainable. Participants are not just policyholders but also co-owners of the Takaful fund, reinforcing the idea of collective responsibility. Salaam Takaful's innovative and data-driven approach ensures that this mutual model remains efficient and inclusive, catering to the evolving needs of policyholders in a digitally driven world.",
    content4:
      "By embracing the principle of Tabarru, Salaam Takaful Limited stands at the forefront of providing ethical financial solutions that align with Islamic values. Takaful not only offers a sustainable model for risk management but also reinforces the concept of helping others as a community. This modern yet faith-based approach bridges the gap between tradition and innovation, making Takaful a preferred choice for individuals seeking peace of mind with Shariah compliance.",
    date: "18-03-2024",
  },
  {
    Key: 2204,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/ESGImportance.png",
    heading: "The Importance of ESG: A Focus on the Social Dimension",
    archead: "The Importance of ESG: A Focus on the Social Dimension",
    content:
      "Environmental, Social, and Governance (ESG) principles have become a cornerstone for responsible business practices worldwide. ESG encompasses three critical pillars: environmental responsibility, social commitment, and governance excellence. The environmental aspect focuses on minimizing ecological footprints, combating climate change, and ensuring sustainable resource use. Governance emphasizes transparency, ethical decision-making, and robust compliance mechanisms. Equally important, the social angle addresses societal welfare, diversity, inclusivity, and equitable opportunities. Collectively, ESG fosters resilience, trust, and long-term value creation, making it indispensable for businesses aiming to thrive responsibly. At the corporate level, integrating ESG ensures sustainable growth, aligns with stakeholder expectations, and builds a legacy of meaningful impact.",
    excerpt:
      "The insurance industry is undergoing a monumental transformation, driven by the advent of Insurtech—technology-driven innovation reshaping how insurance and...",
    content1:
      "At Salaam Takaful Limited, the social dimension of ESG serves as a guiding principle, enabling us to make a tangible difference in the communities we operate in. In 2024, we have actively pursued initiatives that reflect our steadfast commitment to societal welfare. Our Qarz-e-Hasna program has provided interest-free loans to individuals in need, empowering them with financial inclusion and stability. Through strategic academic alliances, we have fostered knowledge sharing and capacity building, equipping the youth with essential skills to shape a brighter future. Similarly, our MTO Madaris Program has bridged the gap between traditional and modern education, preparing students from madaris for diverse career paths and enabling them to contribute meaningfully to the economy.",
    content2:
      "Our partnership with Deaf Reach has championed the inclusion of the differently abled, creating opportunities for them to thrive in an equitable environment. This collaboration underscores our belief in a society where everyone can succeed, irrespective of physical or sensory challenges. In addition, we have collaborated with the Karachi Down Syndrome Program (KDSP) to create meaningful employment opportunities for individuals with Down syndrome. This initiative has promoted workplace inclusivity and diversity, reinforcing our commitment to a society that values every individual's potential. By integrating such impactful programs into our operations, we continue to build an equitable and inclusive community.",
    content3:
      "These efforts reaffirm Salaam Takaful Limited’s dedication to the social angle of ESG. However, the journey doesn’t end here. True progress requires collective action. We encourage other organizations to adopt ESG principles and contribute to societal well-being. Together, we can create a future that’s not only financially secure but also socially inclusive, environmentally sustainable, and ethically governed. By working hand in hand, we can build a legacy of shared prosperity and meaningful change.",
    date: "18-03-2024",
  },
  {
    Key: 2202,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/RiseOfInsuretech.jpg",
    heading:
      "The Rise of Insurtech: Transforming the Way You Manage Your Assets",
    archead:
      "The Rise of Insurtech: Transforming the Way You Manage Your Assets",
    content:
      "The insurance industry is undergoing a monumental transformation, driven by the advent of Insurtech—technology-driven innovation reshaping how insurance and takaful services are delivered. Across the globe, Insurtech is enhancing efficiency, transparency, and customer-centricity. From automated claims processing to personalized policy options, these advancements are redefining how individuals and businesses safeguard their assets, making the industry more accessible and adaptable than ever before.",
    excerpt:
      "The insurance industry is undergoing a monumental transformation, driven by the advent of Insurtech—technology-driven innovation reshaping how insurance...",
    content1:
      "One of the key breakthroughs in the Insurtech revolution is the use of parametric and telematics-based solutions. Unlike traditional insurance/takaful, which relies on lengthy assessments and documentation, parametric and telematics-based solutions utilize data-driven triggers to enable instant payouts. Globally, these types of insurance have become a game-changer for industries. ",
    content2:
      "Salaam Takaful Limited stands at the forefront of this transformation, leveraging cutting-edge technology to redefine the insurance and takaful landscape. With innovative solutions like Salaam Parametric-based Crop Takaful, Salaam Pay as You Drive Motor Takaful, and Salaam Travel Takaful, the company is revolutionizing how assets are protected, ensuring unmatched convenience and peace of mind.",
    content3:
      "Salaam Takaful Limited changes the narrative with parametric solutions that offer automated, instant payouts. For example, Salaam Parametric Crop Takaful uses weather data to protect farmers against adverse conditions, enabling faster claims processing and timely financial support. Salaam Takaful recognizes the challenges farmers face, including climate-based calamities, and is committed to helping them become more resilient against climate change.",
    content4:
      "Another revolutionary development is Salaam Pay as You Drive Motor Takaful. Globally recognized as a fairer approach, this product leverages telematics to calculate contributions based on actual mileage. It not only ensures cost savings for low-mileage drivers but also promotes environmental responsibility by encouraging reduced vehicle use. The widespread adoption of such innovative solutions highlights how insurtech is reshaping perceptions of insurance and takaful, making them more dynamic and policyholder focused.",
    content5:
      "Similarly, Salaam Travel Takaful features groundbreaking parametric-based flight disruption coverage, eliminating concerns about delays. This feature provides instant and automatic compensation, easing the financial burden caused by disrupted schedules. This customer-centric approach highlights Salaam Takaful’s commitment to simplifying takaful experiences.",
    content6:
      "As Insurtech continues to evolve, it is setting new benchmarks for the insurance and takaful sectors, pushing them towards a future that prioritizes efficiency, transparency, and inclusivity. Salaam Takaful Limited believes in leading the way, blending technological innovation with ethical values to redefine asset protection.",
    content7:
      "The rise of Insurtech is more than a trend; it’s a shift towards a smarter, more resilient industry. By embracing these innovations, providers and policyholders alike are stepping into an era where protecting assets is no longer a cumbersome task but an empowering, proactive journey.",
    date: "18-03-2024",
  },
  {
    Key: 2203,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/Pinktober.jpg",
    heading: "Pinktober - Breast Cancer Awareness",
    archead: "Pinktober - Breast Cancer Awareness",
    excerpt:
      "The insurance industry is undergoing a monumental transformation, driven by the advent of Insurtech—technology-driven innovation reshaping how insurance...",
    content:
      "Women often take on multiple responsibilities—whether as mothers, wives, or professionals—prioritizing their families' needs over their own. In doing so, they may overlook their own health. However, self-care is essential, especially when it comes to serious conditions like breast cancer. As the second most common cancer globally, breast cancer affects millions of women each year, with around 2.3 million new cases diagnosed annually. Despite its prevalence, many remain unaware of the critical importance of early detection and preventive measures.",
    content1:
      "Pinktober, or Breast Cancer Awareness Month, is a global initiative held every October to remind women to prioritize their health. Throughout this month, people worldwide wear pink ribbons to raise awareness about breast cancer prevention and the need for routine screenings. The key symptoms to watch for include lumps in the breast or armpit, changes in the size or shape of the breast, dimpling of the skin, or unusual nipple discharge. Regular screenings, mammograms, and self-examinations are vital, as early detection can dramatically increase the chances of successful treatment.",
    content2:
      "Preventing breast cancer begins with leading a healthy lifestyle—maintaining a balanced diet, staying physically active, avoiding smoking and excessive alcohol, and ensuring regular health check-ups. If any unusual changes in the breasts are detected, women should consult their doctors immediately. However, even with preventive care, the emotional and financial toll of breast cancer can be overwhelming. This is where having comprehensive health coverage becomes crucial.",
    content3:
      "At Salaam Takaful Limited, we understand the importance of accessible healthcare, which is why we offer Salaam Sehat Takaful. This product is designed to provide you and your family with coverage when you need it most. With Salaam Sehat Takaful, the financial burden of medical expenses, including cancer treatments, is eased. Whether it's diagnostics, hospital care, or ongoing support, this coverage ensures that women have access to the care they need, particularly in cases of breast cancer.",
    content4:
      "Awareness, early detection, and timely medical intervention can save lives. The stories of women who have fought and survived breast cancer serve as powerful reminders of strength and resilience. No woman should feel alone in this battle. At Salaam Takaful Limited, we stand with you, providing the support and coverage necessary for your health journey, not just during Breast Cancer Awareness Month, but every day.",
    content5:
      "Being informed, proactive, and securing comprehensive health coverage can make all the difference. By doing so, women can protect their health and take control of their futures.",
    date: "18-03-2024",
  },
  {
    Key: 2201,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/Crop.jpg",
    heading:
      "Resilient Farmers, Stronger Future: The Role of Salaam Parametric Crop Takaful",
    content:
      "Pakistan remains an agricultural economy at its core, with a significant portion of the population dependent on farming for their livelihood. Agriculture accounts for about 24% of the country�s GDP and employs nearly 37.4% of the labor force. Yet, despite this vital role, farmers in Pakistan, especially smallholders, often find themselves at the mercy of unpredictable weather patterns, economic instability, and limited access to financial products. Their crops are not just a source of income but their sole lifeline. Any disruption, whether due to natural calamities or market volatility, can plunge these farmers into financial hardship, pushing them further into poverty. This makes innovative solutions critical for protecting their livelihoods and ensuring stability in an increasingly uncertain world.\n\nOne such innovative solution is Parametric-based Crop Takaful, an integral part of Salaam Takaful�s product offerings. It is designed to safeguard farmers from the adverse effects of climate change and natural disasters, providing financial protection without any hurdles. Unlike traditional insurance, which often requires lengthy damage assessments, parametric takaful offers swift payouts based on a predetermined weather index. This ensures peace of mind for farmers to continue their work, knowing they have a safety net in place.\n\nSalaam Takaful Limited is committed to continuously bringing forward modern solutions to address the challenges faced by farmers. Parametric-based Crop Takaful reflects the company's drive to innovate and make life easier for those who need it most. As Salaam Takaful pushes the boundaries of shariah-compliant products, it remains dedicated to empowering farmers and supporting the agricultural growth of Pakistan. The company will continue to spearhead initiatives that protect livelihoods, foster resilience, and contribute to broader goals of economic stability and food security.\n\n\n\nReference: https://www.finance.gov.pk/survey/chapter_24/2_agriculture.pdf",
    excerpt:
      "Pakistan remains an agricultural economy at its core, with a significant portion of the population dependent on farming for their livelihood. Agriculture accounts for about 24% of the country�s GDP and employs nearly 37.4% of the labor force. Yet, despite this vital role, farmers in Pakistan, especially smallholders, often find themselves at the mercy of unpredictable weather patterns, economic instability, and limited access to financial products. Their crops are not just a source of income but their sole lifeline. Any disruption, whether due to natural calamities or market volatility, can plunge these farmers into financial hardship, pushing them further into poverty. This makes innovative solutions critical for protecting their livelihoods and ensuring stability in an increasingly uncertain world.\n\nOne such innovative solution is Parametric-based Crop Takaful, an integral part of Salaam Takaful�s product offerings. It is designed to safeguard farmers from the adverse effects of climate change and natural disasters, providing financial protection without any hurdles. Unlike traditional insurance, which often requires lengthy damage assessments, parametric takaful offers swift payouts based on a predetermined weather index. This ensures peace of mind for farmers to continue their work, knowing they have a safety net in place.\n\nSalaam Takaful Limited is committed to continuously bringing forward modern solutions to address the challenges faced by farmers. Parametric-based Crop Takaful reflects the company's drive to innovate and make life easier for those who need it most. As Salaam Takaful pushes the boundaries of shariah-compliant products, it remains dedicated to empowering farmers and supporting the agricultural growth of Pakistan. The company will continue to spearhead initiatives that protect livelihoods, foster resilience, and contribute to broader goals of economic stability and food security.\n\n\n\nReference: https://www.finance.gov.pk/survey/chapter_24/2_agriculture.pdf",
    date: "20/09/2024",
  },
  {
    Key: 2200,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/Bike.jpg",
    heading: "Salaamti Bike Takaful: Your Ultimate Shield",
    content:
      "In Pakistan, motorcycles are a popular mode of transportation, used by millions across the country. From daily commuters to delivery riders, motorbikes are a convenient and affordable means of travel. However, the increasing number of motorcycles on the roads has also led to a rise in motorcycle accidents. Statistics reveal that motorbike accidents constitute a significant portion of traffic incidents, often resulting in severe injuries and fatalities. Despite this, there is a noticeable gap in the market when it comes to awareness and adoption of bike insurance/bike takaful. While car insurance/takaful is a more commonly understood and utilized product, the motorbike segment remains largely underserved. This lack of awareness and protection leaves bikers vulnerable to financial and personal loss in the event of an accident.  To address this pressing need, Salaam Takaful Limited offers Salaamti Bike Takaful, a comprehensive motorbike Islamic insurance product designed to provide bikers with the coverage they need. This Bike Takaful plan is specifically tailored for bike owners, offering protection against a wide array of risks, including burglary, theft, fire, and natural disasters such as earthquakes and floods. Additionally, it covers damage from external explosions, riots, strikes, and acts of terrorism. Salaamti Bike Takaful also extends its protection to incidents that occur while the bike is in transit, whether by air, road, rail, or other means. Optional benefits include third-party liability coverage, which provides compensation for death or injury to third parties and damage to third-party property, making it a robust solution for the diverse risks faced by bikers.  Recognizing the significant gap in the market, Salaam Takaful Limited is committed to developing products that cater to underserved segments like bikers. By offering Salaamti Bike Takaful, the company is addressing a crucial need and raising awareness about the importance of bike takaful. Salaam Takaful&rsquo;s consistent efforts to tap into this untapped market reflect its dedication to providing ethical, inclusive, and comprehensive coverage solutions that protect individuals and communities alike. Through such initiatives, Salaam Takaful is setting new standards in the industry, ensuring that all road users have access to the protection they deserve.  &nbsp;",
    excerpt:
      "In Pakistan, motorcycles are a popular mode of transportation, used by millions across the country. From daily commuters to delivery riders, motorbikes are a convenient and affordable means of travel....",
    date: "15/08/2024",
  },
  {
    Key: 2194,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/InusrancevsTakaful.jpg",
    heading:
      "Why Choose Takaful? : Discover the Halal Path to Financial Protection",
    content:
      'How Takaful is Different from Insurance and Why is it Halal The financial services industry offers various risk management solutions, including traditional insurance and Takaful. While both serve similar purposes, they differ fundamentally in principles and operations.<  Understanding Takaful/h4>  Takaful, derived from the Arabic word "kafalah" (guaranteeing each other), is an Islamic alternative to conventional insurance. It operates on mutual assistance, solidarity, and shared responsibility. Participants pool their contributions into a common fund used to support members who suffer losses. Any surplus at the end of the term is distributed back to the participants, enhancing the community-centric ethos of Takaful.<  <span class="example1">Key Differences Between Takaful (Islamic Insurance) and Conventional Insurance   Risk Sharing vs. Risk Transfer    <ul style="list-style-type: square;">  Takaful: Risk is shared among all participants. Pooled contributions compensate any member who incurs a loss, emphasizing collective responsibility.</span><  Insurance: Risk is transferred from the policyholder to the insurer in exchange for a premium. The insurer compensates covered losses, creating a contractual relationship.</span></span><      Profit Motive         Takaful: Structured as a non-profit arrangement. Surplus after claims and expenses is returned to participants or kept for future claims, focusing on mutual benefit.</span>< Insurance: For-profit entities. Premiums are invested to generate returns for shareholders, and any surplus is kept by the company.</span></span><        Investment Practices         Takaful: Investments adhere strictly to Shariah (Islamic law), avoiding interest (Riba), gambling (Maysir), and prohibited (Haram) industries such as alcohol, pork, and gambling.</span>< Insurance: Premiums are invested in various financial instruments, including those that may not comply with Shariah principles, like interest-bearing bonds.</span><        Contractual Framework      <ul style="list-style-type: square;"> Takaful: Based on Tabarru (donation), where participants donate contributions to help others. The relationship is cooperative and not commercial.</span>< Insurance: Commercial contracts based on the exchange of premiums for coverage, with defined financial obligations between the insurer and the insured.</span><     Takaful is Halal because it adheres to Shariah principles, avoiding Riba (interest), Gharar (excessive uncertainty), and Maysir (gambling). It ensures ethical investments in Shariah-compliant ventures, reflecting Islamic values of social justice and responsibility. The mutual cooperation in Takaful, where resources are pooled for the common good, aligns with the Islamic principle of helping one another, fostering a sense of community and brotherhood.</span>  &nbsp;  Additionally, Takaful operates as a non-profit model, with any surplus distributed back to participants rather than being retained for profit. This reinforces its ethical stance and contrasts with the profit-driven nature of conventional insurance. By understanding these differences, Muslims can make informed choices that align with their religious values and beliefs.</span>',
    excerpt:
      "How Takaful is Different from Insurance and Why is it&nbsp; Halal The financial services industry offers various risk management solutions, including traditional insurance and Takaful. While both serve similar purposes ...",
    date: "23/07/2024",
  },
  {
    Key: 2189,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/SalaamRaabta.jpg",
    heading:
      "Transforming Policyholder Service with Salaam Raabta: The Ultimate WhatsApp Assistant for Convenience",
    content:
      "In the fast-paced digital era, Salaam Raabta emerged as a revolutionary WhatsApp assistant designed to transform Policyholder interactions. Offering 24-hour service, Salaam Raabta ensures instant replies, providing a seamless and convenient Policyholder experience. This innovative assistant caters to the growing demand for efficiency, user-friendliness, and effective routing, making it an indispensable tool for businesses.  Seamless Policyholder Experience and Convenience  Salaam Raabta is designed with the policyholders in mind, offering a seamless and convenient experience. The assistant allows for interactive and efficient navigation, making it easy for Policyholders to find the information they need. Whether it&rsquo;s getting a quick quote, requesting a callback, or seeking human assistance, Salaam Raabta simplifies the process, ensuring a hassle-free experience.  Efficient Routing  Efficiency is at the heart of Salaam Raabta. The assistant employs advanced algorithms to provide efficient routing, directing Policyholders' inquiries to the appropriate department or personnel. This not only saves time but also ensures that Policyholders receive accurate and relevant information swiftly.  Instant Product Information and Quick Quotes  In today's competitive market, instant access to product information is crucial. Salaam Raabta delivers instant product info, allowing Policyholders to make informed decisions quickly. Additionally, the assistant offers a feature to get a quick quote, providing potential Policyholders with pricing information in real-time.  24/7 Service and Instant Replies  One of the standout features of Salaam Raabta is its 24/7 availability. Policyholders can engage with its interactive WhatsApp chat at any time, receiving instant replies to their queries. This round-the-clock service ensures that Policyholder needs are met promptly, significantly enhancing satisfaction.  Request a Callback and Human Assistance  Understanding the importance of personalized service, Salaam Raabta includes options to request a callback or connect with human assistance. This ensures that Policyholders who prefer a more personal touch can easily get the help they need. By combining automated efficiency with human interaction, Salaam Raabta offers the best of both worlds.  For Salaam Takaful Limited aiming to stay ahead in the digital landscape, adopting Salaam Raabta is a strategic move toward achieving superior Policyholder satisfaction and operational excellence.",
    excerpt:
      "In the fast-paced digital era, Salaam Raabta emerged as a revolutionary WhatsApp assistant designed to transform Policyholder interactions. Offering 24-hour service, Salaam Raabta ensures instant replies, providing a seamless and convenient Policyholder e.....",
    date: "25/06/2024",
  },
  {
    Key: 2183,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/HeatStroke.jpg",
    heading: "Heat Stroke Awareness",
    content:
      "Heat stroke is a serious medical condition that occurs when the body's temperature regulation system fails due to prolonged exposure to high temperatures or physical exertion in hot environments.  Signs &amp; Symptoms:    High body temperature: core body temperature above 39.4&deg;C (103&deg;F) is a primary indicator.<  Altered mental state:onfusion, agitation, slurred speech, irritability, delirium, seizures, and coma.<  Skin changes:ed, hot, and dry skin, particularly in non-sweating heat stroke, though in exertional heat stroke, the skin may be moist.<  Nausea and vomiting:hese symptoms often accompany heat stroke.<  Rapid heartbeat and breathing:he body works harder to cool itself, resulting in a strong, rapid pulse and breathing.<  Headache: throbbing headache is common.&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<   &nbsp;  Preventive Measures:    Stay Hydrated:rink plenty of fluids throughout the day. Water is essential, but sports drinks can also help replenish electrolytes lost through sweat. Avoid alcohol and caffeine as they can contribute to dehydration.<  Wear Appropriate Clothing:pt for lightweight, loose-fitting, and light-colored clothes that allow your body to breathe and sweat to evaporate. Use a wide-brimmed hat and sunglasses for additional protection from the sun.<  Seek Shade and Cool Environments:inimize exposure to direct sunlight, particularly during the peak heat hours from 10 a.m. to 4 p.m. Stay indoors as much as possible, preferably in air-conditioned spaces. If air conditioning is not available, use fans, cool showers, and wet clothes to help lower your body temperature.<  Plan Activities Wisely:chedule outdoor activities for the cooler parts of the day, such as early morning or late evening. Take frequent breaks in shaded or cool areas to prevent overheating.<  Use Sunscreen:pply a broad-spectrum sunscreen with an SPF of at least 30 to prevent sunburn, which can impair your body&rsquo;s ability to cool down.<  Acclimate Gradually:f you are not accustomed to high temperatures, gradually increase your exposure to the heat to help your body adjust. This is particularly important for those who work outdoors or engage in physical activities.<  Monitor High-Risk Individuals:lderly people, infants, young children, individuals with chronic illnesses, and those on certain medications are at higher risk. Ensure they stay cool and hydrated, and check on them frequently.<  Recognize Early Symptoms:eing aware of the early symptoms of heat-related illnesses can prevent escalation to heat stroke. Signs such as heavy sweating, muscle cramps, fatigue, weakness, and dizziness should prompt immediate action to cool down and hydrate.<   Immediate Response to Heat Stroke  If you suspect someone is experiencing heat stroke, it is critical to act fast. Move the person to a cooler place and apply cool, wet clothes to their skin. Use fans to circulate air around them and, if possible, immerse them in cool water. Call emergency services immediately, as heat stroke is a medical emergency requiring prompt professional intervention.  With temperatures set to rise significantly, it is crucial to be vigilant and prepared. By recognizing the signs and symptoms of heat stroke and implementing effective preventive steps, you can protect yourself and others from the potentially deadly effects of extreme heat. Stay cool, stay hydrated, and stay safe during the heatwave.  &nbsp;",
    excerpt:
      "Heat stroke is a serious medical condition that occurs when the body's temperature regulation system fails due to prolonged exposure to high temperatures or physical exertion in hot environments….",
    date: "22/05/2024",
  },
  {
    Key: 2179,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/Globaltakaful.jpg",
    heading: "Trends in the Global Takaful Industry",
    content:
      "In the ever-evolving landscape of the global takaful market, several trends are shaping the future of Islamic insurance. Technological advancements, regulatory shifts, and market expansion are pivotal factors influencing the direction of the industry. Adaptation and innovation in sustainable takaful practices have become imperative for takaful providers to thrive in this dynamic environment.  As technology continues to revolutionize various sectors, the takaful industry is no exception. Salaam Takaful recognizes the importance of staying ahead in this digital age. By integrating cutting-edge technology, Salaam Takaful enhances its operations and improves customer experience. Through user-friendly mobile apps and online portals, Salaam Takaful ensures seamless interactions and convenient access to Takaful insurance solutions, aligning itself with the trend of technological innovation.  Moreover, regulatory changes are playing a crucial role in shaping the takaful landscape globally. Regulators are increasingly focusing on strengthening governance frameworks and risk management practices within the sector. Salaam Takaful in line with SECP regulations remains committed to upholding regulatory standards and adhering to Shariah principles. Through robust compliance mechanisms and transparent practices, Salaam Takaful maintains trust and credibility among its stakeholders, in line with the evolving regulatory landscape.  Furthermore, the takaful industry is witnessing significant growth, driven by increasing awareness of Islamic finance and expanding consumer demand. Emerging Takaful markets&nbsp;present vast opportunities worldwide for takaful providers to expand their footprint.  Looking ahead, Salaam Takaful remains committed to innovation, compliance, and sustainable growth. By embracing technological advancements and adapting to regulatory developments, Salaam Takaful is well-prepared to navigate the complexities of the takaful landscape and deliver value to its stakeholders. With a forward-thinking approach and commitment to Islamic principles, Salaam Takaful looks towards a future of continued success and prosperity in the dynamic world of Islamic insurance.",
    excerpt:
      "In the ever-evolving landscape of the global takaful market, several trends are shaping the future of Islamic insurance. Technological advancements, regulatory shifts, and market expansion are pivotal factors …",
    date: "08/05/2024",
  },
  {
    Key: 2175,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/Marine.jpg",
    heading: "Safety In Transit: Salaam Marine Takaful",
    content:
      "Salaam Takaful leads the way in innovative Islamic insurance solutions, leveraging state-of-the-art technology to empower business owners across various sectors. With a diverse range of products designed to address the evolving needs of modern enterprises, Salaam Takaful stands at the forefront of the industry, revolutionizing the way businesses manage risk and protect their assets.  In the ever-evolving landscape of global trade, safeguarding cargo against risks is paramount. Cargo interests, spanning from importers to exporters, navigate a complex web of challenges, ranging from theft and damage to natural disasters and accidents. Amidst these uncertainties, Salaam Marine Takaful emerges as a beacon of security and reliability.  Salaam Marine Takaful offers a comprehensive solution tailored to the needs of cargo owners. Its unique approach combines the principles of Islamic finance with modern insurance practices, ensuring both financial protection and adherence to ethical principles  One of the key selling points of Salaam Marine Takaful lies in its versatility. Whether goods are transported by sea, air, land, or parcel post, Salaam Marine Takaful provides comprehensive coverage from warehouse to warehouse. This all-encompassing protection shields cargo owners from numerous risks, ensuring that their goods reach their destination safely.  Moreover, Salaam Marine Takafulstands out for its emphasis on transparency and fairness. With clear and straightforward terms, clients can trust in the integrity of the coverage they receive. This commitment to ethical business practices not only aligns with Islamic principles but also fosters trust and credibility in the broader marketplace.  Salaam Takaful, living up to its reputation, will continue to bring innovative solutions for its corporate clients. These solutions will not only help them face potential risks but also keep them a step ahead with their risk management.",
    excerpt:
      "Salaam Takaful leads the way in innovative Islamic insurance solutions, leveraging state-of-the-art technology to empower business owners across various sectors. With a diverse range of products designed to address the evolving needs of modern enterprises, Salaam Takaful stands at the forefront of the industry, revolutionizing the way ....",
    date: "05/04/2024",
  },
  {
    Key: 2171,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/OralHealth.jpg",
    heading: "World Oral Health Day",
    content:
      "Salaam Takaful's commitment to ESG principles, we actively promote awareness campaigns aimed at improving public health. As part of this initiative, Salaam Takaful supports World Oral Health Day, observed annually on March 20th, which serves as a poignant reminder of the significance of maintaining good oral hygiene practices. Recognizing that oral health is integral to overall well-being, this day emphasizes the importance of preventive measures to mitigate the risk of systemic diseases such as heart disease, diabetes, and respiratory infections. Through Salaam Takaful, we advocate for regular dental check-ups as a vital component of early detection and intervention, preventing minor oral issues from escalating into more significant problems. Contrary to common misconceptions, sugar is not the sole culprit in dental problems. Factors such as acidic foods, poor oral hygiene, and tobacco use also contribute significantly. Comprehensive oral care practices are encouraged, including brushing twice daily for two minutes, daily flossing, and rinsing with mouthwash as part of a holistic approach to oral hygiene. Moreover, the importance of a balanced diet rich in fruits, vegetables, and calcium to promote oral health is crucial, along with the cessation of smoking and tobacco use, as quitting significantly reduces the risk of gum disease, tooth decay, and oral cancer. By raising awareness and dispelling common myths surrounding oral health, Salaam Takaful empowers individuals to prioritize their oral hygiene for a brighter, healthier future. Through Salaam Health Takaful and our ongoing commitment to ESG principles, we strive to foster a culture of proactive health management and well-being within our communities.",
    excerpt:
      "Salaam Takaful's commitment to ESG principles, we actively promote awareness campaigns aimed at improving public health. As part of this initiative, Salaam Takaful supports World Oral Health Day, observed ….",
    date: "20/03/2024",
  },
  {
    Key: 2170,
    feature:
      "https://asset.salaamtakaful.com/GeneralAssets/news/SalaamApp-OnlineMotor.jpg",
    heading:
      "Salaam App Revolutionizes Takaful with Online Motor Claim Lodging",
    content:
      "In the ever-evolving landscape of insurance, Salaam Takaful Limited lives up to the title of being the first Islamic insurtech in Pakistan, consistently leveraging technology to enhance policyholders’ experience and convenience. With the upgrade of their innovative Salaam App, they have taken another giant leap forward, making takaful claims easier and more efficient than ever before. In particular, the new Online Motor Claim Lodging feature is set to revolutionize the way people interact with their Islamic insurance policies.  Filing claims have historically been a tedious and time-consuming process, often involving paperwork and lengthy phone calls. However, Salaam Takaful's new Online Motor Claim Lodging feature eliminates these hassles by allowing policyholders to submit their claims directly through the Salaam App. With just a few simple steps, customers can upload the necessary documents, answer a few questions, and submit their claims with ease.  This streamlined process not only saves time and effort for policyholders but also ensures quick resolutions and stress-free claims processing. By leveraging technology, Salaam Takaful is empowering its policyholders to take control of their takaful experience and access their benefits more efficiently than ever before.  What sets Salaam Takaful apart from other takaful companies in Pakistan is its commitment to innovation and customer satisfaction. While takaful is gaining popularity in Pakistan, Salaam Takaful is leading the way with its customer-centric approach and dedication to harnessing technology for the benefit of its policyholders.  In addition to simplifying the claims process, Salaam Takaful offers a wide range of takaful benefits, including comprehensive coverage and personalized service. From motor takaful to health takaful, Salaam Takaful provides peace of mind and financial security to its policyholders, ensuring that their needs are met with compassion and integrity  Salaam Takaful remains committed to pioneering technological solutions, solidifying its position as the premier Islamic insurtech in Pakistan. With a forward-thinking approach, Salaam Takaful will continue to introduce innovative tech-based solutions tailored to the needs of its policyholders.",
    excerpt:
      "In the ever-evolving landscape of insurance, Salaam Takaful Limited lives up to the title of being the first Islamic insurtech in Pakistan, consistently leveraging technology to enhance policyholders’ experience and ….",
    date: "19/03/2024",
  },
  {
    Key: 2169,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/Health.jpg",
    heading: "Salaam Health Takaful: Ensuring Wellness with Islamic Principles",
    content:
      "Salaam Health Takaful is a pioneering Islamic insurance solution that prioritizes comprehensive health coverage while upholding ethical standards and fostering community solidarity. Unlike traditional insurance models, Salaam Health Takaful operates on a cooperative basis, pooling resources from participants to collectively mitigate financial burdens associated with healthcare expenses.  At the heart of Salaam Health Takaful is its commitment to providing extensive coverage for various medical needs, including hospitalization, outpatient services, prescription medications, and preventive care. This inclusive approach ensures that individuals and families can access quality healthcare without compromising their religious beliefs. Additionally, Salaam Health Takaful offers tailored packages for families, catering to their diverse needs and ensuring holistic coverage.  What distinguishes Salaam Health Takaful is its adherence to transparent and ethical business practices. Operating on principles such as Wakalah and Mudarabah, Salaam Health Takaful conducts all transactions in accordance with Shariah law, instilling confidence in participants regarding the integrity of the system.  Customer satisfaction is paramount for Salaam Health Takaful, reflected in its personalized services and efficient claims processing. Participants can rely on Salaam Health Takaful to prioritize their needs and concerns, resulting in a seamless and hassle-free experience throughout their healthcare journey.  Beyond financial protection, Salaam Health Takaful invests in community welfare through educational initiatives. By raising awareness about health and financial planning, Salaam Health Takaful empowers individuals to make informed decisions, fostering a culture of health-consciousness and financial literacy within the community.  In conclusion, Salaam Health Takaful represents a trustworthy and ethical insurance solution that prioritizes the well-being of its participants. With its comprehensive benefits, transparent operations, and commitment to community welfare, Salaam Health Takaful is poised to make a positive impact on the lives of individuals and families, per Islamic principles.",
    excerpt:
      "Salaam Health Takaful is a pioneering Islamic insurance solution that prioritizes comprehensive health coverage while upholding ethical standards and fostering community solidarity. Unlike traditional …",
    date: "19/03/2024",
  },
  {
    Key: 2168,
    feature: "https://asset.salaamtakaful.com/GeneralAssets/news/Car.jpg",
    heading: "Salaam Motor Takaful: Your Ultimate Car Takaful Solution",
    content:
      "Are you searching for a motor insurance solution that aligns with your Islamic values, offers Shariah compliance, and integrates cutting-edge technology? Look no further than Salaam Motor Takaful. We understand the importance of providing comprehensive protection for your vehicle while ensuring that it adheres to Islamic principles. Salaam Motor Takaful offers a comprehensive solution for your car insurance needs, integrating Islamic values with cutting-edge technology to provide peace of mind on the road. Shariah Compliance is at the core of our motor Takaful, ensuring all transactions adhere to Islamic principles, free from interest (riba) and uncertainty (gharar), giving you confidence in the ethical nature of your coverage. Our Takaful plans provide extensive coverage, protecting your vehicle against accidents, theft, fire, and third-party liability, with customizable options to suit your specific needs and budget.    We leverage Insurtech solutions for a Fast and Efficient Claims Process, allowing you to file claims online, track their status in real time, and receive prompt settlements, minimizing disruptions to your routine. At Salaam Motor Takaful, we prioritize a customer-centric approach, ensuring that our dedicated team is committed to providing personalized assistance. We promptly address your queries and concerns to guarantee your satisfaction.    Moreover, we offer competitive pricing without compromising on coverage quality, making comprehensive protection affordable for all. Our aim is to ensure that every individual can access the takaful they need without financial strain.    Additionally, choosing Salaam Motor Takaful goes beyond personal benefits. It also contributes to the community as a portion of contributions is allocated to a mutual aid fund. This fund provides financial assistance to members in need, fostering solidarity and cooperation among policyholders.     Whether you're a seasoned driver or a new car owner, Salaam Motor Takaful is your trusted partner on the road, ensuring your journey is safeguarded every step of the way.     Experience the difference with Salaam Motor Takaful – where tradition meets technology for your peace of mind. Get in touch with us today to learn more about our comprehensive motor Takaful solutions tailored to your needs.",
    excerpt:
      "Are you searching for a motor insurance solution that aligns with your Islamic values, offers Shariah compliance, and integrates cutting-edge technology?..",
    date: "18/03/2024",
  },
];
